/* tslint:disable:max-line-length */

import { LanguageInterface } from "../LanguageInterface";

class English implements LanguageInterface {
  public iso: string = "en-US";

  private language = {
    /*
    | Language Label in Selectbox (Change language global)
    */
    "en-us": "English",
    "nl-nl": "Dutch",

    /*
    | Default
    */

    "label-archive": "Archive",
    "your-logo-here": "Your logo here",
    "label-readonly": "Read only",
    correction: "correction",
    "title-new": "New",
    id: "ID",
    "label-other": "Other",
    "label-none": "None",
    "label-name": "Name",
    "label-short-name": "Short name",
    "label-complex-name": "Complex name",
    "label-agency": "Agency",
    "title-signin": "Sign In",
    "label-signin": "Sign In",
    "button-signup": "Sign Up",
    "link-signup": "Sign Up",
    "signup/start-for-free": "Start for free",
    "signup/main-text": "New account",
    "signup/info-text": "Create a new account and start with Casadesk",
    "confirmnewpassword/main-text": "Provide a password",
    "confirmnewpassword/info-text":
      "Provide a password and start using Casadesk",
    "resetconfirmnewpassword/main-text": "Provide a password",
    "resetconfirmnewpassword/info-text": "Provide a new password and login",
    "menuitem-signout": "Sign Out",
    "label-sign-up-page-agency-name": "Agency name",
    "label-first-name": "First Nаme",
    "label-your-first-name": "Your first name",
    "label-last-name": "Last Nаme",
    "link-go-to-signin": "You already have an account?",
    "link-go-to-signin-underscore": "Go to login",
    "link-back-to-signin": "Back to Sign In",
    "button-back-to-signin": "Back to Sign In",
    "pages/singup-info/termsandconditionstext":
      "I agree with the :terms and :agreement",
    "terms-link": "terms",
    "processing-agreement-link": "data processing agreement",
    "link-forgot-password": "Forgot Password",
    "title-reset-password": "Reset Password",
    "title-reset-password-notice":
      "Click on the button below and we will send you instructions on email how to recover your password.",
    "title-send-me-instructions": "Send Me Instructions",
    "title-manual": "Manual",
    "lookup-component-prompt-notice":
      "You did not create a :entity1. Create a :entity2 now or click Cancel.",
    "label-yes": "Yes",
    "label-no": "No",
    "button-next": "Next",
    "button-newer": "Newer",
    "button-older": "Older",
    "button-previous": "Previous",
    "button-pay": "Pay",
    "button-clear": "Clear",
    "title-go-back": "Go back",
    "label-skip": "Skip",
    "label-done": "Done",
    "button-done": "Done",
    "button-confirm": "Confirm",
    "button-deposit": "Deposit",
    "title-heads-up": "Heads up!",
    "title-new-version-notice": "A new version is available. Activate it now?",
    "button-discard": "Discard",
    "title-attention": "Attention",
    "discard-changes": "Discard changes",
    "button-add": "Add",
    "label-type": "Type",
    "label-typeclass": "Type class",
    "label-status": "Status",
    "title-dashboard": "Dashboard",
    "menuitem-dashboard": "Dashboard",
    "route-dashboard": "Dashboard",
    "title-todos": "Todo's",
    "label-period": "Period",
    "label-invoice-number": "Invoice number",
    "label-bic": "BIC",
    "label-kvk": "Company registry",
    iban: "IBAN",
    website: "Website",
    "label-website": "Website (example: www.example.com)",
    "label-company-registry": "Chamber of Commerce nr.",
    "label-iban": "Bank account Iban",
    "label-аmount": "Аmount",
    "label-vat": "VAT",
    "label-vat-number": "VAT number",
    "label-excluding-vat": "Excluding VAT",
    "label-including-vat": "Including VAT",
    "label-include-payables": "Payable charges",
    "label-include-unpaid-charges": "Unpaid charges",
    "label-include-receivable": "Receivable charges",
    "label-include-snoozed-charges": "Snoozed charges",
    "label-include-snoozed-payments": "Snoozed payments",
    "label-snoozed": "Snoozed",
    "label-not-sent": "Not sent",
    "title-snooze-until": "Snooze until",
    "label-include-snoozed-statements": "Snoozed statements",
    "label-still-to-be-paid": "Still to be paid",
    "label-load-more": "Load More",
    "button-load-more": "Load More",
    "label-hide": "Hide",
    "label-hidden": "Hidden",
    "label-hide-more": "Hide More",
    "label-currency": "Currency",
    "error-text-currency": "Valuta",
    "currency-eur": "EUR",
    "currency-usd": "USD",
    "title-paid": "Paid",
    "class-name-received": "Received",
    description: "Description",
    subject: "Subject",
    date: "Date",
    status: "Status",
    content: "Content",
    "label-description": "Description",
    "textfield-no-description": "no description",
    "button-create": "Create",
    "button-creating": "Creating...",
    "button-update": "Update",
    "button-updating": "Updating...",
    "button-send": "Send",
    "button-send-pdf": "Send Invoice PDF",
    "button-create-invoice": "Close invoice",
    "button-print-pdf": "View Invoice PDF",
    "button-view": "View",
    "button-preview-pdf": "Preview PDF",
    contracts: "Contracts",
    "textfield-contract": "Contract",
    "textfield-previous-contract": "Previous contract: ",
    "title-contract": "Contract",
    "title-new-contract": "New Contract",
    "label-new-contract": "New Contract",
    "label-continue": "Continue",
    "title-new-charge": "New charge",
    "button-new-charge": "New charge",
    "button-existing-charge": "Existing",
    "label-new-payment": "New payment",
    "title-new-payment": "New payment",
    "button-new-payment": "New payment",
    "button-existing-payment": "Existing payment",
    "label-existing-payment": "Existing payment",
    "title-charge-details": "Charge details",
    "title-select-additional-charge": "Select additional charge",
    "title-charge": "Charge",
    "title-invoice": "Invoice",
    "title-charges": "Charges",
    "title-receivable-charges-unpaid-dashboard":
      "Charges - not yet fully received",
    "title-payable-charges-unpaid-dashboard": "Charges - not yet fully paid",
    "title-payments-unused-dashboard": "Payments - not yet fully processed",
    "label-charges": "Charges",
    "label-monthly": "monthly",
    "label-contract-prices": "Contract prices",
    "title-contract-prices": "Amount",
    "title-property-prices": "Charge templates",
    "subtitle-property-prices":
      "Have charges created automatically for this property",
    "subtitle-unit-prices": "Have charges created automatically for this unit",
    "button-add-price": "New price",
    "button-add-charge-template": "New charge template",
    "title-default-agency-fees": "Agency Fees",
    "hint-default-agency-fees":
      "The default values for a new agreement with a landlord",
    "title-property-default-agency-fees": "Agency fee template",
    "subtitle-property-default-agency-fees":
      "Set the default agency fee for units at this location",
    "label/no-agency-fee": "No agency fee",
    "title-unit": "Unit",
    "title-fullunit": "Unit",
    "label-unit": "Unit",
    "textfield-unit": "Unit",
    "label-contract": "Contract",
    "menuitem-units": "Units",
    "title-units-amount": ":amount units",
    "title-unit-amount": ":amount unit",
    "title-units": "Units",
    "title-property": "Property",
    "label-property": "Property",
    "title-payment": "Payment",
    "title-properties": "Properties",
    "label-contact": "Contact",
    "title-contacts": "Contacts",
    "title-contact": "Contact",
    "textfield-date": "Date",
    "utility-about": "Bill is about",
    "utility-address": "Address",
    "utility-amount": "Amount for address",
    "utility-unit": "Unit",
    "utility-share": "Share",
    "utility-unti-amount": "Amount for unit",
    "utility-contract-period": "Contract period",
    "utility-amount-for-tenant": "Amount for tenant",
    "utility-deposit": "Deposits",
    "utility-to-settle": "To pay by you",

    "label-amount": "Amount",
    "total-amount": "Selected: :amount",
    "label-total": "Total: :amount",
    "label-date": "Date",
    "title-set-password": "Set password",
    "title-please-wait": "Please wait...",
    "button-please-wait": "Please wait...",
    "button-close": "Close",
    "button-close-and-next": "Close and next",
    "button-open": "Open",
    "button-send-confirmation-mail": "Send Confirmation Mail",
    "button-send-invite-mail": "Send Invite Mail",
    "label-password": "Password",
    "title-password": "Change password",
    "label-confirm-password": "Confirm Password",
    "label-new-password": "New Password",
    "label-current-password": "Current Password",
    "button-change": "Change",
    "label-changing": "Changing...",
    "title-email": "Email",
    "label-email": "Email",
    "label-total-amount": "Total",
    "label-email-address": "Email address",
    "label-user-email": "Your email address",
    "current-label-email": "Current email",
    "general-agency-label-email": "General agency email address",
    "label-search": "Search",
    "label/searchcharge": "Search charge",
    "label/searchpayment": "Search payment",
    "button-save": "Save",
    "button-saving": "Saving...",
    "title-saving": "Saving...",
    "button-cancel": "Cancel",
    "button-continue": "Continue",
    "button-stop": "Stop",
    "menuitem-edit": "Edit",
    "menuitem-open": "Open",
    "menuitem-edit-description": "Edit description",
    "label-info": "Info",
    "label-history": "History",
    "tasks-notes-notifications-notfound":
      "No tasks, notes or notifications found.",
    "button-remove": "Remove",
    "menuitem-delete": "Delete",
    "menuitem-delete-agreement": "Delete the agreement",
    "menuitem-delete-person": "Delete the contact person",
    "menuitem-delete-contract": "Delete",
    "menuitem-delete-contract-hint": "Permanently delete the contract",
    "menuitem-create-notification": "New notification",
    "menuitem-create-notification-hint":
      "Create a new notification for this contract",
    "menuitem-delete-unit": "Delete this unit",
    "menuitem-delete-property": "Delete the address",
    "menuitem-delete-company": "Delete the company",
    "menuitem-delete-charge": "Delete charge",
    "menuitem-download-csv": "Download charges",
    "select-year-charts": "Select the year for which to download the charges",
    "select-year-charts-label": "Select the year",
    "menuitem-delete-payment": "Delete the payment",

    // savings related
    "menuitem-undo-savings-withdrawal": "Undo withdrawal",
    "hint/menuitem-undo-savings-withdrawal": "Undo this withdrawal from the savings account",
    "menuitem-undo-savings-deposit": "Undo deposit",
    "hint/menuitem-undo-savings-deposit": "Undo this deposit to the savings account",
    "menuitem-undo-paid-directly-to-owner": "Undo direct payment",
    "hint/menuitem-undo-paid-directly-to-owner": "This charge was not directly paid to the landlord.",
    "payment-details/menuitem-undo-settle-with-savings": "Undo settlement",
    "menuitem-undo-settle-charge-with-savings": "Undo settlement",
    "hint/menuitem-undo-settle-charge-with-savings": "Undo the settlement of this charge",
    "menuitem-undo-settle-with-savings": "Undo this settlement with the savings account",

    "menuitem-undo-credit-charge": "Undo credit",
    "hint/menuitem-undo-credit-charge": "Undo credit for this charge",
    "button-person": "Person",
    "label-person": "Person",
    "title-person": "Person",
    "label-contactperson": "Contact",
    "title-tenant": "Tenant",
    "title-executor": "Executor",
    "title-manager": "Caretaker",
    "label-tenant": "Tenant",
    "label-tenant-description": "Tenant (or representative)",
    "label-user": "User",
    "title-occupant": "Occupant",
    "label-occupant": "Co-tenant",
    "new-label-occupant": "Co-tenant",
    "label-occupants": "Occupants",
    "new-label-occupants": "Co-tenants",
    "label-extra-persons": "Extra persons",
    "button-new-person": "New person",
    "button-add-executor": "New contact",
    "button-add-tenant": "Add tenant",
    "textfield-no-executor-found-click-add": "No contacts found",
    "label-company": "Company",
    "button-company": "Company",
    "title-company": "Company",
    "title-owner": "Owner",
    "title-companies": "Companies",
    "label-company-name": "Company name",
    "label-owner-name": "Owner name",
    "title-new-company": "New company",
    "title-new-owner": "New owner",
    "title-server-down": "Server down",
    "menuitem-new": "New",
    "title-page-not-found": "Page Not Found",
    "title-confirmation-link-expired":
      "This email confirmation link has expired",
    "title-invite-link-expired": "This email invite link has expired",
    "title-confirmation-link-expired-footer":
      "The link you clicked to confirm your email has expired. Click on the button below to resend magic link.",
    "title-account-not-confirmed-header": "Account not confirmed",
    "account-confirmed": "Account confirmed",
    "status-confirmed": "Confirmed",
    "status-not-confirmed": "Not confirmed",
    "status-sent": "Sent",
    "statement-status/ready-for-review": "Ready to review",
    "statement-status/ready-to-send": "Ready to send",
    "title-account-not-confirmed-footer":
      "Your account was not confirmed. Click the link in the email sent to :email or click the button below to resend.",
    "title-no-charges-to-list":
      "No charges yet. Click the button 'Add Charge' and start adding charges to your Casadesk system.",
    "title-no-invoices-to-list": "No invoices found",
    "pages/contract-section/price-info/totalmonthlyamount":
      ":amount total monthly",
    "pages/contract-section/price-info/pricenotfound":
      "No prices yet. Click the button 'New Price' and start adding prices to your Casadesk system.",
    "pages/property-section/price-info/pricenotfound":
      "No charge templates found.",
    "title-no-charges-to-list-update":
      "No charges yet. Click the button 'Pay Charge' and start adding charges to your Casadesk system.",
    "title-no-charges-to-be-removed": "No charges to be removed",
    "title-no-default-agency-fees-to-list":
      "No agency fees yet! Click the button 'Add Agency Fee' and start adding agency fees to your Casadesk system.",
    "title-property-no-units-to-list":
      "No units yet. Click the button 'Add Unit' and start adding units to your Casadesk system.",
    "title-no-units-to-list": "No units found.",
    "textfield-charge-was-deleted-you-can-find-payments":
      "The charge is deleted.",
    "title-no-payments-to-list":
      "No payments yet. Click the button 'Add Payment' and start adding payments to your Casadesk system.",
    "title-bank-account": "Bank Account",
    "label-bank-account": "Bank account",
    "label-bank-account-id": "Bank Account IBAN",
    "agency-profile-label-bank-account":
      "Bank account used for property management",
    "title-dropzone-upload-notice": "Drag & Drop files to upload",
    "error-wrong-total-amount-utilityBills":
      "Total amount should be higher than 0 and lower then 100.000",
    "label-expiration-date-not-set": "Expiration date not set",
    "title-select-charges-to-pay": "Select charges to pay",
    "textfield-no-unpaid-charges-for-unit":
      "This unit doesn't have unpaid charges",
    "title-no-unpaid-charges-for-unit": "This unit doesn't have unpaid charges",
    "title-only-inactive-units-can-be-deleted":
      "Only inactive units can be deleted. Do you want to make unit inactive and remove?",
    "symbol-infinity": "∞",
    "title-warning": "Warning",
    "menuitem-activate": "Set to available again",
    "button-activate": "Activate",
    "menuitem-deactivate": "Set to temporarily not available",
    "menuitem-deactivate-hint":
      "Because of renovation, or other reason, the unit is temporarily not available",
    "menuitem-activate-hint": "The unit is available again",
    "label-deactivate": "Temporarily not available",
    "menuitem-archive": "Archive",
    "menuitem-archive-hint":
      "Similar to deleting but when archived you’ll be able to find it again",
    "menuitem-unarchive-hint":
      "Change the archive state and make the unit visible again",
    "label-unarchive": "Unarchive",
    "button-dont-save": "Don't save",
    "title-users": "Users",
    "title-property-new-price": "New property price",
    "subtitle-charge-new-price": "Owners Association contribution",
    "description-charge-new-price":
      "A new charge is created every selected period from the first day up to and including the last day",
    "title-property-price": "Property price",
    "button-show-more": "Show more",
    "button-show-less": "Show less",
    "button-ok": "OK",
    "label-set-time-notification": "Set a time/notification",
    "menuitem-notifications": "Notifications",
    "notifications-not-found": "No notifications found",
    "label-from-person-or-company": "From person or company",
    "button-paid-to": "Paid to",
    "title-paid-to": "Paid to",
    "label-paid-to": "Paid to",
    "label-received-from": "Received from",
    "title-received-from": "Received from",
    "menuitem-settle": "Settle",
    "button-settle": "Settle",
    "menuitem-unsettle": "Unsettle",
    "button-unsettle": "Unsettle",
    "button-unlink": "Unlink",
    "title-settle-charge": "Settle charge",
    "title-charges-list": "Charges list",
    "button-keep": "Keep",
    "button-no-charge": "No charge",
    "title-delete-contract": "Delete contract",
    "button-add-charge": "Add charge",
    "button-add-payment": "Add payment",
    "button-add-contract": "Add contract",
    "button-add-unit": "Add unit",
    "button-add-property": "Add property",
    "button-new-property": "Add address",
    "button-new-company": "Add company",
    "button-add-note": "Add note",
    "button-add-attachment": "Add attachment",
    "button-add-logo": "Upload logo",
    "button-add-agency-fee": "Add agency fee",
    "title-add-agency-fee": "Add agency fee",
    "button-add-user": "Add user",
    "title-system": "System",
    "label-all-charges": "All charges",
    "label-charge-for-contact": "Charge for contact",
    "label-charge-for-company": "Charge for company",
    "label-charge-from-contact": "Charge from contact",
    "label-charge-from-company": "Charge from company",
    "label-counterparty-iban": "Bank account counterparty",
    "label-counterparty": "Counterparty",
    "title-agency-fee-profile": "agency profile",
    "title-agency-fee-owner": "owner",
    "title-agency-fee-property": "property",
    "title-agency": "Agency",
    "label-click-set-the-end-date": "Click here to set the end date",
    "title-if-you-want-to-renew-the-contract":
      "Do not set the end date for the contract if you want to renew the contract. If you renew a contract you can change the rent, occupant,..etc. Click Renew if you want to renew the contract.",
    "menuitem-pay": "Process payment",
    "menuitem-activities": "Activities",
    "menuitem-quick-options": "Quick options",
    "menuitem-consider-paidcharge":
      "Consider this charge paid (payment details unknown)",
    "menuitem-settlepaymentwithsavings": "Settle with savings",
    "hint/menuitem-settlepaymentwithsavings":
      "Settle the - remaining - amount with the savings account of :agencyName or an owner",
    "menuitem-settlechargewithsavings": "Settle with savings",
    "hint/menuitem-settlechargewithsavings":
      "Settle this charge with the savings account",
    "menuitem-create-credit-charge": "Create a credit charge",
    "menuitem-set-charge-paid-to-owner": "Paid directly to the owner",
    "hint/menuitem-set-charge-paid-to-owner":
      "When the payment does not arrive in the agency’s bank account but was paid directly to the owner",
    "page/chargeupdate-preprocess/paidtoowner-info":
      "Payment for this charge was not received on a bank account managed with Casadesk. The payment is registered as done directly to the owner.",
    "menuitem-create-credit-charge-for-receivable": "Credit this charge",
    "button-create-credit-charge": "Create a credit invoice",
    "hint/menuitem-create-credit-charge-for-receivable":
      "Create or process a credit charge for a full or partial discount on this charge",
    "menuitem-create-credit-charge-for-payable": "Process a credit invoice",
    "hint/menuitem-create-credit-charge-for-payable":
      "To apply a full or partial discount on this charge",
    "page/chargeupdate-preprocess/credit-title": "Create a credit charge",
    "page/chargeupdate-preprocess/credit-info":
      "A credit charge is created to reverse this charge, or to apply a discount on this charge.",
    "page/chargeupdate-preprocess/credit-defaultdescription": "Credit charge",
    "page/chargeupdate-preprocess/credit": "Credit",
    "hint/menuitem-undo-settle-with-savings":
      "Undo the earlier settlement with the savings account",
    "payment-details/hint/menuitem-undo-settle-with-savings":
      "Undo the settlement of this payment",
    "menuitem-consider-payment-used": "Consider this payment processed",
    "menuitem-consider-payment-fully-used": "Consider payment fully used",
    "menuitem-consider-payment-agencyfee": "Process as payment for agency fees",
    "menuitem-withdraw-from-agency-savings": "Withdraw from agency savings",
    "menuitem-consider-payment-income-for-agency":
      "Deposit into savings of :agencyname",
    "menuitem-agency-costs": "Process as costs for :agencyName",
    "hint/menuitem-agency-costs":
      "For example banking fees or other costs that should not be paid by an owner",
    "menuitem-refund-payment": "Refund this payment",
    "hint/menuitem-refund-payment":
      "The payment was incorrect and must be - partially - returned",
    "title-click-continue-to-settle":
      "Click 'Continue' to settle charge :chargeToSettle with charge :chargeSelected",
    "title-charge-delete-from-charge-page-content-dialog":
      "You're about to remove the charge. Are you sure?",
    "title-charge-locked-owner-tenant":
      "Cannot delete. Part of a locked statement.",
    "title-charge-not-allowed-to-delete-tenant-charge":
      "Not allowed to delete. Part of a settled bill. Remove related landlord charge.",
    "title-charge-delete-owner-tenant-from-charge-page":
      "This charge is part of a settled bill. All related charges are removed.",
    "title-invoice-delete-from-charge-page-content-dialog":
      "You're about to remove the invoice. Are you sure?",
    "title-payment-unsettle-from-charge-page-content-dialog":
      "You're about to unsettle the payment. Are you sure?",
    "title-charge-was-created-to-settle-payments":
      "A charge was created to settle payment :paymentToSettle with payment :paymentSelected",
    "title-no-payments-to-list-without-button": "No payments yet.",
    "title-payment-delete-from-payment-page-content-dialog":
      "You're about to remove the payment. Are you sure",
    "dialog-info/removetransaction":
      "Only delete this transaction if the payment for this transaction is already present (to prevent a duplicate). Do not delete transactions that were actually done in the bank account. Otherwise balance calculations for this bank account might produce incorrect results.",
    "title-charge-will-become-unpaid":
      "The charge will become unpaid. And you can use the payment to pay another charge.",
    "title-payment-unlink-from-payment-page-content-dialog":
      "You're about to unlink the payment. Are you sure?",
    "title-date": "Date",
    "title-owners-reports": "Owners reports",
    "title-pay-charge": "Pay charge",
    "title-monthly": "monthly",
    "label-id": "ID",
    and: "and",
    "label-percentagefee": "Percentage fee",
    "title-welcome": "Welcome",
    "new-invoice": "New charge",
    "admin-fee": "Default administrative fee for settlement of services ",
    "label-more": "More...",
    "title-more": "More",
    "title-less": "Less",
    "title-landlord": "Owner",
    "title-start": "Start",
    "page/singup-dialog/confirmpassword": "We sent an email to :email.",
    "page/singup-dialog/confirmpassword-2":
      "Click the link in the email and choose a password.",
    "label-direct": "Direct",
    "title-address": "Address",
    "title-addresses": "Addresses",
    "change-address": "Change address",
    "link-counterparty": "Link counterparty",
    "unlink-counterparty": "Unlink counterparty",
    "label-landlord": "Landlord",
    "title-agreement": "Agreement",
    "event-charge-settled": "Charge settled with another charge",
    "event-charge-unsettled": "Settlement with another charge undone",
    "event-charge-settled-savings": "Charge settled with savings",
    "event-charge-unsettled-savings": "Settlement with savings undone",
    "event-payment-refunded": "Payment refunded",
    "event-payment-unrefunded": "Refund undone",
    "event-charge-credited": "Charge credited",
    "event-charge-uncredited": "Credit undone",
    "event-charge-linked": "Charge linked",
    "event-charge-unlinked": "Charge unlinked",
    "title-credit-invoice": "Credit invoice",
    "event-ponto-synchronization": "Ponto synchronization",
    "settlement-with-savings-description": "Settlement with savings",
    "title-website-link": "Website link",
    "hint/title-website-link":
      "Publish this link on the website and allow tenants to login to the tenant portal",

    /*
    |  Bank Transactions
    */

    "mt940-is-uploading": "The MT940 file is uploading. Please wait",
    "mt-940-is-processing": "The MT940 file is processing. Please wait",
    "you-have-verified-all-payments-from-file":
      "You have verified all payments that were created with the file you upload",
    "status-verified": "Verified",
    "status-not-verified": "To Verify",
    verified: "verified",
    "not-verified": "not verified",
    transaction: "Transaction",
    "to-verify": "To verify",
    "page/banktransactionfile-section/listoftransaction-info/transactionnotfound":
      "Well done! All transactions have been verified.",
    removed: "Removed",
    "wrong-charge-dialog-text": "The charges are being unlinked.",
    "mt-940-0-payments-are-created": "0 payments are created",
    "mt-940-does-not-have-payments":
      "This file doesn’t have payments. Choose another one",
    "mt-940-not-all-payments-created":
      "The file is processed and :transactionCount bank transactions were found. For these :transactionCount bank transactions, :paymentsCreatedCount payments are created. For :paymentsNotCreatedCount bank transaction payments were created before.",
    "mt-940-payments-amount": ":amount payments",
    "mt-940-processing-finished-1":
      "The file with bank transactions was processed with the following results:",
    "mt-940-processing-finished-2":
      "Click Сontinue and start the verification of the created payments.",
    "mt-940-processing-finished-2-close":
      "Click Close and start the verification of the created payments.",
    "mt-940-processing-finished-total-count-payments":
      ":count bank transactions found",
    "mt-940-processing-finished-created-count-payments":
      ":count payments created",
    "mt-940-processing-finished-existing-count-payments":
      "for :count bank transactions a payment already exist (these bank transactions were uploaded before)",
    "mt-940-processing-finished-not-recognized-count-payments":
      "for :count bank transactions the format was not recognized (please send a message to Casadesk with a request to investigate this issue)",
    "mt-940-uploading-is-crashed":
      "The server does not respond, something went wrong. Please try and upload the file again. Inform Casadesk support if the problem persists.",
    "section/transactioncontrolbuttons-info/charges-were-found-1":
      "This payment was automatically linked to a charge. Switch to Verified if the charge is correct.",
    "section/transactioncontrolbuttons-info/charges-were-found-2":
      "Is the charge not correct for this payment? Then unlink the charge and select the correct charge.",
    "section/transactioncontrolbuttons-info/charges-not-found-1":
      "No charge was found for this payment. Select an existing charge, or create a new charge, to link with this payment. Then switch to Verified.",
    "section/transactioncontrolbuttons-info/charges-not-found-2":
      "Charge unknown at this time? Then select the option Charge unknown and switch to Verified.",
    "section/transactioncontrolbuttons-info/transactionverified":
      "This bank transaction was verified. Click Next.",
    "dialog/banktransactionfile-info/chargeunlink":
      "The charge are being unlinked.",
    "section/transactionconpaymentdetailsbuttons-info/transactionverified":
      "This bank transaction was verified.",

    /*
    |  Breadcrumbs
    */

    /* list pages */
    "breadcrumbs-label-properties": "Addresses",
    "breadcrumbs-label-units": "Units",
    "breadcrumbs-label-companies": "Companies",
    "breadcrumbs-label-contacts": "Contacts",
    "breadcrumbs-label-owner-statements": "Owner statements",
    "breadcrumbs-label-mails": "Mails",

    /* object page */
    "breadcrumbs-label-user": "User",
    "breadcrumbs-label-notification": "Notification",
    "breadcrumbs-label-transaction-file": "Transaction file",
    "breadcrumbs-label-property": "Address",
    "breadcrumbs-label-unit": "Unit",
    "breadcrumbs-label-contract": "Contract",
    "breadcrumbs-label-tenant": "Tenant",
    "breadcrumbs-label-executor": "Executor",
    "breadcrumbs-label-manager": "Caretaker",
    "breadcrumbs-label-owner": "Owner",
    "breadcrumbs-label-company": "Company",
    "breadcrumbs-label-charge": "Charge",
    "breadcrumbs-label-payment": "Payment",
    "breadcrumbs-label-bank-transaction": "Bank Transaction",
    "breadcrumbs-label-agency-statement": "Agency statement",
    "breadcrumbs-label-owner-statement": "Settlement period",
    "breadcrumbs-label-task": "Task",
    "breadcrumbs-label-note": "Note",
    "breadcrumbs-label-invoice": "Invoice",
    "breadcrumbs-label-activity-template": "Activity template",
    "breadcrumbs-label-activity": "Activity",
    "breadcrumbs-label-agency": "Agency",
    "breadcrumbs-label-conversation": "Conversation",
    "breadcrumbs-label-agreement": "Agreement",
    "breadcrumbs-label-new-bill-settlement": "Settle final bill",

    /* new pages */
    "breadcrumbs-label-new-property": "New address",
    "breadcrumbs-label-new-unit": "New unit",
    "breadcrumbs-label-new-contract": "New Contract",
    "breadcrumbs-label-new-company": "New company",
    "breadcrumbs-label-new-person": "New person",
    "breadcrumbs-label-new-tenant": "New tenant",
    "breadcrumbs-label-new-executor": "New contact",
    "breadcrumbs-label-new-manager": "New caretaker",
    "breadcrumbs-label-new-owner": "New owner",
    "breadcrumbs-label-new-user": "New user",
    "breadcrumbs-label-new-charge": "New charge",
    "breadcrumbs-label-new-payment": "New payment",
    "breadcrumbs-label-new-task": "New task",
    "breadcrumbs-label-new-note": "New note",
    "breadcrumbs-label-new-invoice": "New invoice",
    "breadcrumbs-label-new-activity-template": "New activity template",
    "breadcrumbs-label-new-activity": "New activity",

    /* menu pages */
    "breadcrumbs-label-finance": "Finance",
    "breadcrumbs-label-finance-payments": "Payments",
    "breadcrumbs-label-finance-charges": "Charges",
    "breadcrumbs-label-finance-banktransaction": "Bank",
    "breadcrumbs-label-finance-statements": "Owner statements",
    "breadcrumbs-label-finance-agencybalance": "Agency Balance",
    "breadcrumbs-label-finance-savings": "Savings accounts",
    "breadcrumbs-label-finance-reports": "Reports",
    "breadcrumbs-label-finance-invoices": "Invoices",
    "breadcrumbs-label-contact-persons": "Persons",
    "breadcrumbs-label-contact-companies": "Companies",
    "breadcrumbs-label-reports-ownerstatements": "Owner",
    "breadcrumbs-label-reports-agencystatement": "Agency statements",
    "breadcrumbs-label-reports-booklist": "Journal",
    "breadcrumbs-label-reports-paylist": "Payables",
    "breadcrumbs-label-reports-overview": "Receivables",
    "breadcrumbs-label-reports-balance": "Balance",
    "breadcrumbs-label-dashboard": "Dashboard",
    "breadcrumbs-label-dashboard-overview": "Start",
    "breadcrumbs-label-dashboard-tasks": "Tasks",
    "breadcrumbs-label-dashboard-activities": "Activities",
    "breadcrumbs-label-dashboard-statements": "Owner statements",
    "breadcrumbs-label-dashboard-contracts": "Contracts",
    "breadcrumbs-label-dashboard-notifications": "Notifications",
    "breadcrumbs-label-dashboard-receivables": "To receive",
    "breadcrumbs-label-dashboard-payables": "To pay",
    "breadcrumbs-label-dashboard-unused": "Unused",
    "breadcrumbs-label-dashboard-notes": "Notes",
    "breadcrumbs-label-dashboard-messages": "Messages",

    /* other */
    "breadcrumbs-label-settings": "Settings",
    "breadcrumbs-label-unit-charges": "Unit charges",
    "breadcrumbs-label-renew-contract": "Renew contract",
    "breadcrumbs-label-charge-settle": "Charge settle",
    "breadcrumbs-label-payment-settle": "Payment settle",
    "breadcrumbs-label-pay-charge": "Pay charge",
    "breadcrumbs-label-pay-invoice": "Pay invoice",
    "breadcrumbs-label-use-payment": "Use payment",
    "breadcrumbs-label-default-unit-prices": "Default unit prices",
    "breadcrumbs-label-new": "New",
    "breadcrumbs-label-confirm-task": "Confirm tasks",
    "breadcrumbs-label-send-email": "Send email",

    /* dashboard subtitle*/
    "dashboard-charges/subtitle": "Link with a payment, or snooze",
    "dashboard-payments/subtitle": "Link with a charge, or snooze",
    "dashboard-statements/subtitle": "Send now, or snooze",
    "dashboard-contracts/subtitle":
      "These units do not have a signed contract, or the contract is expiring",

    /*
    |  Charge
    */
    "charge-is-locked":
      "This charge is locked because it is linked to financial statement",
    "charge-is-fully-paid": "Charge is already fully paid",
    "you-can-not-create-payment-charge-is-fully-paid":
      "You cannot create another payment for this charge. This charge is already fully paid. Remove a payment from this charge or go to a charge not already fully paid and try again.",
    "please-choose-an-existing-charge-and-click-create":
      "Please choose an existing charge and click 'Create' button to finish transaction",
    "please-choose-an-existing-charge-and-click-continue-to-finish":
      "Please choose an existing charge and click 'Continue' button to finish transaction",
    "please-choose-an-existing-charge-and-click-continue":
      "Please choose an existing charge and click 'Continue' button",
    "page/chargeupdate-link/sendreminder": "Send reminder",
    "page/chargeupdate-link/sendreminder-hint":
      "Send a reminder when the charge was not yet - fully - paid",

    // Charge Create

    "for-period": "Statement period",
    "charge-for-period": "Charge for period",
    "first-date-for-period": "First date for period",
    "button-create-extra-charge": "Use for additional charge",
    day: "Day",
    month: "Month",
    year: "Year",
    "title-charge-type": "Charge type",
    "charge-type-name": "Label",
    "charge-class-id-type": "Type",

    // Charge Settle

    "amount-paid": "Amount paid",
    "due-date-payment": "Due date payment",
    "no-end-date": "no end date",
    "click-continue-to-settle-charge":
      "Click Continue to settle :chargeToSettle with :chargeSelected",
    "payment-was-created-to-settle-charges":
      "A payment was created to settle :chargeToSettle with :chargeSelected",
    "please-select-charge-from-list": "Please select charge from list",

    // Charge Template

    "label-repeat-period": "Repeat Period",
    "repeat-period-once": "Once",
    "repeat-period-weekly": "Weekly",
    "repeat-period-monthly": "Monthly",
    "repeat-period-yearly": "Yearly",
    "due-date-for-first-payment": "Due date for first payment",
    "label-payment-offset": "Payment offset",
    "due-date-offset": "Due date offset",
    "payment-offset-first-day-of-period": "at first day",
    "payment-offset-minus-3-day": "-3 day",
    "payment-offset-minus-2-day": "-2 day",
    "payment-offset-minus-1-day": "-1 day",
    "payment-offset-plus-1-day": "1 day",
    "payment-offset-plus-2-day": "2 day",
    "payment-offset-plus-3-day": "3 day",
    "payment-offset-week-after": "1 week",
    "payment-offset-week-before": "-1 week",
    "first-date-of-payment": "First date of payment",
    "end-date-of-payment": "End date of payment",
    "default-unit-prices": "Default unit prices (for new contracts)",
    "default-unit-prices-short": "Default unit prices",
    "create-default-price-for": "Create default price for",
    "charge-template-type-rent": "Rent",
    "charge-template-type-parking": "Parking",
    "charge-template-type-deposit": "Deposit",
    "charge-template-type-administration-fee": "Administration Fee",
    "charge-template-type-agency-fee": "Agency Fee",
    "charge-template-type-late-fee": "Late Fee",
    "charge-template-type-deposit-refund": "Deposit Refund",
    "charge-template-type-loss": "Loss",
    "charge-template-type-utilities": "Utilities",
    "charge-template-type-water": "Water",
    "charge-template-type-gas": "Gas",
    "charge-template-type-electricity": "Electricity",
    "charge-template-type-taxes": "Taxes",
    "charge-template-type-banking-costs": "Banking Costs",
    "charge-template-type-other-receivable": "Other Receivable",
    "charge-template-type-other-payable": "Other Payable",
    "charge-template-type-payout": "Payout",
    "charge-template-type-surplus": "Surplus",

    /*
    |  Payment
    */

    "status-used": "Used",
    "status-unused": "Unused",
    "status-partially-used": "Partially Used",
    unused: "Unused",
    "pay-charge": "Pay charge",
    payment: "Payment",
    payments: "Payments",
    "title-payments": "Payments",
    "title/deposits-and-withdrawals": "Deposits and withdrawals",
    "payment-not-found": "Payment is not found",
    "payment-is-fully-used": "Payment is already fully used",
    "payment-is-removed": "Payment is removed",
    "balance-for-contract": "Balance for contract",
    "balance-for-property": "Balance for address",
    "balance-for-unit": "Balance for unit",
    "balance-for-activity": "Balance for activity",
    "balance-for-company": "Balance for company",
    "agency-balance": "Agency Balance",
    "profit-loss-balance": "Profit and loss balance",
    "owner-statement-for": "Statement for",
    "download-owner-statement": "Download owner statement",
    "download-agency-statement": "Download agency statement",
    to: "To",
    from: "From",
    with: "With",
    "from-lowercase": "from",
    "to-lowercase": "to",
    "add-a-message": "Add a message",
    summary: "Summary",
    "details-for": "Details for income and expenses",
    "owner-savings-for": "Savings account", 
    "payment-type-cash-description": "Charge is paid with a cash",
    "payment-type-bank-description": "Charge is paid with a bank transaction",
    "payment-type-cheque-description": "Charge is paid with a cheque",
    "payment-type-from-deposit-description":
      "Reduces a deposit amount for a payment amount",
    "payment-creation-type-manual": "Manual",
    "payment-creation-type-transaction-file": "Transaction File",
    "payment-creation-type-pay-until": "Pay Until Feature",
    reference: "Reference",
    "ledger-account": "Ledger Account",
    "bank-transaction": "Bank Transaction",
    verify: "Verify",
    "payment-successfully-processed": "Payment successfully processed",
    "create-an-extra-payment": "Create extra payment",
    "you-are-going-to-pay-create-extra-payment":
      "You are about to use a payment of :paymentAmount to pay a charge of :chargeAmount. Another payment of :anotherPayment is necessary for the charge.",
    "fill-info-about-new-payment":
      "Fill info about new payment below to pay charge above",
    "select-one-payment-to-pay-charges":
      "Select one of the payments below to pay the charges(-s) above",
    "click-finish-to-pay":
      "Click finish to pay :chargesSum with the payment of :paymentAmount.",
    "can-not-update-settle-payment": "Can not update settle payment",
    "can-not-update-settle-charge": "Can not update settle charge",
    "payment-created": "Payment created",
    "you-paid-the-last-charge-of-contract":
      "You paid the last charge of the contract. The balance will disappear from Unit details. You can find balance in finance tab of Contract",
    "payments-might-have-been-unlinked":
      "Payments might have been unlinked from deleted charges. Such payments still exist and you may use them to pay other charges.",
    "no-charges-found": "No charges found",
    "button-click-create-extra-payment":
      "Click 'Create extra payment' to create an extra payment for the charge.",
    "button-click-skip-extra-payment":
      "Click 'Skip' if you want to settle the charge later.",
    "charge-created": "Charge created",
    "do-you-want-to-create-extra-charge":
      "You are about to use a payment of :paymentAmount to pay a charge of :chargeAmount. That leaves an extra amount available of :additionalChargeAmount.",
    "do-you-want-to-create-extra-charge-2": `Click button "Create charge" to create an extra charge for :additionalChargeAmount. Or click "Skip" to do it later.`,
    "title-use-for-additional-charge": `Click "Use for additional charge" to use the extra amount available for another charge.`,
    "title-use-for-additional-charge-2": `Click "Skip" if you want to use the extra amount available later.`,
    "create-an-extra-charge": "Use for additional charge",
    "using-agency-fee": "The agency fee settings inherited from the",
    "payment-and-charge-should-have-same-classes":
      "To link a payable charge with a received payment, or a receivable charge with a paid payment, is not possible.",
    "button-create-extra-payment": "Create extra payment",
    "button-settle-the-difference": "Settle the difference",
    "payment-is-locked":
      "This payment is locked because it is linked to financial statement",
    "include-paid-charges": "Include paid charges",
    "please-link-unused-payments": "Please link unused payments or delete them",
    "click-continue-to-settle-payment":
      "Click 'Continue' to settle payment :paymentToSettle with payment :paymentSelected.",
    "charges-were-settled":
      "Charge :chargeToSettle was successfully settled with charge :chargeSelected",
    "click-to-replace-iban":
      "Klik Wijzigen om :oldIban te vervangen door :newIban voor :person",
    "payment-from": "Payment from",
    "please-choose-an-existing-payment":
      "Please choose an existing payment and click 'Create' button to finish transaction",
    "title-remove-savings-payment-warning":
      "This charge or payment cannot be removed. It was created for a savings deposit or withdrawal. Go to the savings and remove the deposit or withdrawal there.",
    cannot_use_option_modified_true:
      "Cannot use the options, please save data and try again",

    // Payment Link

    "title-additional-charge-for-payment": "Additional charge for payment",
    "title-use-payment": "Use payment",

    // Payment Create
    "you-are-about-to-stop":
      " You are about to stop the verifying of the payment. You can continue later for the file you uploaded.",
    "pay-charges": "Pay charge(s)",
    "which-starts-on-day": "which starts on day:",
    "charge-for": "Charge for:",
    "charge-from": "Charge from:",
    charge_already_is_fully_paid: "Charge already is fully paid!",
    contract_is_not_signed_yet: "Contract is not signed yet",

    // Payment Settle

    "title-settle-payment": "Settle Payment",
    "title-settle-payment-warning": "You can not settle fully used payment.",

    /*
    |  Finance
    */

    "label-finance": "Finance",
    "title-finance": "Finance",
    "upload-mt940-file": "Upload bank transactions",
    link: "Link",
    linking: "Linking...",
    "menuitem-use": "Use",
    linked: "Linked",
    "menuitem-unlink": "Unlink",
    unlinked: "Unlinked",
    unlinking: "Unlinking...",
    uploading: "Uploading...",
    processing: "Processing...",
    "processing-file": "Processing MT940 file",
    "processing-notice": "Processing transactions. Hold tight.",
    processed: "Processed",
    "processing-x-of-y": "Processing :x of :y",
    "linked-payments-so-far":
      "Automatically linked :linked payments to a charge.",
    "transaction-files": "Transaction files",
    "bank-transactions": "Bank transactions",
    "title-bank": "Bank",
    "bank-transaction-upload-notice": "Uploading bank transactions...",
    success: "Success",
    error: "Error",
    "create-charge": "Create charge",
    "create-payment": "Create payment",
    "payments-processed": ":x payments processed",
    "unlink-succeeded": "Unlink succeeded",
    "charge-payment-unlinked":
      "The charge and payment were unlinked. Find the unlinked payment in the Finance section (see menu) and use it to pay another charge.",
    overdue: "Overdue",
    "change-section/charge-info/relatedtoobject-object":
      "Change charge related object",
    "bank-accounts": "Bank accounts",
    "delete-bank-account": "Delete bank account",
    "you-are-about-to-delete-bank-account":
      "You are about to delete bank account :name :number. Are you sure you want to delete? The bank account will be deleted permanently.",
    "add-bank-account": "Add bank account",
    "bank-account-number": "Bank account number",
    default: "Default",
    "this-payment-is-fully-used-you-can-not-link":
      "This payment is already fully used. You can not link it with charges",
    "use-this-charge-to-settle": "Use this charge to settle",
    "use-this-payment-to-settle": "Use this payment to settle",
    "select-charge-to-settle-with": "Select charge to settle with",
    "select-payment-to-settle-with": "Select payment to settle with",
    "fill-out-the-payment-details": "Fill out the payment details",
    "no-charges-found-select-other-object":
      "No charges found. Select Contract, Company, Unit or Property",
    "pay-with-payment": "Use payment",
    "use-this-payment-to-pay": "Use this payment to pay",
    "no-transactions-to-list":
      "You don't have any bank transactions yet. Click button 'Upload transactions' and select the MT-940 file with transactions provided by your bank.",
    "transactions-list-notice":
      "Click the button 'Upload transactions' and upload the MT-940 file that is provided by your bank.",
    "bank-accounts-subtitle": "The bank accounts to receive the rent on",

    /*
    |  Property
    */

    "property-address": "Select address",
    "dropdown-searchforddress-label": "Select address",
    "no-manager-found-click-add":
      "No caretaker found. Click 'New caretaker' and create a new one",
    "property-page-property-update-units-related-to-property":
      "Units for Property",
    "no-properties-to-list-for-property":
      "No properties yet. Click the button 'Add Property' and start adding properties to your Casadesk system.",

    /*
    |  Person
    */

    "personcreate-newperson-title": "New person",
    persons: "Persons",
    "title-persons": "Persons",
    "person-pick": "Pick a person",
    "managercreate-newmanager-title": "New caretaker",
    "button-add-person": "Add person",
    "contract-create-button-add-person-to-contract":
      "Add a person to the contract",
    "contract-update-button-add-person-to-contract":
      "Add a person to the contract",
    "contract-renew-button-add-person-to-contract":
      "Add a person to the contract",
    "no-person-found-click-add":
      "No person found. Click 'Add person' and create a new one",
    "new-tenant": "New Tenant",
    "page/companyupdate-section/person-info/nopersonsfound":
      "No persons yet. Click the button 'New Person' and start adding contacts to your Casadesk system.",
    "page/persons-info/nopersonsfound":
      "No persons yet. Click the button 'New Person' and start adding contacts to your Casadesk system.",
    "menuitem-send-mobile-app-link": "Send mobile app link",
    "page/personupdate-preprocess/sendlink-info":
      "Send an email to the owner with a link to access the mobile app for owners. Continue?",
    "option-new-person": "New person",
    "option-existing-person": "Existing person",

    /*
    |  Unit
    */

    "create-unit": "Create unit",
    "tenant-contact-info": "Tenant contact info",
    "unit-number": "Unit Number",
    "unit-type": "Unit type",
    "unit-type-room": "Room",
    "unit-type-studio": "Studio",
    "unit-type-apartment": "Apartment",
    "unit-type-house": "House",
    "unit-type-house-boat": "House boat",
    "unit-type-commercial-space": "Commercial space",
    "unit-type-garage": "Garage",
    "unit-type-villa": "Villa",
    "unit-type-senior-accomodation": "Senior accommodation",
    "unit-type-live-in-guardian": "Live in guardian",
    "unit-type-bungalow": "Bungalow",
    "unit-type-live-workspace": "Live workspace",
    "unit-type-no-preference": "No preference",
    "unit-type-complex": "Complex",
    "new-property": "New property",
    "new-address": "New address",
    "old-address": "Old address",
    "new-unit": "New unit",
    "square-meters": "Square meters",
    rooms: "Rooms",
    "separate-bedrooms": "Separate bedrooms",
    bathrooms: "Bathrooms",
    "publication-title": "Publication title",
    "no-unit-found-click-add":
      "No unit found. Click 'Add unit' and create a new one",
    "add-new-default-charge-template": "New charge",
    "no-default-charges-to-list":
      "No charges yet. Click the button 'Add Charge' and start adding charges to your Casadesk system.",
    "showing-count-x-of-y-units": "Showing :x of :y units",
    "you-can-not-make-changes-when-unit-is-not-active":
      "You can not make changes when unit is not active",
    "unit-is-inactive": "Unit is inactive",

    /*
    |  Contract
    */

    end: "End",
    "menuitem-end": "End",
    "menuitem-clear-end-date": "Remove the end date",
    "menuitem-renew": "Renew",
    "button-renew": "Renew",
    "launchpanel/option-renew": "Renew this contract",
    "launchpanel/option-adjust": "Adjust rent prices",
    "launchpanel/send-adjust": "Send rent adjustment details",
    "launchpanel/contract-option/createchargetemplate": "Add a contract amount",
    "launchpanel/contract-option/createchargetemplate-hint":
      "Add an amount to be paid by the tenant to the contract",
    sign: "Sign",
    proforma: "Proforma",
    "create-contract": "Create contract",
    "end-contract": "End contract",
    "end-agency-fee": "End agency fee",
    "end-charge-template": "End charge template",
    "renew-contract": "Renew contract",
    "update-date": "Update date",
    "charges-will-be-created-to-this-point":
      "You are about to sign a contract. This can not be undone. Charges for this contract will be created up to this point of time",
    "sign-contract-first-charge-will-be-created-on-date":
      "You sign a contract. The first charge will be created on a :firstDate",
    "charges-which-were-removed": "Charges which were removed",
    "dialog/postprocess-removecharges-info1":
      "At this time the list of charges is updated. This can take a few minutes.",
    "you-are-about-to-set-end-date":
      "Set the date for the last day of the contract. After the end date you'll settle the financial account (return deposit etc.), and close the contract.",
    "you-are-about-to-continue-contract":
      "You are about to continue the contract. Please select a new expiration date",
    "if-you-want-change-contract-click-renew":
      "If you instead want to make changes to the contract (tenant, occupant, rent amount,..) click renew.",
    "set-new-date-or-renew":
      "You are about to create a new contract to replace the current contract. As this is a new contract you can adjust all necessary details. When ready save the new contract. The old contract remains available for reference purposes.",
    "contract-sign-warning":
      "The status of the contract will be changed to Signed. This cannot be undone.",
    "contract-sign-warning-1":
      "The rent charges are created automatically starting from :firstDate.",
    "contract-sign-warning-2":
      "The financial start date in Casadesk for :agencyName is :financialStartDate. No charges are created for the period before this date.",
    "contract-sign-warning-3":
      "This rule prevents charges to be created for past times.",
    "agreement-sign-warning":
      "The status of the agreement will be changed to Signed. This cannot be undone.",
    "agreement-sign-warning-1":
      "The charges are created automatically starting from :firstDate.",
    "agreement-sign-warning-2":
      "The financial start date in Casadesk for :agencyName is :financialStartDate. No charges are created for the period before this date. This rule prevents charges to be created for past times.",
    "agreement-sign-warning-3":
      "The charges are created automatically starting from the first date of the next new contract.",
    "unit-does-not-have-default-charges-yet":
      "The unit does not have default charges yet. Do you want to create default charge templates now?",
    "first-date": "First date",
    "renew-date": "Renew date",
    "last-date": "Last date",
    "last-date-1st-expiration-date": "Last date (1st expiration date)",
    "expiration-date": "Expiration date",
    "date-pay-charges-until": "Date pay charge untill",
    "final-date-2nd-expiration-date": "Final date (2nd expiration date)",
    "final-date": "Final date",
    "end-date": "End date",
    "label/end-date": "End date",
    "contract-expiration-date": "Notification date",
    "contract-notification": "Notification",
    "hint/contractexpirationdate":
      "At this date you’ll receive a notification because of an upcoming expiration date",
    "last-date-of-period-cannot-be-earlier-then-first-date":
      "Last date of period cannot be earlier then first date",
    "last-date-of-period-pretty-close":
      "Info: Last date is pretty close to first date.",
    "last-date-agreed-contract":
      "The last date is the last day of the period agreed in the contract.",
    drop: "Drop",
    "cancel-the-contract": "Cancel the contract",
    "contract-ended": "Contract ended",
    "no-tenant-found-click-add":
      "No tenant found. Click 'Add tenant' and create a new one",
    "no-contracts-to-list":
      "No contracts yet. Click the button 'Add Contract' and start adding contracts to your Casadesk system.",
    "set-end-date": "Set the end date",
    "clear-end-date": "Clear end date",
    "page/agreementupdate-launchpanel/setenddate": "Set the end date",
    "page/agreementupdate-launchpanel/setenddate-hint":
      "Set the last date for which an agency fee charge should be created",
    "page/agreementupdate-launchpanel/clearenddate": "Remove the end date",
    "page/agreementupdate-launchpanel/clearenddate-hint":
      "When the wrong end date was set",
    "page/agreementupdate-launchpanel/delete-hint":
      "Permanently delete the agreement",
    "set-warning-date": "Set warning date",
    "change-warning-date": "Change notification date",
    "end-contract-modal-title": "Set end date for contract",
    "end-agency-fee-modal-title": "Set the end date for the charge fee",
    "end-charge-template-modal-title": "Set end date for charge template",
    "expiration-contract-modal-title": "Set expiration date for contract",
    "end-date-not-set": "End date not set",
    "mark-past-invoices-as-paid-until":
      "Mark past invoices as paid until following date:",
    "you-created-concept-contract":
      "Contract was created. Now it is in concept status. Please sign a contract if you want to start creating charges",
    "first-date-in-the-past-ask-automatically-create-payments":
      "We noticed the start date of the contract is in the past. Continue to automatically create payments for all charges in the past. Click Skip to keep all charges in the past unpaid.",
    "want-to-change-the-rent":
      "You want to change the rent for this contract? Click the 'Renew' button.",
    "you-can-not-update-signed-contract": "You can not update signed contract",
    "you-did-not-create-charge-rent":
      "You didn't create a charge template for the rent. Do you want to create it now? With a charge template rent charges are created automatically.",
    "you-did-not-create-charge-deposit":
      "You didn't create a charge template for the deposit. Do you want to create it now? With a charge template the deposit charge is created automatically.",
    "you-did-not-create-agency-fee":
      "You didn't register an agency fee. Register one now?",
    "you-can-delete-only-concept-contracts":
      "You can delete only concept contracts",
    "sign-the-contract-to-create-charges":
      "Sign the contract to create charges",
    "no-charges-sign-the-contract-to-create-charges":
      "No charges yet. Sign the contract to create charges",
    "contract-update-dialog-sign-post-process-message-1":
      "The status of the contract was successfully changed to Signed.",
    "contract-update-dialog-sign-post-process-message-2":
      "From this moment charges are being created automatically. When available, you may find these charges on the tab Finance.",
    "you-can-not-update-charge-templates-for-active-contract":
      "A signed contract cannot be changed. Made a mistake and need to make changes? Then remove this contract and create a new one. Want to keep the contract but need to renew it? Then click the button Renew.",
    "menuitem-create-charges-for-next-period": "Create next rent charge",
    "dialog/createchargesfornextmonth-info":
      "The rent charges for the period :period are to be created.",
    "dialog/preprocess-createchargesnextmonth/title": "Create rent charges",
    "email/subject-rent-adjust": "Rent adjustment",
    "send-invoice-subject": "Settlement",

    //Collective invoice coach
    "launchpanel-menuitem/createfirstinvoice": "Rent statement for tenant",
    "launchpanel-menuitem/createlastinvoice": "Final statement for tenant",
    "coach/collectiveinvoice-step/first-title": "Select charges",
    "coach/collectiveinvoice-step/second-title": "Due date",
    "coach/collectiveinvoice-step/third-title": "Finish",
    "coach/collectiveinvoice-step/first-info":
      "Select the charges to include on the rent statement",
    "coach/collectiveinvoice-step/second-info":
      "Select the due date for the new tenant",
    "coach/collectiveinvoicefirst-step/third-info":
      "The invoice for the new tenant is going to be created. View and print the invoice, or send the invoice to the new tenant by email",
    "coach/collectiveinvoicefinal-step/third-info":
      "The invoice for the tenant is going to be created. View and print the invoice, or send the invoice to the tenant by email",
    "coach/collectiveinvoice-preprocess/info":
      "No charges found. Make sure the contract is signed, and the first charges are created.",
    "coach/collectiveinvoice-preprocess/infonotfoundcharges":
      "All charges for this contract were paid. Thus no final statement is necessary to settle any unpaid charges.",
    "preprocess/collectiveinvoice-info/alreadycreatedinvoice":
      "Reuse the previously created Invoice, or create a new invoice and replace?",
    "preprocess/collectiveinvoice-info/alreadycreatedinvoiceoption":
      "View and print the invoice, or send the invoice to the new tenant by email.",
    "coach-error-duedate": "Due date",
    "coach-error-chargeids": "Charges",
    "coach/collectiveinvoice-scenario/company-step/fourth-errorinfo2":
      "Go back and correct the problem, or click 'Cancel' try again later.",
    "coach/collectiveinvoice-preprocess/infoisnotsigned":
      "The contract is not signed yet. Change the status of the contract to signed and try again.",
    "coach/collectiveinvoice-preprocess/enddateisnotset":
      "First set the end date",
    "launchpanel-menuitem/createextracharge": "Extra charge for tenant",
    "coach-error-shortname": "Short name",

    // Settle charge coach
    "coach/settlecharge-step/first-info": "Select a charge and click Settle",
    "coach/settlecharge-step/second-info":
      "The charges were successfully settled.",

    // Settle payment coach
    "coach/settlepayment-step/first-info": "Select a payment and click Settle",
    "coach/settlepayment-step/second-info":
      "The payments were successfully settled.",

    // Renew
    "click-finish-to-create-new-contract":
      "Click 'Finish' to create a new contract registration which can be considered signed.",

    /*
    |  Contact/Company/User
    */

    phone: "Phоne",
    "agency-phone": "General phone number",
    "phone-1": "Phоne 1",
    "phone-2": "Phоne 2",
    "label-mob-number": "Mobile phone",
    "other-phone": "Other phone",
    profession: "Profession",
    address: "Search Аddress",
    "label-address": "Аddress",
    role: "Role",
    "role-admin": "Administrator",
    "role-none": "None",
    "role-owner": "Owner",
    "role-occupant": "Occupant",
    "role-tenant": "Tenant",
    "role-user": "User",
    "role-vendor": "Vendor",
    "role-manager": "Manager",
    "role-mede-huurder": "Occupant",
    "type-owner": "Owner",
    "type-vendor": "Vendor",
    "date-of-birth": "Date of birth",
    "place-of-birth": "Place of birth",
    "identity-document-type": "ID document type",
    "identity-document-number": "ID document number",
    "identity-document-type-passport": "Passport",
    "identity-document-type-driving-licence": "Driving Licence",
    "identity-document-type-identity-card": "Identity Card",
    "gender-type": "Gender",
    "language-type": "Language",
    "can-not-update-removed-person": "Can not update removed person",
    "can-not-update-removed-company": "Can not update removed company",
    "no-company-found-click-add":
      "No company found. Click 'Add company' and create a new one",
    "company-update-persons-related-to-company":
      "Persons related to the company",
    "company-update-persons-related-to-owner": "Persons related to the owner",
    "company-update-properties-related-to-owner":
      "Properties related to the owner",
    "company-update-properties-related-to-company":
      "Properties related to the company",
    "no-contacts-to-list":
      "No contacts yet. Click the button 'Add Contact' and start adding contacts to your Casadesk system.",
    "no-companies-to-list":
      "No companies yet. Click the button 'Add Company' and start adding companies to your Casadesk system.",
    "page/companyupdate-section/property-info/propertyforcompanynotfound":
      "No properties yet. Click the button 'New Property' and start adding properties to your Casadesk system.",
    "you-are-about-to-delete-user":
      ":name will be removed. This cannot be undone. Continue?",
    "verification-email-sent":
      "Click the verification link in the message that was sent to :newEmail. Until the new email address has been verified, the active email address remains :currentEmail.",
    "system-sent-notification-to-new-user":
      "An invitation with link has been sent to the new user.",
    "invitation-email-sent": "Invitation email sent",
    "new-executor": "New contact",
    "new-user": "New User",
    "broken-month-calculation": "Broken month calculation",
    "delete-user": "Remove user",
    "user-info": "User Info",
    "change-email": "Change email",
    "new-email": "New email",
    "confirm-email": "Repeat new email",
    "confirm-email-should-be-equal": "Emails are not equal",
    "title-savings": "Savings accounts",
    "button-withdrawal": "Withdrawal from savings",
    "page/companyupdate-section/statements-tab/finance-info/nostatementsfound":
      "No statements exist.",
    "title-no-statements-to-list": "No statements exist.",

    /*
    |  Attachments
    */

    attachments: "Attachments (documents and pictures)",
    "attachments-for-person": "Attachments for person (documents and pictures)",
    "attachments-for-caretaker":
      "Attachments for caretaker (documents and pictures)",
    "attachments-for-company":
      "Attachments for company (documents and pictures)",
    "attachments-for-owner": "Attachments for owner (documents and pictures)",
    "attachments-for-executor":
      "Attachments for assignee (documents and pictures)",
    "attachments-for-tenant": "Attachments for tenant (documents and pictures)",
    "attachments-for-property":
      "Attachments for property (documents and pictures)",
    "attachments-for-address":
      "Attachments for address (documents and pictures)",
    "attachments-for-unit": "Attachments for unit (documents and pictures)",
    "attachments-for-contract":
      "Attachments for contract (documents and pictures)",
    "attachments-for-agency": "Attachments for agency (documents and pictures)",
    "attachments-for-task": "Attachments for task (documents and pictures)",
    "attachments-for-conversation":
      "Attachments for this conversation (documents and pictures)",
    "private-attachments-for-task":
      "Private attachments for task (documents and pictures)",
    "shared-attachments-for-note":
      "Attachments for note (documents and pictures)",
    "private-attachments-for-note":
      "Private attachments for note (documents and pictures)",
    "attachments-for-invoice":
      "Attachments for invoice (documents and pictures)",
    "attachments-for-activity":
      "Attachments for activity (documents and pictures)",
    "attachments-for-user": "Attachments for user (documents and pictures)",
    "title-attachments": "Attachments",
    "attachments-for-charge": "Attachments for charge (documents and pictures)",
    "attachments-for-email": "Attachments for this email",

    /*
    |  Agency fee
    */

    "fixed-fee": "Fixed Fee",
    "percentage-fee": "Percentage Fee",
    "fixed-plus-percentage-mode": "Fixed Plus Percentage Mode",
    "agreement-card/percentagefee-label": "Percentage",

    /*
    |  Notification
    */

    "amount-to-pay": "Amount to pay",
    "due-date": "Due date",
    "continue-contract": "Continue contract",
    "you-are-about-to-set-expiration-date":
      "You are about to set the expiration date of the contract. Expiration notification will be created at that date.",
    "open-notification-details": "Open Notification Details",
    "open-activity-details": "Open activity details",
    "open-task-details": "Open task details",
    "task-details": "Task details: ",
    "days-ago": "days ago",
    "unpaid-charges": "Unpaid charges",
    "notification-details": "Notification details",
    "unpaid-charge": "Unpaid charge",
    "unpaid-invoice": "Unpaid invoice",
    "charge-was-sent": "Charge was sent",
    "invoice-was-sent": "Invoice was sent",
    "email-was-sent-to": "Email was sent to:",
    "email-was-sent": "Email was sent",
    number: "Number",
    "unpaid-notification-was-created-because":
      "Notification was created because the charge was not paid in time. Ensure if payment is charged. If not, then contact a tenant or snooze the notification.",
    "event-update-contract-prices-was-created-because-part-1":
      "Determine if the contract must be renewed and prices updated. Click on the contract link below to do it now. Or click Snooze to do it later.",
    "event-update-contract-prices-was-created-because-part-2":
      "This notification was created as a yearly reminder to verify if the contract prices are still correct.",
    "open-charge-details": "Open charge details",
    "open-tenant-details": "Open tenant details",
    "open-contract-details": "Open contract details",
    "open-unit-details": "Open unit details",
    created: "Created",
    "expiring-contracts": "Expiring contracts",
    "no-notifications": "No notifications",
    expires: "Expires",
    "expiring-contract": "Expiring contract",
    "expiring-notification-was-created-because":
      "Notification was created because the contract ends soon. Contact a tenant to know if the contract is going to be extended. If not, then set an end date for the contract.",
    "unpaid-charge-notification": "Unpaid charge notification",
    "unpaid-notification-deactivated-charge-fully-paid":
      "The unpaid charge notification was deactivated, as the charge was fully paid",
    "unpaid-notification-not-deactivated-charge-partly-paid":
      "The unpaid charge notification was not deactivated, as the charge was just partly paid",
    "expiring-contract-notification": "Expiring contract notification",
    "notification-information": "Notification information",
    snooze: "Snooze",
    unsnooze: "Unsnooze",
    "snooze-date-will-be-removed":
      "Snooze date will be removed and a notification will be activated again",
    "snooze-for-days": "Snooze for (days)",
    "snooze-until-date": "Snooze until (date)",
    or: "or",
    "you-can-snooze-for-1-day": "You can snooze at least for 1 day",
    "email-was-saved": "Email was saved",

    /*
    |  Activities and Tasks
    */

    "activity-templates": "Activities",
    "new-activity": "New activity",
    activity: "Activity",
    "status-open": "Open",
    "status-closed": "Closed",
    "status-close": "Close",
    "status-finished": "Finished",
    "activitytemplatecreate-addactivity-title": "New activity template",
    "page/setting-tab/activities-field/newactivity-type/button": "Add activity",
    "create-activities-with-tasks":
      "Create activities with tasks which can be applied to users and contacts",
    "determine-name-for-activity":
      "Provide the name for the activity template and add tasks.",
    "determine-name-for-activity-2":
      "Use an activity template to create a group of tasks with 1 click for a check in, incident,.. etc. Activity templates are available at units.",
    "activity-name": "Activity name",
    tasks: "Tasks",
    "new-task": "New task",
    "new-note": "New note",
    "number-of-tasks": "Number of tasks",
    "delete-activity": "Delete activity",
    "delete-note": "Delete note",
    "you-are-about-to-delete-activity":
      "You are about to delete ':name' activity. Are you sure you want to delete? The activity will be deleted permanently.",
    "you-are-about-to-delete-task":
      "You are about to delete ':name' task. Are you sure you want to delete? The task will be deleted permanently.",
    "you-are-about-to-delete-note":
      "You are about to delete note. Are you sure you want to delete? The note will be deleted permanently.",
    "you-are-about-to-delete-event":
      "You are about to delete event. Are you sure you want to delete? The event will be deleted permanently.",
    "create-individual-task": "Create individual task",
    "menuitem-add-task": "Add task",
    "button-add-task": "Add task",
    "button-add-activity": "Add activity",
    "menuitem-create-task": "Create a task",
    "charge-details/menuitem-create-task": "New task",
    "confirm-task": "Confirm task",
    "you-are-about-to-create-task-for-unit":
      "You are about to create a task and link it for Unit :unit.",
    "you-are-about-to-create-task-for-property":
      "You are about to create a task and link it for Property :property.",
    "registered-by": "Registered by",
    "assigned-to-me": "To do by me",
    "include-closed": "Finished tasks",
    "include-closed-messages": "Include closed",
    "include-still-to-show": "Snoozed tasks",
    "to-show-on": "To show on",
    "include-activities-tasks": "Include activity tasks",
    "created-by-me": "Created by me",
    instructions: "Instructions",
    instruction: "Instruction",
    "to-do-by": "Assignee",
    "reported-by": "Reported by",
    assignee: "Assignee",
    reporter: "Reporter",
    "to-be-executed-on-or-before": "To be executed on or before",
    "final-date-for-task": "To do on or before",
    "show-me-from": "Snooze this task until",
    "show-me-from-task-dialog": "Snooze this task until",
    "days-to-execute": "Days to execute",
    "minimum-one-day": "Minimum one day",
    "no-tasks-created": "No tasks found.",
    "create-tasks-associated-with-the-activity":
      "Create task associated with the activity",
    "delete-task": "Delete task",
    "this-field-is-required": "This field is required",
    "label-overview": "Overview",
    "unfinished-tasks": "Unfinished tasks",
    "no-tasks": "No tasks",
    task: "Task",
    incident: "Incident",
    "menuitem-finish": "Finish",
    "menuitem-unfinish": "Unfinish",
    "button-finish": "Finish",
    "button-finish-task": "Finish task",
    "button-close-task": "Close task",
    "button-reopen-task": "Reopen task",
    "button-unfinish-task": "Unfinish task",
    "you-are-about-to-finish-task":
      "You are about to finish ':name' task. The task will be deleted from 'Unfinished tasks' list and will be marked as done.",
    "you-are-about-to-unfinish-task":
      "You are about to unfinish ':name' task. The task will be marked as undone.",
    "edit-task": "Edit task",
    "update-task": "Update task",
    "activity-template": "Activity template",
    "create-tasks-for": "Create activity :activityTemplate",
    "you-are-about-to-create-task-for-activity-for-unit":
      "Create activity ':activityTemplate' with tasks for: :unit.",
    "you-are-about-to-create-task-for-activity-for-property":
      "Create activity ':activityTemplate' with tasks for: :property.",
    "create-tasks": "Create activity",
    "confirm-tasks": "Confirm tasks",
    "deselect-tasks-you-do-not-want-to-apply":
      "Deselect tasks you do not want to apply, create any additional tasks or maake sure the tasks have the right person, instructions and execution date attached.",
    "task-was-finished": "Task :task finished",
    "task-was-created": "Task :task created",
    "task-was-updated": "Task :task updated",
    "task-was-removed": "Task :task removed",
    "task-for-unit-done": "Object :unit",
    "task-for-unit-created": "Object :unit",
    "task-for-unit-updated": "Object :unit",
    "task-for-unit-removed": "Object :unit",
    "task-for-property-done": "Object :property",
    "task-for-property-created": "Object :property",
    "task-for-property-updated": "Object :property",
    "task-for-property-removed": "Object :property",
    "done-by-executor": "done by :executor",
    "page/activity-field/name-label": "Name",
    "new-task-based-on-conversation": "New task based on this conversation",

    /*
    |  Timeline
    */

    timeline: "Timeline",
    note: "Note",
    "type-a-note": "Type a note...",
    "please-enter-a-note": "Please enter a note",
    memo: "Memo",
    "memo-text": "Memo text",
    "add-memo": "Add memo",
    "menuitem-add-memo": "Memo",
    "launch-panel-add-memo": "Open the memo",
    "remove-memo": "Remove memo",
    "to-set-a-notification":
      "To set a notification, choose date and a time in the future",
    time: "Time",
    due: "Due",
    by: "by",
    for: "for",
    reminder: "Reminder",
    "launch-panel-pay-charge": "Process a payment for this charge",
    "launch-panel-settle-charge": "Settle with another charge",
    "hint/launch-panel-settle-charge":
      "To settle an amount to be received with an amount to be paid",
    "launch-panel-settle-payment": "Settle with another payment",
    "hint/launch-panel-settle-payment":
      "Settle - part of - this payment with another payment",
    "launch-panel-send-payment-by-email": "Send by email",
    "hint/launch-panel-send-payment-by-email":
      "Send the details of the payment by email to anyone you want",
    "hint/launch-panel-send-task-by-email":
      "Send the details of the task by email to anyone you want",
    "hint/launch-panel-pay-charge":
      "Register a payment (if not received as a bank transaction)",
    "launch-panel-register-charge": "New charge based on this payment",
    "hint/launch-panel-register-charge":
      "A charge is created based on the - remaining - amount of this payment, for example for an automatically debited energy bill",
    "payment-date": "Payment date",
    "launch-panel-add-memo-for-charge": "Edit memo for this charge",
    "hint/launch-panel-renew-contract":
      "To increase the rent, add a charge or change the occupant, for example.",
    "hint/launch-panel-adjust-contract":
      "Review and adjust the rent prices for the this contract",
    "hint/launch-panel-adjust-contract-unitpage":
      "Review and adjust the rent prices for the active contract",
    "hint/launch-panel-set-end-date-contract":
      "When the tenant leaves the unit and the deposit needs to be returned",
    "hint/launch-panel-clear-end-date-contract":
      "When the wrong end date was set",
    "hint/launch-panel-create-extra-charge":
      "Extra incidental costs for the tenant, or a charge to return money to the tenant",
    "hint/launch-panel-create-charge-uncoming-period":
      "Already create the next rent charge to process an advance payment, for example",
    "hint/launch-panel-create-rent-statement":
      "Overview of the charges to be paid by the tenant",
    "hint/launch-panel-create-final-statement":
      "Final settlement statement for the tenant",
    "hint/launch-panel-drop":
      "When the contract is not going to be signed by all parties",
    "hint/launch-panel-remove": "Permanently delete the contract",
    "launch-panel-add-extra-charge-for-unit": "Create an extra charge",
    "menuitem-open-memo": "Open the memo",
    "charge-details/menuitem-open-memo": "Memo",
    "launch-panel-send-tenant-portal-link-hint":
      "The portal allows a tenant to report an issue",
    "launch-panel-unit-extra-charge-hint":
      "An extra cost to be paid by the owner for this unit, or an extra amount to be received by the owner (a tax return for example)",
    "launch-panel-create-contract": "Create a new contract",
    "hint/launch-panel-create-contract": "Create a concept contract for a new tenant",
    "launch-panel-bill-settlement": "Settle a final bill",
    "hint/launch-panel-bill-settlement":
      "Distribute a final bill (water, electricity, heating,..) over the tenants",
    "launch-panel-create-agreement": "Create a new agreement",
    "hint/launch-panel-create-agreement":
      "Create a concept agency agreement for the owner",
    "launch-panel-create-default-contract-amount": "Default rent amounts",
    "launch-panel-create-default-contract-amount-hint":
      "Update the default amounts for a new rental contract",
    "launch-panel-move-unit": "Move unit",
    "launch-panel-move-unit-hint": "Move this unit to another property",
    "launch-panel-create-pdf": "Create PDF",
    "launch-panel-create-pdf-hint":
      "Create a PDF document with the charge details",
    "contract-launch-panel-create-pdf": "Create a PDF",
    "contract-launch-panel-create-pdf-hint":
      "Create a PDF document with the contract details",
    "launch-panel-create-invoice": "Create invoice",
    "launch-panel-create-invoice-hint":
      "Assign an invoice number and create the final PDF document",
    "notification-rent-message": "Adjust the rent price",
    "launch-panel-send-to-landlord": "Send to landlord",
    "hint/launch-panel-send-to-landlord":
      "Send the details of this contract to the landlord. This will also include details of the previous version of the contract, if available.",

    /*
    |  Event
    */

    event: "Event",
    notification: "Notification",
    "by-user": "(by :user)",
    "event-charge-overdue-title": "Overdue (:daysd)",
    "event-charge-overdue-reason":
      "Charge ( :charge ) is overdue. It had to be paid on :date.",
    "event-invoice-overdue-reason":
      "Invoice ( :charge ) is overdue. It had to be paid on :date.",
    "event-contract-expiring-title": "Expiring",
    "event-contract-ending-title": "Ending",
    "event-contract-expiring-reason":
      "Contract between Tenant ( :tenant ) and Unit ( :unit ) is expiring on :date.",
    "event-contract-ending-reason":
      "Contract between Tenant ( :tenant ) and Unit ( :unit ) is ending on :date.",
    "event-contract-ended-title": "Ended",
    "event-contract-ended-reason": "Contract ended on :date.",
    "event-system-created-title": ":entity created",
    "event-system-updated-title": ":entity updated",
    "event-system-removed-title": ":entity deleted",
    "created-owner-statement": "Created owner statement",
    "owner-statement-was-created": "Owner statement for :month was created.",
    "owner-statement-was-sent":
      "Owner statement for :month was sent to the owner.",
    "owner-statement-warning": "Owner Statement Warning",
    "owner-statement-type-agency": "Agency",
    "owner-statement-type-owner": "Owner",
    "owner-statement-type-tenant": "Tenant",
    "send-owner-statement-for": "Send owner statement for :month",
    "sent-owner-statement": "Sent owner statement",
    "owner-statement": "Statement",
    "owner-statement-closed": "Closed",
    // carry: "Carry", // deprecated: carry info is no longer presented nor used otherwise
    payout: "Payout",
    view: "View",
    "exclusive-vat": "Excluding VAT",
    "total-agency-services": "Total services",
    "total-to-pay-by-owner": "Total to pay by",
    "to-be-paid-to-owner": "To be paid",
    "to-be-received-from-owner": "To be received",
    "total-sum-charges-for-month": "Sum of charges for",
    "total-expences": "Total expenses",
    "total-sum-payments-for-month": "Total income received",
    "details-for-the-result": "Details for the result for",
    "this-is-first-owner-statement":
      "This is first owner statement created for You. This statement will include all charges from previous periods",
    totals: "Totals",
    "charges-paid-in": "Charges paid in",
    "late-payments": "Late payments",
    "to-be-paid": "To be paid by :ownername",
    "to-be-received": "To be received by :ownername",
    "to-be-paid-small-first-letter": "to be paid by :ownername",
    "to-be-received-small-first-letter": "to be received by :ownername",
    "paid-by-owner-small-first-letter": "paid by :ownername",
    "received-by-owner-small-first-letter": "received by :ownername",
    "paid-by-owner": "Paid by :ownername",
    "received-by-owner": "Received by :ownername",
    "still-to-be-paid": "Still to be paid by :ownername",
    "still-to-be-received": "Still to be received by :ownername",
    "already-settled": "Already settled",
    "still-to-be-received-from-the-beginning":
      "Still to be received at the begging of :period (from last statement)",
    "still-to-be-received-for-month": "Not received for",
    "still-to-be-received-at-the-end":
      "Still to be received at the end of :period (to next statement)",
    "create-owner-statement-send-it-to-owner":
      "Create an owner statement and send it to the owner",
    "charge-paid-with-payment": "Charge :charge was paid",
    "charge-and-payment-were-unlinked":
      "Charge :charge and payment :payment were unlinked",
    "company-and-person-were-linked":
      "Company :company and person :person were linked",
    "event-details": "Event details",
    "event-update-contract-prices": "Update contract prices",
    "event-statement-was-created": "Statement created",
    "event-statement-was-closed": "Statement closed",
    "amount-to-credit": "Amount to credit",

    // Event details update window (Unit update titles)
    "title-updated-unit-number": "Updated Unit Number",
    "title-updated-unit-type-id": "Updated Unit Type Id",
    "title-updated-paid-status-id": "Updated Paid Status Id",
    "title-updated-square-meters": "Updated Square Meters",
    "title-updated-room-number": "Updated Room Number",
    "title-updated-bedroom-number": "Updated Bedroom Number",
    "title-updated-bathroom-number": "Updated Bathroom Number",
    "title-updated-publication-title": "Updated Publication Title",
    "title-updated-unit-status-id": "Updated Unit Status Id",
    "title-updated-planning-data": "Updated Planning Data",
    "title-updated-note": "Updated Note",

    /*
    |  Settings
    */

    "label-settings": "Settings",
    "title-settings": "Settings",
    "menuitem-settings": "Settings",
    "settings-user-profile": "User",
    "settings-user-profile-title": "Profile user",
    "settings-agency-profile": "Agency",
    "settings-email-subject": "Email subject",
    "settings-agency-profile-panel": "Agency profile",
    "settings-agency-profile-panel-subtitle":
      "Name, Address, Bank account number, Website, Phone number,…",
    "settings-agency-preferences-panel-subtitle":
      "Default settlings for a new user, new contract, new charge,…",
    preferences: "Preferences",
    "agency-preferences": "Agency preferences",
    "agency-logo-section": "Agency logo",
    "agency-logo-section-subtitle":
      "The logo is being used in emails, invoices, reports and other documents",
    language: "Language",
    "use-beta-version-features": "Use beta version features",
    "hint-bankaccount-info":
      "This bank account will be presented on the invoices",
    "label/agency-general-contact": "General contact for rental management",
    "label/company-general-contact": "General contact",
    "hint-agency-short-name":
      "Limit to 12 characters. Being used for example in mobile text messages",
    "use-show-review-features": "Review owner statements",
    "use-not-show-username-features": "Use the general address as sender",
    "settings/agencyprofile-info/notshowusername-link":
      "Go to settings to set the general email address",

    /*
    |  Reports
    */

    reports: "Reports",
    "title-reports": "Reports",
    "title-statements": "Owner statements",
    "title-statements-dashboard": "Owner statements - ready to send",
    "owner-statements-for": "Owner statements for",
    "agency-statements": "Agency statements",
    "agency-statement": "Agency statement",
    "agency-statement-for": "Agency statement for",
    "financial-statement": "Financial statement",
    "created-with-casadesk": "Created with Casadesk",
    "owner-statements-subtitle": "Statement for the owner",
    "financial-report-for": "Statement for",
    result: "Result",
    "payout-section-title/previouspayoutcharges":
      "Previous statements for :period",
    "payout-section-title/newactualpayoutcharge": "Settlement :period",
    "payout-section-title/additionalactualpayoutcharge":
      "Additional settlement :period",
    "payout-section-title/ofwhichsettled": "Of which already settled",
    "payout-section-title/settlements": "To be settled",
    "payout-section-title/topay": "Remains to be paid",
    "payout-section-title/savings": "Savings",
    "preprocess/lockstatement-info/beforesend":
      "After closing, it is no longer possible to update this statement and its charges.",
    "preprocess/lockstatement-info/beforeprint":
      "An invoice is about to be created and the statement is set to Sent. Once created the invoice cannot be removed. Continue?",
    "preprocess/lockstatement-info/needactivateinvoicing":
      "Invoicing is not activated yet. To activate invoicing, please go to Settings | Agency profile. Note that this option is only available for administrators",
    "preprocess/lockstatement-error/statementoutdated-info/needactivateinvoicing":
      "The owner statement was updated. Please review and try again.",
    "button-download": "Download",
    "page/reports-tab/booklist-title": "Journal",
    "page/reports-tab/booklist-info": "Download the journal for the period:",
    "page/reports-tab/paylist-title": "Payables",
    "page/reports-tab/paylist-info":
      "Overview of payables that are not yet - fully - settled.",
    "page/reports-tab/overview-title": "Receivables",
    "page/reports-tab/overview-info":
      "Overview of receivables that are not yet - fully - settled.",
    "page/reports-tab/balance-title": "Balance",
    "page/reports-tab/balance-section-title": "Property balances",
    "page/reports-tab/balance-info":
      "Download the property balances for period:",
    "owner-statements-to-invoice-status": "To invoice",
    "owner-statements-all-invoiced-status": "Invoiced",
    "preprocess/createinvoice": "An invoice is about to be created. Continue?",

    /*
    |  Invoices
    */
    invoices: "Invoices",
    "title-invoices": "Invoices",

    /*
    |  Filters
    */

    all: "All",
    empty: "Empty",
    unpaid: "Unpaid",
    rented: "Rented",
    "all-payments": "All Payments",
    "unused-payments": "Unused Payments",
    "all-charges": "All charges",
    unfinished: "Unfinished",
    "all-active": "All (active)",

    /*
    |  Mail System
    */

    message: "Message",
    reason: "Connection results",
    logs: "Mail server says:",
    mail: "Mail",
    mails: "Mails",
    "my-email-account": "My Email Account",
    "user-email-accounts": "User Email Accounts",
    "agency-email-accounts": "Agency Email Accounts",
    active: "Active",
    inactive: "Inactive",
    "new-email-account": "New Email Account",
    "add-email-account": "Add email account",
    "update-email-account": "Update email account",
    imap: "IMAP",
    "imap-user": "IMAP User",
    "imap-password": "IMAP Password",
    "imap-host": "IMAP Host",
    "imap-port": "IMAP Port",
    "email-provider": "Email provider",
    "no-emails-to-list":
      "No emails yet. Click the button 'Add Email Account' and start adding emails to your Casadesk system.",
    "email-was-changed": "Email was changed",
    "email-was-successfully-changed":
      "The email was successfully changed. Now you can use your new email when signing in to Casadesk.",
    "unsubcribed-successfully": "You successfully unsubscribed",
    "mail-box-mail-page": "Mail box",
    "title-mail-box-mail-page": "Mail box",
    "mail-page-title": "Mail page",
    "email-box-page-no-emails-list-admin":
      "There are no agency email accounts activated. Click on 'Add Email Account' button to create a new agency email account, or activate an existing account in the mail settings: 1.Go to Settings 2.Go to Mail tab 3.Choose and update the account you want to use.",
    "email-box-page-no-emails-list-manager":
      "Your agency has no activated agency email account yet. Contact with the administrator for more details",
    "email-box-page-no-emails-list-admin-active":
      "Agency email accounts ‌are activated. Casadesk updates emails every 10 minutes. Your emails will be displayed here.",
    "mail-page-detail-title": "Mails details",
    "mails-pagee-mail-accounts": "Mail accounts",
    "history-url-mail-details": "Mail details",
    "history-url-mails": "Mails",
    "setting-page-no-user-emails-to-list":
      "No emails yet. Add users to your Casadesk system to see their email accounts here.",
    "button-google-account-google-logout": "Logout from",
    "button-google-account-google-login": "Login with Google",
    "label-ssl": "label-ssl",

    /*
    |  Agency profile
    */

    locale: "Locale",
    "default-locale": "Default locale (dates, numbers,..)",
    "default-language": "Default language",
    "default-calculation": "Default calculation",
    "calculation-month": "Month",
    "calculation-year": "Year",
    "locale-en-us": "United States",
    "locale-nl-nl": "The Netherlands",
    "locale-en-cy": "Cyprus",
    "settings/agencyprofile-label/notificationperiod":
      "Default notification period (months)",
    "settings/agencyprofile-info/notificationperiod":
      "A few months before the next expiration date Casadesk presents a notification for a contract.",
    "settings/agencyprofile-info/brokenmonthcalculation":
      "Calculate the rent per day for full year (365 days), or for - the number of days in - that particular month.",
    "settings/agencyprofile-label/vat": "Default VAT percentage",
    "settings/agencyprofile-label/fee": "Percentage administration fee",
    "settings/agencyprofile-info/vat":
      "The VAT percentage is applied in new invoices",
    "settings/agencyprofile-info/fee":
      "The administration fee is being added to the service costs (available in the settlement coach of the unit) ",
    "settings/agencyprofile-error/fee":
      "Administration percentage can not be less then 0",

    "settings/agencyprofile-info/invoices": "Invoices",
    "settings/agencyprofile-info/invoices-hint":
      "A copy of every invoice is send to this email address",
    "settings/agencyprofile-info/sender": "Sender for emails",
    "settings/agencyprofile-info/sender-hint":
      "Sender for automatically sent emails",
    "settings/agencyprofile-info/sender-general-contact": "General contact",
    "settings/agencyprofile-info/sender-general-email": "General email address",
    "settings/agencyprofile-info/reviewfeatures":
      "Allow another user to review the owner statements before sending them",
    "settings/agencyprofile-section/ownerstatements-label/statementemailtext":
      "Default owner statement email text",
    "settings/agencyprofile-section/ownerstatements-title/defaulttextforstatementemail":
      "Default text for owner settlement email",
    "settings/agencyprofile-section/ownerstatements-title/defaulttextforadjustrentemail":
      "Default text for rent adjustment email",
    "settings/agencyprofile-section/ownerstatements-hint/sendcopy":
      "Default values for the ‘Send a copy’ option in ‘Send email’ pages",
    "settings/agencyprofile-section/ownerstatements-title/sendcopyofattachments":
      "Send copy of attachments to",
    "settings/agencyprofile-section/ownerstatements-label/sendcopytoemails":
      "Send a copy of the attachment(s) to email address",
    "settings/agencyprofile-info/brokenmonthexplanation":
      "One day rent based on month or year price",
    "title-agency-statements": "Agency statements",
    /*
    |  Types
    */

    // Charge types
    rent: "Rent",
    basic_rent: "Basic rent",
    deposit: "Deposit",
    parking: "Parking",
    administration_fee: "Administration fee",
    late_fee: "Late fee",
    loss: "Loss",
    utilities: "Utilities",
    water: "Water",
    gas: "Gas",
    electricity: "Electricity",
    taxes: "Taxes",
    banking_costs: "Banking costs",
    agency_fee: "Agency fee",
    surplus: "Surplus",
    settlement: "Statement",
    other_receivable: "Other receivable",
    other_payable: "Other payable",
    paid_to_much: "Paid too much",
    late_payment_fee: "Late payment fee",
    deposit_refund: "Deposit refund",
    furnished: "Services",
    facilities: "Facilities",
    stub_receivable: "Dummy charge",
    stub_payable: "Dummy charge",
    payout_receivable: "Settlement",
    payout_payable: "Settlement",
    overpaid_receivable: "Overpaid",
    overpaid_payable: "Overpaid",
    refund_receivable: "Refund",
    refund_payable: "Refund",
    savings_account_withdraw: "Withdrawal from savings",
    savings_account_deposit: "Deposit to savings",
    owner_association_contribution: "Owner Association contribution",
    credit: "Credit",
    credit_payable: "Credit",
    credit_receivable: "Credit",
    settled_bill_receivable: "Settled bill",
    settled_bill_payable: "Settled bill",

    //Unit types
    room: "Room",
    studio: "Studio",
    apartment: "Apartment",
    house: "House",
    boat: "Boat",
    commercial: "Commercial",
    garage: "Garage",
    villa: "Villa",
    senior_accommodation: "Senior accommodation",
    live_in_guardian: "Live in guardian",
    bungalow: "Bungalow",
    live_workspace: "Live workspace",
    no_preference: "No preference",
    complex: "Complex",

    //FixedPlusPercentageModes types
    fpp_both: "Apply both the percentage and fixed fee",
    fpp_wichever_high: "Apply lowest amount only",
    fpp_wichever_low: "Apply highest amount only",

    //Repeat period types
    once: "Once",
    monthly: "Monthly",
    yearly: "Yearly",
    weekly: "Weekly",

    //Charge classes types
    receivable: "Receivable",
    payable: "Payable",
    "receivable-template": "receivable",
    "payable-template": "payable",

    //Contract status types
    concept: "Concept",
    signed: "Signed",
    dropped: "Dropped",
    expiring: "Expiring",
    ending: "Ending",
    ended: "Ended",
    closed: "Closed",

    //Payment types
    payment_type_cash: "Cash",
    payment_type_bank: "Bank",
    payment_type_cheque: "Cheque",
    payment_type_settlement: "Settle",
    payment_type_settled_bill: "Settled Bill",
    payment_type_other: "Other",
    payment_type_savings_account: "Savings account",

    //Statements status
    definitive: "Definitive",
    "statement-status-definitive": "Invoiced",
    "statement-status-concept": "Concept",

    // Identity document types
    passport: "Passport",
    driving_licence: "Driving Licence",
    identity_card: "Identity Card",
    none: "None",

    // Gender types
    gender_type_male: "Male",
    gender_type_female: "Female",
    gender_type_unknown: "Unknown",

    // Creation types
    "creation-type-auto": "Auto",
    "creation-type-manual": "Manual",
    "creation-type-file": "File",

    //Unit service status type
    unit_service_status_type_management: "Managed",
    unit_service_status_type_inactive: "Archive (inactive)",

    //Assignment service status type
    assignment_service_status_type_inactive: "Inactive",
    assignment_service_status_type_tenantsearch: "Tenant search",
    assignment_service_status_type_operational: "Operational management",
    assignment_service_status_type_financial: "Administrative management",
    assignment_service_status_type_operationalfinancial: "Property management",

    /*
    |  Socket
    */

    "socket-connected": "Socket connected",
    "socket-disconnected": "Socket disconnected",
    "socket-disconnected-message-line-1": "Oh snap!",
    "socket-disconnected-message-line-2":
      "We cannot connect to the servers at this time.",
    "socket-disconnected-message-line-3":
      "This dialog will automatically be closed when the servers come up. ",
    "socket-disconnected-message-line-4":
      "Please wait while we reconnect you back...",

    /*
    |  Backend Errors (sync)
    */

    be_statement_not_found: "Owner statement not found",
    be_iban_in_use: "This bank account is already used for :displayName",
    be_no_balance_for_period: "No balance for this period",
    be_incorrect_email_address: "Email address is not correct",
    be_not_allowed_change_email_account:
      "You have not enough rights to create or change this email address",
    be_charge_class_unmatch: "Charge class of related objects does not match",
    be_contact_exists: "This email address is already in use at :displayName",
    be_payment_date_earlier_than_first_date:
      "Payment date cannot be earlier than first date",
    be_payment_not_found: "Payment not found",
    be_payment_requires_transaction: "Payment requires a transaction",
    be_duration_must_be_at_least_one_period:
      "Duration of a Charge Template must be at least one period",
    be_last_earlier_than_first_date:
      "Last date of period cannot be earlier than first date",
    be_final_rental_period_date_early:
      "Final rental period date cannot be earlier than last date",
    be_account_already_confirmed: "Account already confirmed",
    be_account_blocked: "Your account is blocked",
    be_account_not_confirmed: "Your account is not confirmed",
    be_only_one_email_allowed: "Only one email account is allowed per contact",
    be_ajv_not_validated: "The information in the ':fieldName' field is not valid",
    be_minimum_two_admins_required:
      "The user role cannot be changed. You need at least 1 user with the admin role.",
    be_password_regex_invalid:
      "At least 8 characters and 1 digit. Special characters are",
    "be_password_regex_invalid-1": "also allowed, like: ! # @ & * +",
    be_array_expected: "Field should be an array",
    be_contract_end_date_in_past: "Contract end date can not be in the past",
    be_array_length_expected: "Invalid array length",
    be_body_invalid: "Invalid request body",
    be_charge_template_not_found: "Charge not found",
    be_agency_fee_not_found: "Agency fee not found",
    be_company_exists:
      "This agency name is already in use. Please choose another name.",
    be_company_not_found: "Company not found",
    be_company_name_required: "Company name required",
    be_auto_created_charges_cannot_be_deleted:
      "Automatically created charges cannot be deleted",
    be_contact_company_not_related: "Contact and company are not related",
    be_action_minimum_two_admins_required:
      "The user role cannot be changed. You need at least 1 user with the admin role.",
    be_contact_not_found: "Contact not found",
    be_contract_not_found: "Contract not found",
    be_contract_cannot_delete_has_linked_payments:
      "Some of the charges in this contract has linked payments to it's charges so it is not possible to delete the contract.",
    be_contract_cannot_end_has_linked_payments:
      "Some of the charges in this contract has linked payments to it's charges so it is not possible to end the contract.",
    be_contract_already_ended: "Contract is already ended",
    be_contract_cannot_end_in_this_date: "Contract cannot end in this date.",
    be_agency_cannot_change: "Agency cannot be changed",
    be_contract_not_signed: "Contract must be signed",
    be_data_required: "Data is required",
    be_unit_number_required:
      "Unit number is required when there is another Unit in the same property",
    be_invalid_date: "Invalid date",
    be_email_account_not_found: "Email account is not found",
    be_unit_cannot_be_deactivated_due_to_active_contracts:
      "Unit cannot be deactivated due to active contracts",
    be_email_required: "Email is required",
    be_es_add_error: "Error occured when adding record to elastic search",
    be_es_check_index_error:
      "Error occured when checking index in elastic search",
    be_es_get_error: "Error occured when getting record from elastic search",
    be_es_remove_error:
      "Error occured when removing record from elastic search",
    be_es_query_error: "Error occured when searching record in elastic search",
    be_event_not_found: "Event not found",
    be_event_reply_wrong_type: "You can't reply on this type of event",
    be_field_required: "Required field is missing",
    be_file_ext_not_supported: "File extension is not supported",
    be_file_too_big: "File too big",
    be_firstname_email_required:
      "First name and email fields are required for admins and users.",
    be_fk_value_not_found: "Foreign key value not found",
    be_json_parse_error: "Error occured during parsing of json",
    be_main_tenant_missing:
      "The tenant has no general contact person. Please assign a general contact and try again.",
    be_main_tenant_not_found:
      "Contact marked as main tenant doesn't exist in this agency",
    be_missing_file: "No file to upload",
    be_success_delete: "Successfully deleted",
    be_model_not_found: "Model not found",
    be_no_charge_template_contract_link: "Charge should be linked to contract",
    be_charge_template_of_signed_contract_cannot_be_removed:
      "Charge of a signed Contract can not be removed",
    be_charge_template_of_signed_contract_cannot_be_updated:
      "Update is not possible, contract is already signed",
    be_no_contact_for_contract:
      "Contact for contract relations between this id's not found",
    be_no_event_agency_link: "Event is not related to your agency",
    be_no_version_token_in_app: "No version token in app config",
    be_not_allowed: "You are not allowed to do this",
    be_not_tenant: "Contact marked as main tenant is not tenant",
    be_password_required: "Password is required",
    be_password_invalid_pattern:
      "Password should contain 6 letters and consist of mixed letters and numbers.",
    be_password_does_not_match: "Passwords does not match",
    be_password_wrong: "Password is wrong",
    be_period_required: "Periods param is required",
    be_remove_property_with_units:
      "Property includes units and can't be removed",
    be_property_not_found: "Property is not found",
    be_remove_owner: "Contact owns properties and can't be removed",
    be_remove_self: "You can't remove yourself",
    be_owner_required: "Owner is required",
    be_remove_users_admins: "Users or admins can't be removed",
    be_server_error:
      "The server encountered a problem. Please try again later. Casadesk staff is notified by this problem.",
    be_token_already_used: "Token is already used",
    be_token_invalid: "Your session is expired.",
    insufficient_savings_balance: "Insufficient savings",
    charge_is_part_of_a_settlement_with_savings: "This charge is part of a settlement with savings",

    be_token_required: "Token is required",
    be_es_unknown_type: "Unknown type of elastic search index",
    be_unit_not_found: "Unit not found",
    be_unrecognized_action: "Unrecognized action",
    be_update_remove_signed_contract:
      "Signed contracts can't be updated or removed",
    be_user_id_required: "User id is required",
    be_user_not_found: "User not found",
    be_version_required: "Version is required",
    be_work_order_not_found: "Work order not found",
    be_contact_for_contract_missing_description:
      "If the Person type is Other, description field is required.",
    be_mt940_file_invalid:
      "The provided bank transaction does not comply with MT-940 standard.",
    be_unauthorized: "Unauthorized",
    be_disabled: "This feature is temporarily disabled.",
    be_charge_create_requires_at_least_one_relation:
      "Charge requires at least one relation.",
    be_charge_create_property_needs_person:
      "Property does not have a Person as an owner.",
    be_cannot_remove_charge_because_it_was_used_in_financial_statement:
      "Cannot delete charge because it's already been used in an owner statement",
    be_contract_cannot_end_charges_exist_in_financial_statement:
      "You can not end a contract because some charges were used in an owner statement. To end this contract first you need to delete an owner statement.",
    cannot_change_charge_because_it_was_used_in_financial_statement:
      "Can not change charge because it was used in an owner statement",
    cannot_change_payment_because_it_was_used_in_financial_statement:
      "Can not change payment because it was used in an owner statement",
    cannot_unlink_charge_because_it_was_used_in_financial_statement:
      "Cannot unlink charge because it's already been used in an owner statement",
    cannot_unlink_charge_because_financial_statement_locked:
      "Unlinking not possible. The charge was processed in a closed statement",
    cannot_unlink_payment_because_financial_statement_locked:
      "Unlinking not possible. The linked amount was processed in a closed statement",
    cannot_unlink_payment_because_it_was_used_in_financial_statement:
      "Cannot unlink payment because it's already been used in an owner statement",
    cannot_change_charge_class:
      "De nota klasse (te betalen, te ontvangen) kan niet worden gewijzigd. De klasse moet dezelfde zijn als de gekoppelde betaling.",
    payment_is_fully_used:
      "You fully used this payment. Please choose another one or create new payment",
    such_email_already_exist: "Such email is already exist",
    cannot_unlink_settle_payment: "Can not unlink settle payment",
    cannot_update_settle_payment: "Can not update settle payment",
    cannot_change_linked_object_in_automatically_created_charges:
      "Can not change linked object in automatically created charges",
    be_leave_company_not_allowed: "Admins and users cannot leave their agency",
    cannot_change_class_of_payment_that_already_linked_to_the_charge:
      "The class of the payment (received, paid) cannot by changed. The class must be the same as the linked charge.",
    cannot_remove_settled_payment:
      "Deletion not possible. Unlink and try again",
    cannot_remove_settled_charge: "Deletion not possible. Unlink and try again",
    cannot_remove_special_settlement_charge:
      "You can not delete this charge. This charge is a special settlement charge for the settlement of two payments. Go to one of the payments and unsettle them and charge will disappear.",
    cannot_remove_special_settlement_payment:
      "You can not delete this payment. This payment is a special settlement payment for the settlement of two charges. Go to one of the charges and unsettle them and payment will disappear.",
    cannot_remove_contract: "You can remove only concept contract or renewed",
    email_already_use: "This email address is already in use",
    cannot_pay_charge_with_different_type_of_payment:
      "To link a payable charge with a received payment, or a receivable charge with a paid payment, is not possible.",
    "cannot_create_charge_template_with_unsigned-contract":
      "Cannot create charge template with unsigned contract",
    "you-can-not-change-the-amount-for-a-charge":
      "You can not change the amount for a charge",
    "you-can-not-change-the-amount-for-a-payment":
      "You can not change the amount for a payment",
    cannot_settle_payment_with_equal_types:
      "Can not settle payment and charges with equal types",
    cannot_settle_settled_payment: "Can not settle settled payment",
    should_be_filled_one_of_the_fees_types:
      "Should be set one of the fees types",
    cannot_settle_payments_with_different_amount:
      "Can not settle payments with different amount",
    be_remove_tenant_with_contracts: "Can not remove tenant with contracts",
    cannot_unlink_payment_of_the_process_settle:
      "You can not unlink this payment. This payment is a special settlement payment for the settlement of two charges. Go to one of the charges and unsettle them and payment will disappear.",
    cannot_unlink_charge_of_the_process_settle:
      "This charge and payment can not be unlinked. They were created for the agency’s savings and are read-only. Go to the savings and remove the deposit or withdrawal there.",
    be_unit_number_exist: "Unit number already exist",
    this_company_have_a_property:
      "This company could not be removed. The company is an owner and has properties. Remove the properties first, or move the properties to another owner, and try again.",
    payment_charge_class:
      "To link a payable charge with a received payment, or a receivable charge with a paid payment, is not possible.",
    cannot_remove_finished_contract:
      "This contract cannot be removed as the end date was set. First remove the end date, then try again.",
    vat_less_than_amount: "VAT amount must be less than invoice amount",
    cannot_set_end_date_renewed:
      "The end date cannot be changed. This contract is already ended, or renewed.",
    contract_has_manual_charges:
      "The contract cannot be removed. This contract is linked to manually created charges, and/or charges are linked to manually created payments. Unlink these charges and try again.",
    contract_has_manual_payments:
      "The contract cannot be removed. This contract is linked to manually created charges, and/or charges are linked to manually created payments. Unlink these charges and try again.",
    financial_operations_were_blocked:
      "This feature is not available at this time because financial data is being updated. Please try again later.",
    forbid_remove_opened_activity:
      "This activity cannot be deleted because the the status is Open. First close the activity, then try again.",
    notification_period_warning:
      "Select a date which lies after the first date of the contract.",
    notification_rent_message: "Rent review",
    notification_adjust_rent_message: "Adjust the rent price",
    agency_fee_is_forbidden_to_remove_from_unit:
      "This agency fee cannot be removed. A unit needs at least 1 agency fee.",
    contract_forbidden_to_sign:
      "Cannot sign this contract. The basic rent price is missing in this contract or the agency fee is missing in the unit. Make sure the basic rent price and agency fee are in place, then try again.",
    agency_fee_template_first_day_restrictions:
      "Cannot update the first date for the agency fee. The first date for the agency fee must be equal to or before the first date of the contract for this unit",
    agency_fee_template_first_day_restrictions_2:
      "Cannot update the first date for agency fee charges because the first agency charge has already been created.",
    be_account_number_exist:
      "The bank account cannot be saved. The bank account number is already in use. Update the bank account number and try again.",
    payment_link_fee_charges:
      "No unpaid agency fee charges were found. The payment remains available. Try again later.",
    cannot_change_charge_class_in_auto:
      "The charge was not saved. The charge class (payable, receivable) cannot be changed for an automatically created charge. Delete this charge and create a new charge manually.",
    agency_fee_for_this_object_already_exist:
      "The agency fee template cannot be created. The unit already has an agency fee template.",
    cant_create_unit_without_rent_template_and_agency_fee_template:
      "The unit could not be created. Agency fee is missing. Please add the missing details and try again.",
    description_not_valid: "Value too large",
    cant_create_contract_without_rent_template:
      "The contract cannot be created. A charge template for the basic rent is missing. Add this charge template and try again.",
    locked_charge_update_forbidden:
      "This charge cannot be updated. The charge was part of an invoice that was made final.",
    payout_charge_update_forbidden:
      "This payout charge cannot be updated. It is automatically created and updated by the system.",
    locked_charge_remove_forbidden:
      "The charge cannot be deleted. It is part of an invoice which was made definitive. Create a credit charge to reverse this charge.",
    payout_charge_remove_forbidden:
      "This payout charge cannot be remove. It is automatically created and updated by the system.",
    invoice_creation_forbidden_date:
      "The creation of an invoice is forbidden, because the first date of statement is before of activation invoice date",
    such_email_already_exists: "This email address is already in use",
    savings_forbid_unlink:
      "This charge and payment can not be unlinked. They were created for the agency’s savings and are read-only. Go to the savings and remove the deposit or withdrawal there.",
    savings_forbid_unsettle:
      "The payment details cannot be updated because the payment was registered for the savings.",
    amount_will_be_less_then_zero:
      "It is not possible to withdrawal an amount.",
    zero_amount:
      "A withdrawal is not possible. The amount is not valid. Change the amount and try again.",
    mt_upload_only:
      "This file cannot be processed. This is not a MT940 file. Select a MT940 file and try again.",
    be_user_with_such_email_exists: "This email address is already in use",
    withdraw_impossible: "There are no savings at this time.",
    forbidden_to_settle_payout:
      "The selected charges cannot be settled with each other. An owner statement settlement charge can only be settled with another owner statement settlement charge.",
    update_first_date_to_past_is_forbidden_charge_template:
      "Change first date to today or later",
    email_has_not_be_sent: "The email was not sent. An error occurred.",
    email_has_not_be_sent_max_size:
      "The email was not sent. The email is too big.",
    invoice_creation_forbidden: "Invoice already exists",
    invoice_creation_forbidden_credit:
      "Invoicing not possible. Original charge is not an invoice.",
    forbid_create_charge_whithout_counter_party:
      "Charge not created. Missing counterparty",
    payout_charge_unsettle_forbidden:
      "The payout charge cannot be unsettled, it was invoiced",
    forbidden_remove_transaction: "A bank transaction cannot be removed",
    no_payouts_in_owner_statement:
      "No invoice created. The statement has no amount to settle.",
    unverified_payments_in_statement:
      "Statement cannot be closed. One or more payments were not yet reviewed",
    expiration_date_is_invalid:
      "The expiration notification must be in the future",
    be_charge_not_found: "Charge not found",
    general_contact_id_required: "Required field",
    cannot_change_statement_period_for_automatically_created_charge_before_start_date:
      "The statement period cannot be before the financial start date",
    "cannotpaycharge-info/bankaccountmissing":
      "Bank account missing. Please add the property management bank account in: Settings | Agency profile",
    invoice_creation_forbidden_before_previous:
      "The owner statement could not be created. First finish the owner statement for previous period and try again.",
    can_not_make_savings_action: "The charge is already fully settled",
    use_remove_from_savings:
      "Not possible to remove; part of a settlement with savings",
    can_not_use_undo_with_not_savings_entity:
      "No settlement with savings found",
    can_not_make_savings_for_fully_used_payment:
      "The payment is already fully used",
    email_address_required: "Email address required",
    mobile_phone_required: "Mobile phone required",
    mobile_phone_invalid:
      "Valid phone number: 0612345678, or the international format: +31612345678",
    cannot_unlink_overpaid_charge_from_refunded_payment:
      "The payment and charge cannot be unlinked. Undo the refund and try again.",
    cannot_remove_refunded_payment:
      "The payment cannot be removed. Undo the refund and try again.",
    cannot_unlink_refunded_payment_from_overpaid_charge:
      "The charge cannot be removed. Undo the refund and try again.",
    cannot_remove_refund_charge:
      "The charge cannot be removed. Undo the refund and try again",
    forbidden_update_removed_charges:
      "Is is not possible to update a deleted object",
    cannot_refund_payment_without_counterparty:
      "Link the counterparty in the payment and try again.",
    only_refunded_charge_can_be_unrefunded:
      "To undo the refund is not possible. A refund was not found.",
    cannot_remove_contract_with_locked_charges:
      "This contract cannot be deleted. One or more charges linked to this contract are locked. Charges are locked when, for example, they are part of a locked invoice.",
    cannot_change_generalcontactid_if_company_is_tenant:
      "This person cannot be removed. The person is the main contact for one or more contracts.",
    account_recently_synchronized: 
      "The latest bank transactions were already fetched during the last 30 minutes. Try again later.",
    be_remove_property_with_not_deletable_units:
      "The property cannot be deleted. One or more units still have an active contract or agreement.",
    be_unit_cannot_be_deleted_due_to_active_contracts_and_agreements:
      "The unit cannot be deleted. There is still an active contract or agreement.",
    readonly_payment_update_forbidden:
      "Cannot update the payment. This payment is read only.",
    readonly_charge_update_forbidden:
      "Cannot update the charge. This charge is read only.",
    statement_period_could_not_be_older_than_4_years:
      "The statement period can not be older than 4 years",
    statement_period_could_not_be_before_financial_start_date:
      "The statement period cannot be before the financials start date: :financialStartDate",
    cannot_unlink_payment_from_paid_directly_to_owner_charge:
      "The payment cannot be unlinked from directly paid charge",
    cannot_remove_paid_directly_to_owner_charge:
      "The payment cannot be removed because the linked charge is directly paid",
    cannot_remove_payment_related_to_paid_directly_to_owner_charge:
      "The charge cannot be removed because it was directly paid",
    cannot_credit_fully_settled_charge: "Cannot credit fully settled charge",
    forbidden_to_remove_agency_fee_with_active_charges:
      "This agreement cannot be removed because charges exist for this agreement. Remove those charges and try again.",
    forbidden_to_change_expiration_date_while_contract_renewing:
      "Forbidden to change expiration date while contract renewing",
    cannot_remove_credit_charge:
      "This charge is read-only and can therefor not be removed or updated.",
    cannot_undo_credit_which_was_settled_with_savings:
      "This charge is read-only and can therefor not be removed or updated.",
    cannot_credit_charges_with_system_types:
      "Credit not possible. The charge was created by the system",
    cannot_credit_charges_which_was_settled_with_savings:
      "Credit is not possible. First, undo the settlement with savings.",
    cannot_credit_payout_without_invoice_amount:
      "Credit not possible. The owner statement has no invoiced amount",
    credit_amount_for_payouts_can_not_be_bigger_than_invoice_amount:
      "Credit not possible. The credit amount is larger than the invoiced amount",
    forbidden_to_uncredit_locked_charges:
      "Credit not possible. The charge is part of a closed statement",
    credit_amount_is_larger_than_invoiced_amount:
      "Credit not possible. The credit amount is larger than the invoiced amount",
    cannot_process_file_with_transactions_length_greater_than_250:
      "Bank transactions not processed. Please upload a file with a maximum of 250 transactions.",
    archived_unit: "Not allowed. The unit is archived",
    no_previous_contract: "No previous contract found",
    forbidden_settle_with_savings_fully_paid_charge:
      "The amount cannot be settled with savings",
    last_bank_account_cannot_be_deleted:
      "Delete not allowed. A minimum of one bank account is necessary.",
    default_bank_account_should_be_present:
      "Update not allowed. A minimum of one default bank account is necessary",
    cannot_credit_charge_with_amount_zero:
      "Credit not possible. The credit amount must be more than 0.",
    something_went_wrong: "Something went wrong from ponto side",
    no_supported_accounts: "Accounts are not supported",
    cannot_archive_unit:
      "There is still an active agreement or contract. Please allow the agreement or contract to end first before archiving this unit.",
    cannot_extend_contract_for_not_later_date:
      "The new date must be later than the previous contract date",
    cannot_create_charge_with_counterparty_object_owner:
      "Charge not created. Landlord cannot pay himself.",
    forbidden_settle_with_savings_not_locked_payout_charges:
      "Close the owner statement to settle this charge.",
    cannot_renew_the_contract:
      "Select a different start date. The contract cannot be renewed for periods with charges that are already locked. Charges become locked when they are part of a statement that is closed.",
    "is-impossible-to-make-a-table": "No charges found",

    //Agency statements
    savings_account: "Savings acccount",
    deposited_title: "Deposited to savings",
    deposited_row_description: "Total deposited",
    withdrawn_title: "Withdrawn from savings",
    withdrawal_row_description: "Total withdrawn",
    "button-withdrawal-agency-statement": "Withdrawal",
    agency_charges_title: "Agency charges",
    agency_charges_already_pay_title: "Agency charges that already paid",

    //Special default error message for fields
    maxlength: "Value too large",
    minlength: "This field is mandatory",
    minitems: "This field is mandatory",
    date_can_be_up_to_2_months:
      "This date can be up to 1 year in the past or future.",
    format: "This field is mandatory",

    /*
    |  Frontend Errors
    */

    "wrong-file-type":
      "Wrong file format. You can upload only .jpg, .jpeg, .bmp, .png, .doc, .docx, .pdf files.",
    "wrong-file-type-logo":
      "Wrong file format. You can upload only .jpg, .jpeg, .png",
    "wrong-file-size": "File size is bigger than maximum allowed value",
    "no-statement-for-this-month":
      "There is no statement for this month. Please, choose another month.",
    "note-can-not-be-longer-than-255":
      "Note can note be longer than 255 symbols.",
    "this-field-is-not-valid": "This field is not valid",
    "check-internet-try-again":
      "Please check your internet connection and try again",
    "memo-can-not-be-longer-than-255":
      "Memo can note be longer than 255 symbols.",
    "error-response-is-undefined":
      "A usual response from the server was missed. Perhaps the internet connection is not great.",
    "error-response-contains-no-message":
      "Server responded without any messages",
    "error-no-results": "No results",
    "error-no-selected-tenant": "Please select a tenant first.",
    "error-this-field-is-required": "This field is required",
    "error-label-contactperson": "contact",
    "error-label-user": "user",
    "label-contactid": "Contact",
    "error-label-company": "company",
    "error-notvaliddatata-agencyfee":
      "The contract cannot be created. The agency fee has one or more invalid values. Please adjust the agency fee and try again.",
    "error-already-use-bank-account":
      "This bank account is already used for :displayName ",
    "error-notvaliddatata-chargetemplate":
      "Error in a charge template: <:field>. Please correct and try again.",
    "error-notvaliddatata-chargetemplate-coach":
      "Error in a contract amount: <:field>. Please remove and try again.",
    "error-notvaliddatata-agencyfeeunit":
      "Error in a agency fee: <:field>. Please correct and try again.",
    "error-attachment-download-response-was-failed":
      "Download is not possible at this time due some technical issue. Please try again later.",
    "memo-can-not-be-updated": "Memo cannot be updated",
    "label-chargetypeids": "Charge types",
    "agreement-cannot-be-removed-because-of-locked-charges":
      "This agreement cannot be removed. A charge for the period :firstDate - :lastDate is part of an already closed owner statement. Set the end date to :lastDate to end this agreement.",
    cannot_credit_credit_charge: "A credit charge cannot be credited",
    cannot_credit_credited_charge: "This charge is already credited",
    cannot_credit_payout_charge:
      "Payout charges cannot be credited. Credit individual charges.",

    /*
    | Aplication start page
    */

    "application-starting-notice": "Starting",
    "application-crashed": "Crashed",
    "application-crashed-notice":
      "We're sorry but the application crashed. Please go back to the Sign In page.",

    /*
    | Settings page - agency profile tab
    */

    "agency-profile-agency-name": "Name",

    /*
    API calls
    */

    "api-requst-confirm-email-sent":
      "Confirmation email has been sucessfully sent.",
    "invite-email-sent": "Invite email has been sucessfully sent.",
    "reset-email-sent": "Reset email has been sucessfully sent.",

    //Default
    "show-more-notifications": "Show :amount more notifications",
    "show-less-notifications": "Show less notifications",
    "save-changes": "Save changes",
    "are-you-sure": "Are you sure?",
    "coach/close-subtitle": "Any provided information will be lost",
    "warning-data-may-be-lost": "All changes you made will be lost.",
    "warning-data-are-lost": "All changes you made are lost.",
    "warning-templates-may-be-lost": "You did not save the last rent price",
    "warning-confirm-delete": "You're about to delete an entity. Are you sure?",
    "contact-person-remove-dialog":
      "You're about to delete the person. Are you sure?",
    "contact-company-remove-dialog":
      "You're about to delete the company. Are you sure?",
    "charge-unsettle-from-charge-page-content-dialog":
      "You're about to unsettle the charge. Are you sure?",

    //Archive
    "warning-confirm-archive-title": "You are about to archive this unit",
    "warning-confirm-archive-text":
      "Archive a unit when you no longer manage it. If the unit is only not available temporarily, then choose that option and do not archive. ",
    "warning-confirm-archive1": `When archived:`,
    "warning-confirm-archive2": `- No more rent charges created`,
    "warning-confirm-archive3": `- No more agency fee charges created`,
    "warning-confirm-archive4": `- The unit is no longer presented in the unit list (although you’ll still be able to find the unit when you search for it, as well as in the owner’s details page`,
    //Agency modal

    "charge-unlink-from-payment-page-content-dialog":
      "You're about to delete the charge. Are you sure?",
    "charge-unlink-from-charge-page-content-dialog":
      "You're about to delete the payment. Are you sure?",
    "attachment-remove-page-content-dialog":
      "You're about to delete the attachment. Are you sure?",
    "charge-remove-from-property-page-content-dialog":
      "You're about to delete the charge. Are you sure?",
    "file-remove-from-bank-transactions-page":
      "You are about to remove the bank transaction file. All payments will be removed. Any charges linked to the payments become unpaid again. Continue?",
    "unit-remove-from-property-detail-page":
      "You're about to delete the unit. Are you sure?",
    "agency-fee-remove-from-settings-page":
      "You're about to delete the agency fee. Are you sure?",

    //Charges
    "charge-unlink-info":
      "The charge will be unlinked from the payment. After unlinking the charge becomes - partially - unpaid and the payment becomes available again to pay another charge. Are you sure?",

    /* NEW TRANSLATION */

    /*
    | Drop down fields for objects
    */

    "dropdown-searchforproperty-label": "Select for property",
    "dropdown-searchforaddress-label": "Select for address",
    "dropdown-property-notfound": "No property found.",
    "dropdown-button-new-property": "Add property",
    "dropdown-searchforowner-label": "Search for owner",
    "dropdown-searchforlandlord-label": "Search for landlord",
    "dropdown-searchlandlord-label": "Search landlord",
    "dropdown-searchforowner-label2": "Search for owner",
    "dropdown-owner-notfound":
      "No owner found. Click 'New owner' and create a new one",
    "dropdown-button-new-owner": "New owner",
    "dropdown-tenant-label": "Search for tenant",
    "dropdown-searchforperson-label": "Search for person",
    "dropdown-selectperson-label": "Select person",
    "dropdown-selecttenant-label": "Select tenant",
    "dropdown-additional-person-label": "Search for person",
    "dropdown-searchformanager-label": "Search for caretaker",
    "dropdown-searchforcompany-label": "Search for company",
    "dropdown-searchforunit-label": "Select a unit",
    "dropdown-manager-notfound":
      "No caretaker found. Click 'New caretaker' and create a new one",
    "dropdown-person-notfound":
      "No person found. Click 'New person' and create a new one",
    "dropdown-unit-notfound":
      "No unit found. Click 'New unit' and create a new one",
    "dropdown-tenant-notfound":
      "No tenant found. Click 'New tenant' and create a new one",
    "dropdown-company-notfound":
      "No company found. Click 'New company' and create a new one",
    "dropdown-button-newmanager": "New caretaker",
    "dropdown-person-label": "Person",
    "dropdown-company-label": "Company",
    "dropdown-property-label": "Address",
    "dropdown-unit-label": "Unit",
    "dropdown-owner-label": "Owner",
    "dropdown-owner-label2": "Owner",
    "dropdown-landlord-label": "Landlord",
    "dropdown-owner-landlord": "Landlord",
    "dropdown-manager-label": "Caretaker",
    "dropdown-button/newtenant": "New tenant",
    "dropdown-button/newcounterparty": "New counterparty",

    //General label
    "generalsearch-label": "Search Casadesk",

    // Charge for ( object...)
    "page/banktransactionupdate-section/charge-tab/newcharge-field/object-label":
      "Charge for (contract, company, unit or property)",
    "page/banktransactionupdate-section/charge-tab/existingcharge-field/object-label":
      "Search for object (contract, company, unit or property)",
    "page/chargecreate-section/charge-field/object-label":
      "Charge for (contract, company, unit or property)",
    "page/chargecreate-section/invoice-field/object-label":
      "Invoice for (contract, company, unit or property)",
    "page/chargesettle-section/charge-tab/newcharge-field/object-label":
      "Charge for (contract, company, unit or property)",
    "page/chargeupdate-section/charge-field/object-label":
      "Charge for (contract, company, unit or property)",
    "page/chargeupdate-section/invoice-field/object-label":
      "Invoice for (contract, company, unit or property)",
    "page/paymentcreate-section/charge-tab/newcharge-field/object-label":
      "Charge for (contract, company, unit or property)",
    "page/paymentcreate-section/charge-tab/existingcharge-field/object-label":
      "Search for object (contract, company, unit or property)",
    "page/paymentupdate-section/charge-tab/newcharge-field/object-label":
      "Charge for (contract, company, unit or property)",
    "page/paymentupdate-section/charge-tab/existingcharge-field/object-label":
      "Search for object (contract, company, unit or property)",
    "dropdown-chargeobject-notfound": "Nothing found",
    "dropdown/activity-field/object-label": "Activity for unit",
    "coach/credit-label/object":
      "Find charge for (contract, company, unit or property)",
    "dialog/chargecreate-popup/rentcharge-info":
      "Use the option ‘Create next rent charge’ on the contract page. Or click Continue if this is a special one time rent charge",

    // Charge classes
    "charge-class-receivable": "To receive from",
    "charge-class-payable": "To pay to",
    "charge-class-invoice": "Invoice received from",

    /*
    | Payment section (payment details) use in Payment create, Payment update, Charge create, Payment settle, Charge update.
    */
    // Payment classes
    "payment-class-received": "Received from",
    "payment-class-paid": "Paid to",

    /*
    | Settings
    */
    /* agency profile */
    "page/settings-tab/agencyprofile-section/financialstartdate-info/financialstartdate1":
      "Select the start date for the owner statements.",
    "page/settings-tab/agencyprofile-section/financialstartdate-info/financialstartdate2":
      "Charges and payments with a date before the start date are not being included in the owner statements. The start date can only be updated by an admin user.",
    "page/settings-tab/agencyprofile-section/financialstartdate-title":
      "Start date owner statements",
    "page/settings-tab/agencyprofile-section/financialstartdate-subtitle":
      "From the selected date on Casadesk will automatically create the owner statements",
    "page/settings-tab/agencyprofile-section/financialstartdate-datepicker-label/financialstartdate":
      "Select start date",
    "page/settings-tab/agencyprofile-section/financialstartdate-button/savefinancialstartdate":
      "Save",
    "page/settings-tab/agencyprofile-postprocess/financialstartdateisbusy":
      "The provided start date is being processed. Until finished, no new start date can be set.",
    "dialog-agencyisbusy":
      "This feature is not available at this time because financial data is being updated. Please try again later.",
    "page/settings-tab/agencyprofile-section/statementssettings-title":
      "Emails",
    "page/settings-tab/agencyprofile-section/statementssettings-subtitle":
      "Default email texts, send copy, review,…",
    "page/settings-tab/agencyprofile-section/invoiceactivationdate-title":
      "Switch on invoicing",
    "page/settings-tab/agencyprofile-section/invoiceactivationdate-subtitle":
      "Create the invoice for a concept owner statement",
    "page/settings-tab/agencyprofile-section/invoiceactivationdate-datepicker-label/invoiceactivationdate":
      "Select period start",
    "page/settings-tab/agencyprofile-section/invoiceactivationdate-info":
      "After activating the invoicing it is for every user possible to create an invoice for the owner statement. Such an invoice is final and cannot be undone.",
    "page/settings-tab/agencyprofile-section/invoiceactivationdate-button/saveinvoiceactivationdate":
      "Save",
    "page/settings-tab/agencyprofile-section/invoiceactivationdate-info/preprocess":
      "You are about to set the start date for the financial statements. After you set this date, you cannot change it anymore.",

    /* charge types */
    "page/settings-tab/chargetypes-label": "Charge types",
    "page/settings-tab/chargetypes-section/chargetypes-title": "Charge types",
    "page/settings-tab/chargetypes-section/chargetypes-button/addchargetype":
      "Add charge type",
    "page/settings-tab/chargetypes-section/chargetypes-dialog/deletechargetype-title":
      "Delete charge type",
    "page/settings-tab/chargetypes-section/chargetypes-dialog/deletechargetype-info":
      "The type will no longer be available for new charges. Existing charges are not changed, they will keep this type.",

    /* activity templates */
    "page/settings-tab/activitytemplates-switcher/activateactivities-label":
      "Activate activities",
    "page/settings-tab/activitytemplates-hint/foradmin-1":
      "By creating activities you allow a user to create multiple tasks with 1 click . For example, use an activity to create the tasks related to a check in.",
    "page/settings-tab/activitytemplates-hint/foradmin-2":
      "After activation activities become available in the dashboard and at each unit. Instruct users when to use them.",

    /*
    | Payment update page.
    */
    "page/paymentupdate-section/charge-button/anothercharge":
      "Add another charge",

    /*
    | Unit create/update page.
    */
    "page/unitcreate-unitnumber-info":
      "You may skip the unit number field if the location only contains 1 rental unit.",

    /*
    | Dialogs
    */
    "dialog-signup-post-process-info1":
      "The Casadesk environment for :agencyname is now ready to use.",
    "dialog-signup-post-process-info2":
      "Note: Confirm your email address by clicking the link in the message we sent to :email",
    "dialog-add-agency-fee-subtitle":
      "Each month an agency fee charge is created based on this information",
    "dialog/preprocess-editaddress/title": "Update address",
    "dialog/preprocess-editaddress/info":
      "Could the exact address specification not be found (for example the house number extension is missing)? Then correct it here.",
    /* Task edit */
    "dialog/edittask-info/couldnteditfinishedtask":
      "You couldn't edit finished task",

    /* Entity names */
    company: "Company",
    contract: "Contract",
    person: "Person",
    property: "Property",
    unit: "Unit",
    agency: "Agency",
    owner: "Owner",
    object: "Object",
    tenant: "Tenant",
    charge: "Charge",
    invoice: "Invoice",

    /*
   | Company create page
   */
    "page/companycreate-companyname-info":
      "Is the owner a person and not a company? Than just enter a fictitious company name like 'Peterson rentals'.",

    /*FINANCE*/
    "page/finance-tab/banktransactions-filestatusfailed": "Failed",

    /* Unit update page */
    "menuitem-process-payment": "Process payment",
    "unitupdate-title": "Unit",
    "unitupdate-section/active-status": "Unit is temporarily not available",
    "unitupdate-section/archive-status": "This unit is archived",
    "unitupdate-section/active-button/activate": "Available again",
    "unitupdate-tab/info": "Info",
    "unitupdate-tab/finance": "Finance",
    "unitupdate-tab/contracts": "Contracts",
    "unitupdate-tab/settings": "Settings",
    "unitupdate-tab/agreements": "Agreements",
    "unitupdate-tab/info-field/unitnumber-label": "Unit Number",
    "unitupdate-tab/info-field/unittype-label": "Unit Type",
    "unitupdate-tab/info-field/unitservicestatus-label": "Unit service status",
    "unitupdate-tab/info-field/squaremeters-label": "Square meters",
    "unitupdate-tab/info-field/rooms-label": "Rooms",
    "unitupdate-tab/info-field/separatebedrooms-label": "Separate bedrooms",
    "unitupdate-tab/info-field/bathrooms-label": "Bathrooms",
    "unitupdate-tab/info-field/publicationtitle-label": "Publication title",
    "unitupdate-tab/finance-radiobutton/all": "All",
    "unitupdate-tab/finance-radiobutton/unpaid": "Unpaid",
    "unitupdate-dialog/warning-info/cannotmakechanges":
      "You can not make changes when unit is not active",
    "unitupdate-dialog/postprocess-info/deletedcharge":
      "Charge was deleted. You can find payments which were linked to this charge in Finance -> Payments",
    "page/unitupdate-section/agencyfee-info/defaultagencyfeesnotfound":
      "No agency fees found",
    "page/unitupdate-dialog/agencyfee-title": "Agency fee details",
    "page/unitupdate-section/agencyfee-info/inheritedfrom":
      "The agency fee settings inherited from the",
    "page/unitupdate-section/info-changeunitservicestatus/dialoginfomanaged":
      "Service status is set to Managed. Charges will be created automatically for this unit.",
    "page/unitupdate-section/info-changeunitservicestatus/dialoginactive":
      "Service status is set to Inactive. Charges will stop to be created automatically for this unit.",
    "page/unitupdate-section/info-changeunitservicestatus/dialogtitle":
      "Service status update",
    "page/unitupdate-section/info-changeunitservicestatus/label": "Service",
    "page/unitupdate-section/info-agreement/subtitle":
      "The service arrangement agreed with the owner",
    "page/unitupdate-section/settings/charge-template/title":
      "New rental contract",
    "page/unitupdate-section/settings/charge-template/subtitle":
      "Default rent amounts for new rental contracts",
    "page/unitupdate-section/settings/agreement/title": "New agreement",
    "page/unitupdate-section/settings/agreement/subtitle":
      "Default values for new management agreements",
    "page/unitupdate-section/settings/general/title": "General",
    "page/unitupdate-section/settings/general/sub-title":
      "The administration fee is being added to the service costs (available in the settlement coach of the unit)",
    "page/unitupdate-section/settings/charge-template/add-button":
      "New rent amount",
    "page/unitupdate-section/settings/charge-template/no-charge-templates-found":
      "No default rent amounts found",

    // Universal (used throughout the application)
    "field/optional": " (optional)",

    /* General buttons */
    "page/entity-button/cancel": "Cancel",
    "page/entity-button/done": "Done",
    "page/entity-button/save": "Save",
    "section/balance-button/newcharge": "New charge",
    "section/balance-button/showmore": "Show more",
    "section/balance-button/showless": "Show less",
    "dialog-button/cancel": "Cancel",
    "dialog-button/save": "Save",
    "dialog-button/create": "Create",
    "dialog-button/close": "Close",
    "dialog-button/newproperty": "New unit",
    "dialog-button/creating": "Creating...",
    "dialog-button/saving": "Saving...",
    "dialog-button/change": "Change",
    "dialog-button/skip": "Skip",
    "page/entity-button/create": "Create",
    "page/entity-button/creating": "Creating...",
    "dialog-button/continue": "Continue",
    "dialog-button/finish": "Finish",
    "dialog-button/yes": "Yes",
    "dialog-button/no": "No",
    "dialog-button/selectmt940file": "Select MT940 file",
    "dialog/renewcontract-button/continue": "Continue",
    "dialog/renewcontract-button/cancel": "Cancel",
    "dialog/sendemail-button/donotcancel": "Do not cancel",
    "dialog-button/back": "Back",
    "dialog-button/pay": "Pay",
    "dialog-button/send": "Send",
    "dialog-button/replace": "Replace",
    "dialog-button/reuse": "Reuse",
    "dialog-button/addoneunit": "Add a unit",
    "dialog/createtask-button/finish": "Finish",
    "dialog-button/newrealestate": "Register first property",

    /* Dialog charge type */
    "dialog/chargetype-button/newchargetype": "New type",
    "dialog/chargetype-title": "Charge type",
    "dialog/chargetype-field/chargetypename-label": "Charge type name",
    "dialog/chargetype-field/chargeclassname-label": "Charge type class",

    // 3-dot menu (menuitems)
    "menu/charge-option/edit": "Edit",
    "menu/charge-option/pay": "Pay",
    "menu/charge-option/settle": "Settle",
    "menu/charge-option/unsettle": "Unsettle",
    "menu/charge-option/remove": "Remove",
    "menu/agencyfee-option/remove": "Remove",
    "menu/agencyfee-option/edit": "Edit",
    "menu/defaultunitchargetemlpate-option/remove": "Remove",
    "menu/defaultunitchargetemlpate-option/edit": "Edit",
    "menu/payment-option/edit": "Edit",
    "menu/payment-option/pay": "Pay",
    "menu/payment-option/settle": "Settle",
    "menu/payment-option/unsettle": "Unsettle",
    "menu/payment-option/remove": "Remove",
    "menu/payment-option/unlink": "Unlink payment",
    "menu/payment-option/unrefund": "Undo refund",
    "menu/charge-option/unlink": "Unlink charge",
    "menu/charge-option/unrefund": "Undo refund",
    "menu/user-option/view": "View",
    "menu/attachment-option/setavatar": "Main image",
    "menu/status-option/open": "Reopen",
    "menu/status-option/close": "Close",
    "menu/attachment-option/download": "Download",

    // Contract, unit, property balance keys. These keys are used for sections that present a balance in various places (for example: unit update page on tab finance)
    "section/balance-info/renewdate": "Renew date",
    "section/balance-info/chargesforcontractnotfound":
      "No charges yet. Click the button 'New Charge' and start adding charges to your Casadesk system.",
    "section/balance-info/chargesforunitnotfound":
      "No charges yet. Click the button 'New Charge' and start adding charges to your Casadesk system.",
    "section/balance-info/chargesforpropertynotfound":
      "No charges yet. Click the button 'New Charge' and start adding charges to your Casadesk system.",
    "section/balance-info/chargesforcompanynotfound":
      "No charges yet. Click the button 'New Charge' and start adding charges to your Casadesk system.",
    "section/balance-info/chargesforactivitynotfound":
      "No charges yet. Click the button 'New Charge' and start adding charges to your Casadesk system.",
    "section/balance-title/balanceforunit": "Balance for unit",
    "section/balance-title/balanceforcontract": "Balance for contract",
    "section/balance-chargestatus/unpaid": "Unpaid",
    "section/balance-info/chargesbeforestartdatenotpresented":
      "Charges before the financial start date :startDate are not presented",

    // Balance dialogs
    "section/balance-dialog/preprocess-info/deletecharge":
      "You're about to delete the charge. Are you sure?",
    "section/balance-dialog/preprocess-info/unsettlecharge":
      "You're about to unsettle the charge. Are you sure?",

    // Default charge templates section
    "section/defaultunitchargetemplates-title":
      "Default unit prices (for new contracts)",
    "section/defaultunitchargetemplates-button/newprice": "New price",
    "section/defaultunitchargetemplates-info/pricenotfound":
      "No prices yet. Click the button 'New Price' and start adding prices to your Casadesk system.",
    "section/defaultunitchargetemplates-unitupdate/settings-title":
      "Default charges contract",
    "section/defaultunitchargetemplates-unitupdate/settings-subtitle":
      "These charges are automatically added to a new contract",

    // Default charge templates dialog
    "dialog/defaultchargetemplatesdetails-title": "Default rent amount",
    "dialog/newdefaultchargetemplates-title": "Default rent amount",
    "dialog/chargetemplatesdetails-title": "Charge template",
    "dialog/newchargetemplates-title": "New charge template",
    "dialog/contractitemdetails-title": "Contract amount",
    "dialog/newcontractitems-title": "New contract amount",
    "dialog/defaultchargetemplates-field/duedatepayment-label":
      "Due date payment",
    "dialog/defaultchargetemplates-field/duedatefirstpayment-label":
      "Due date for first payment",
    "dialog/defaultchargetemplates-field/firstdate-label":
      "Create the first charge on or after",
    "dialog/defaultchargetemplates-field/enddate-label": "End date",
    "dialog/defaultchargetemplates-field/description-label": "Description",
    "dialog/defaultchargetemplates-field/amount-label": "Аmount",
    "dialog/defaultchargetemplates-field/currency-label": "Currency",
    "dialog/defaultchargetemplates-field/type-label": "Type",
    "dialog/defaultchargetemplates-field/period-label": "Repeat period",
    "dialog/defaultchargetemplates-field/paymentoffset-label": "Payment offset",
    "dialog/defaultchargetemplates-field/paiddirectlytoowner-label":
      "Owner receives payments direct from tenant",
    "dialog/chargetemplate-info1":
      "Based on this charge template a charge is created.",
    "dialog/defaultchargetemplate-info1":
      "This default contract amount will automatically be applied in any new rental contract for this unit",
    "dialog/preprocess-endchargetemplate-info1":
      "Set the last day for which a charge should be paid.",
    "dialog/preprocess-endchargetemplate-info2":
      "Note: manually remove charges that might already have been created for the period after the last day.",
    "dialog/defaultchargetemplates-label/collate":
      "Do not merge with other charges",
    "dialog/chargetemplatecreate-hasdifferentispaiddirectlytoowner/info":
      "Some contract prices are to be directly paid to the owner, some not. Note that after signing the contract a change in these settings can only be applied by creating a new contract.",
    "dialog/chargetemplatereadonly-info":
      "Read-only: the contract is signed; updates by creating a new contract.",
    "dialog/preprocess-info/deletechargetemplate":
      "You're about to delete the charge template. Are you sure?",

    // Agency fees section
    "section/agencyfee-title": "Agreement",
    "section/agencyfee-button/agreement": "New agreement",
    "section/agencyfee-button/newagencyfee": "New agency fee",
    "section/agencyfee-info/defaultagencyfeesnotfound": "No agency fees found",
    "section/agencyfee-info/agreementsnotfound": "No agreements found",

    "section/agencyfee-info/inheritedfrom":
      "The agency fee settings inherited from the",
    "section/agencyfee-subtitle/default": "Default agency fee",
    "section/agencyfee-subtitle/defaultfornewunits":
      "Set the default agreement values",
    "section/agencyfee-table-title": "Default agreement settings",
    "address/default-agreement-subtitle":
      "Default agreement settings for units at this address",

    //Agency fee dialog
    "dialog/agencyfee-title": "Agency fee",
    "dialog/agreement-title": "Agreement",
    "dialog/agencyfee-subtitle": "Default agency fee setting for :entity",
    "dialog/agencyfee-info":
      "Each month an agency fee charge is created based on the information provided below.",
    "dialog/agencyfee-info/amount":
      "The agency fee is the amount including the VAT",
    "dialog/agencyfee-info/fixedfee":
      "For each rent charge an agency fee charge is created with this fixed amount.",
    "dialog/agencyfee-info/percentagefee":
      "The percentage is applied on the amounts of the active contract, or on the default rent amounts if there is no active contract available.",
    "dialog/agencyfee-info/chargetypes":
      "The percentage is calculated over the selected amount types.",
    "dialog/agencyfee-field/fixedfee-label": "Fixed monthly fee",
    "dialog/agencyfee-field/fixedfee-sub-label":
      "Percentage administration fee",
    "dialog/agencyfee-field/newagency-fixedfee-label": "Fixed fee",
    "dialog/agencyfee-field/percentagefee-label": "Percentage of the rent",
    "dialog/agencyfee-field/newagency-percentagefee-label":
      "Variable fee, percentage of the rent",
    "dialog/agencyfee-field/fixedpluspercentagemode-label":
      "Fixed and/or percentage",
    "dialog/agencyfee-field/currency-label": "Currency",
    "dialog/agencyfee-field/vat-label": "VAT amount",
    "dialog/agencyfee-field/vatpercentage-label": "VAT percentage",
    "dialog/agencyfee-radio/dates-hint": "Date a which compensation fees start",
    "dialog/agencyfee-field/firstdate-label": "Specific date",
    "dialog/agencyfee-field/firstdate-radiobutton": "specific date",
    "dialog/agencyfee-field/startfromcontractdate-label":
      "first day of the next new contract",
    "dialog/agencyfee-field/lastdate-label":
      "Last day to create an agency fee for",
    "dialog/agencyfee-field/chargetypes-label": "Charge types",
    "dialog/preprocess-info/agencyfee":
      "You're about to delete the agency fee. Are you sure?",
    "dialog/remove-contract": "The agreement will be deleted. Are you sure?",
    "dialog/postprocess-info/agencyfeeupdate":
      "Changes are saved. These changes apply to new agency fee charges that are created monthly.",
    "dialog/preprocess-endagencyfee-info1":
      "Set the last day for which the owner should be charged an agency fee. Any agency charge fees already created for the period after the end date should be removed manually.",

    /*
    | Banktransaction page.
    */
    "page/banktransaction-section/charge-correctcharge-button":
      "Charge correct",
    "page/banktransaction-section/charge-incorrectcharge-button":
      "Charge incorrect",
    "page/banktransaction-section/charge-correctcharges-button":
      "Charges correct",
    "page/banktransaction-section/charge-incorrectcharges-button":
      "Charges incorrect",
    "page/banktransaction-section/title-transactionscount":
      "Check transactions :current of :total",
    "page/banktransaction-section/title-transactioncount":
      "Transaction :current of :total",
    "page/banktransaction-section/unusedpayment-hint":
      "A payment was successfully created for the bank transaction. But a matching charge could not be found. Please select an existing charge for this payment, or create a new charge",

    /*
    | Banktransaction page dialog.
    */
    "dialog/banktransactioncoach-title": "Select counterparty",
    "dialog/banktransactioncoach-info/step1":
      "Select person or company and click Next",
    "dialog/banktransactioncoach-info/step2":
      "Select an existing person/company, or click New",

    /* Hints */
    "page/contracts-hint/lastdate-info":
      "The last date is the last day of the period agreed in the contract.",
    "page/personcreateupdate-company-info": "Select a company for this person",
    "dialog/coachcreditinvoice-vat/info":
      "Provide the amount to credit (including VAT, if applicable)",
    "page/propertyupdate-tab/settings-hint/bankaccount":
      "Select the default bank account for payments related to this address",
    "page/contracts-hint/readonly":
      "The contract is signed; click renew to update an existing contract, or delete and create a new contract if you made a mistake",
    "page/contracts-label/automaticallysendrentinvoice":
      "Automatically send the monthly rent bill by email to the tenant",
    "page/contracts-label/iscommercialcontract":
      "This is a VAT contract. The contract prices include :vatPercentage% VAT",

    /*
    | Property page
    */
    "page/property-section/attachment-hint":
      "Add an outside photo for this address (inside photo's in unit page)",

    /*
    | Contracts dialog
    */
    "dialog/preprocess-info/checkfirstdate":
      "The tenant may stay in the unit up to and including the 1st day of the new month. Continue?",
    "dialog/preprocess-info2/checkfirstdate":
      "Or should the tenant have left the unit before the 1st day of the new month? Then click Cancel, and change the date.",
    "dialog/preprocess-endcontract-info1":
      "Set the date for the last day of the rental period for this contract. This date will be the end date.",
    "dialog/preprocess-endcontract-info2":
      "After setting the end date, you'll settle the financial matters (return deposit etc.) and close the contract. With the end date set, Casadesk stops creating new charges for the period after the end date. When necessary Casadesk will adjust or remove any existing charges. Also, a new charge will be created for the return of the deposit (if a deposit was paid).",
    "dialog/preprocess-endcontract-info3":
      "Do not set the end date if you want to renew the contract. Click Renew if you want to renew the contract. If you renew a contract you can change the rent, occupant,..etc.",
    "dialog/postprocess-endcontract-ending-info-1":
      "The status of the contract was successfully changed to Ending, the end date is set to :endDate.",
    "dialog/postprocess-endcontract-ending-info-2":
      "At this moment charges are being updated, if necessary. And for any deposit paid, a deposit refund charge is created. When finished, you may find the updated charges on the tab Finance.",
    "dialog/postprocess-endcontract-ended-info-1":
      "The end date is registered, the last rental date is :endDate. For any deposit paid, a return deposit charge is going to be created.",
    "dialog/renewcontract-info1":
      "You are about to create a new version of an existing contract. This allows you to update the prices or change the occupant, for example.",
    "dialog/renewcontract-info2":
      "To keep the previous details in Casadesk, a new version of the contract is created. The tenant does not have to sign this new version. Most contracts allow a owner to increase the rent yearly, for example. And in such cases the existing signed contract suffices.",
    "dialog/preprocess-renewcontract":
      "Set the first date from which the changes - you are about to make - should be active.",
    "dialog/preprocess-removenotsignedcontract":
      "Are you sure you want to delete contract for tenant :tenant",
    "dialog/preprocess-removesignedcontract-baseverison":
      "You are about to remove this contract. Charges and payments created automatically for this contract, are also removed. Charges and payments that were otherwise created for this contract are not removed.",
    "dialog/preprocess-removesignedcontract-renewedverison":
      "As this is a renewed version of a contract, the previous version is made activate again.",
    "dialog/postprocess-removenotsignedcontract": "The contract was removed.",
    "dialog/postprocess-removesignedcontract":
      "The contract was removed. The automatically created contract charges are now also being removed and financial statements updated.",
    "dialog/preprocess-contractisbusy":
      "The contract cannot be modified at this time because financial data is being updated. Please try again later.",
    "dialog/auto-email-send/tenant-email-notfound":
      "This tenant doesn’t have an email address registered yet. Click Continue if you want to register it now.",
    "dialog/auto-email-send/company-tenant-email-notfound":
      "The general contact has no email address. Add the email address now?",
    "dialog/create-pdf-title":
      "The PDF document is about to be created and attached to this charge. Click this attachment to view the document. Or select the action Send a copy by email to forward the document.",
    "dialog/create-pdf-contract-title":
      "The PDF document is about to be created and attached to this contract. Click this attachment to view the document. Or select the action Send a copy by email to forward the document.",
    "dialog/set-invoice-title":
      "An invoice (PDF) is created after which the charge can no longer be changed.",

    /*  Contract pages (update, create, extend) */
    "field/lastfinalenddate-info/error":
      "Select a different date. The date now lies before the first day of the contract",

    // ID document country
    "dropdown/documentcountry-label": "ID document issued in",

    /* Coach dialogs for user (stepper) */
    "coach/propertyowner-scenario/company-step/step-1-title": "The company",
    "coach/propertyowner-scenario/company-step/step-1-subtitle":
      "Enter the name of the company and click 'Next'",
    "coach/propertyowner-scenario/company-step/step-2-title": "Summary",
    "coach/propertyowner-scenario/company-step/first-info1":
      "Is the owner a person or a company?",
    "coach/propertyowner-scenario/company-step/first-info2":
      "Are 2 or more persons together the landlord? Then select company and add the persons later to the company.",
    "coach/propertyowner-radiobutton/person": "Person",
    "coach/propertyowner-radiobutton/company": "Company",
    "coach/propertyowner-title": "New owner",
    "coach/propertyowner-scenario/company-step/second-title": "Company",
    "coach/propertyowner-scenario/company-step/third-title": "Summary",
    "coach/propertyowner-scenario/company-step/fourth-title": "Finish",
    "coach/propertyowner-scenario/company-step/second-field/companyname-label":
      "Company name",
    "coach/propertyowner-scenario/company-step/second-info1":
      "Enter the name of the company and click 'Next'",
    "coach/propertyowner-scenario/company-step/third-info1":
      "Click 'Next' and a new owner is created based on the following details:",
    "coach/propertyowner-scenario/company-step/third-info2": "New owner:",
    "coach/propertyowner-scenario/company-step/fourth-info1":
      "The owner company was successfully created: ",
    "coach/propertyowner-scenario/company-step/fourth-info2":
      "Click 'Finish' and enter more company details where appropriate.",
    "coach/propertyowner-scenario/company-step/fourth-errorinfo1":
      "The following error occurred: ",
    "coach/propertyowner-scenario/company-step/fourth-errorinfo2":
      "Go back and correct the problem, or click 'Close' try again later.",
    "coach/propertyowner-scenario/person-step/step-1-title": "The person",
    "coach/propertyowner-scenario/person-step/step-1-subtitle":
      "Enter the name of the person and click 'Next'",
    "coach/propertyowner-scenario/person-step/second-field/firstname-label":
      "First name",
    "coach/propertyowner-scenario/person-step/second-field/lastname-label":
      "Last name",
    "coach/propertyowner-scenario/person-step/second-title": "Person",
    "coach/propertyowner-scenario/person-step/third-title": "Сompany",
    "coach/propertyowner-scenario/person-step/fourth-title": "Create",
    "coach/propertyowner-scenario/person-step/fifth-title": "Finish",
    "coach/propertyowner-scenario/person-step/third-info1":
      "Enter the name of the company and click 'Next'",
    "coach/propertyowner-scenario/person-step/third-info2":
      "A landlord in Casadesk is always a company. We therefor create a fictitious company and link the person to that company.",
    "coach/propertyowner-scenario/person-step/last-hint":
      "More landlord details can later be added",
    "coach/propertyowner-scenario/person-step/third-field/companyname-label":
      "Company name",
    "coach/propertyowner-scenario/person-step/third-field/additionalnameofcompany-label":
      " Rentals",
    "coach/propertyowner-scenario/person-step/fourth-info1":
      "Click 'Next' and a new owner is created based on the following details:",
    "coach/propertyowner-scenario/person-step/fourth-info2":
      "Person :contactName will be linked to the company :companyName.",
    "coach/propertyowner-scenario/person-step/fifth-info1":
      "The following owner was successfully created:",
    "coach/propertyowner-scenario/person-step/fifth-info2":
      "Click 'Finish' and enter more details for the person where appropriate. Then click 'Save' and continue with the creation of the new property.",
    "coach/propertyowner-button/next": "Next",
    "coach/propertyowner-field/newcompany-label": "Company",
    "coach/propertyowner-field/newperson-label": "Person",
    "coach/owner-error/field-label": ":field",
    "coach-error-contacts.firstname": "First name",
    "coach-error-name": "Company name",

    /* Coach dialogs POA owner (stepper) */
    "coach/poaowner-scenario/company-step/first-title": "New POA",
    "coach/poaowner-scenario/company-step/second-title": "Contact details",
    "coach/poaowner-scenario/company-step/third-title": "Create",
    "coach/poaowner-scenario/company-step/fourth-title": "Finish",
    "coach/poaowner-scenario/company-step/first-field/companyname-label":
      "Company name",
    "coach/poaowner-scenario/company-step/first-field/poaname-label":
      "Name Owners Association",
    "coach/poaowner-scenario/company-step/first-info1":
      "Provide the name of the POA.",
    "coach/poaowner-scenario/company-step/second-info1":
      "Provide the contact details for the POA.",
    "coach/poaowner-radiobutton/department": "Department",
    "coach/poaowner-radiobutton/person": "Person",
    "coach/poaowner-radiobutton/none": "Not at this time",
    "coach/poaowner-scenario/company-step/second-field/department-label":
      "Name department",
    "coach/poaowner-scenario/company-step/third-info1":
      "Click Next and the new POA is created based on the following details:",
    "coach/poaowner-scenario/company-step/third-poa/label":
      "Name Owners Association: ",
    "coach/poaowner-scenario/company-step/third-contactdetails/label":
      "Contact details:",
    "coach/poaowner-scenario/company-step/fourth-info1":
      "The following POA was successfully created: ",
    "coach-error-contacts.email": "Email",
    "coach-error-email": "Email",

    /* Coach dialogs for user EXECUTOR(stepper) */
    "coach/executor-scenario/company-step/first-info1":
      "The task will be assigned to a:",
    "coach/reporter-scenario/company-step/first-info1":
      "The task was reported by:",
    "coach/executor-radiobutton/person": "Person",
    "coach/executor-radiobutton/user": "User",
    "coach/executor-radiobutton/company": "Company",
    "coach/executor-radiobutton/department": "Department",
    "coach/executor-scenario/person-step/second-title": "Person",
    "coach/executor-scenario/person-step/third-title": "Company",
    "coach/executor-scenario/person-step/fourth-title": "Create",
    "coach/executor-scenario/person-step/fifth-title": "Finish",
    "coach/executor-scenario/person-step/second-info1":
      "Provide details for the person:",
    "coach/executor-radiobutton/existingcompany": "Existing company",
    "coach/executor-radiobutton/newcompany": "New company",
    "coach/executor-radiobutton/nocompany": "No company for a contact",
    "coach/executor-scenario/person-step/third-info1":
      "For which company in Casadesk Is the person a contact?",
    "coach/executor-scenario/person-step/fourth-info1":
      "Click 'Next' and the new contact is created based on the following details:",
    "coach/executor-scenario/person-step/fourth-label/person": "Person: ",
    "coach/executor-scenario/person-step/fourth-label/companyname":
      "Company name: ",
    "coach/executor-scenario/person-step/fifth-info1":
      "The following contact was successfully created: ",
    "coach/reporter-scenario/person-step/fifth-info1":
      "The following reporter was successfully created: ",
    "coach-error-firstname": "First name",
    "coach/executor-scenario/company-step/second-title": "New Company",
    "coach/executor-scenario/company-step/third-title": "Contact details",
    "coach/executor-scenario/company-step/fourth-title": "Create",
    "coach/executor-scenario/company-step/fifth-title": "Finish",
    "coach/executor-scenario/company-step/second-info1":
      "Provide the name of the company: ",
    "coach/executor-scenario/company-step/third-info1":
      "Provide the contact details for the company: ",
    "coach/executor-scenario/company-step/fourth-info1":
      "Click 'Next' and the new contact is created based on the following details:",
    "coach/executor-scenario/company-step/fourth-label/newcompany": "Company: ",
    "coach/executor-scenario/company-step/fourth-label/newperson": "Person: ",
    "coach/executor-scenario/company-step/fourth-label/department":
      "Department: ",
    "coach/executor-scenario/company-step/fifth-info1":
      "The following contact was successfully created: ",
    "coach/reporter-scenario/company-step/fifth-info1":
      "The following reporter was successfully created: ",
    "coach/executor-scenario/department-step/second-title": "Department",
    "coach/executor-scenario/department-step/third-title": "Create",
    "coach/executor-scenario/department-step/fourth-title": "Finish",
    "coach/executor-scenario/department-step/second-info1":
      "Provide details for the department: ",
    "coach/executor-scenario/user-step/second-info1":
      "Provide details for the user: ",
    "coach/executor-title": "New contact",
    "coach/create-contact-for-company":
      "No contact person is yet known for :companyName. Create a contact for :companyName now.",
    "coach/executor-scenario/user-step/second-title": "User",
    "coach/executor-scenario/user-step/third-title": "Create",
    "coach/executor-scenario/user-step/fourth-title": "Finish",
    "coach/executor-scenario/person-step/third-info":
      "The new person was successfully created!",
    "coach/executor-scenario/user-step/third-info":
      "The new user was successfully created!",
    "coach/executor-scenario/person-step/second-field/firstname-label":
      "First name",
    "coach/executor-scenario/person-step/second-field/lastname-label":
      "Last name",
    "coach/executor-scenario/person-step/second-field/email-label": "Email",
    "coach/executor-scenario/user-step/first-error":
      "The new user could not be created. You do not have the Admin role in Casadesk. Please ask a user with the Admin role to create this new user for you.",
    "coach/executor-button/next": "Next",
    "coach/executor-scenario/user-step/fifth-info2":
      "An email was sent to the new user. When the user confirmed the invitation he will have access to Casadesk.",
    "coach/executor-scenario/user-step/fourth-info1":
      "Click 'Next' and the new contact is created based on the following details: ",
    "coach/executor-scenario/user-step/fourth-label/newuser": "User: ",

    /* Coach dialogs UNIT (stepper) */
    "coach/newunit-step/first-step": "Landlord",
    "coach/newunit-step/first-title": "The landlord",
    "coach/newunit-step/first-subtitle": "Select the landlord for the unit",
    "coach/newunit-step/first-step-success":
      "The details of the landlord were successfully saved",
    "coach/newunit-step/first-step-person-or-company":
      "Is the landlord a person or a company",
    "coach/newunit-step/first-step-two-or-more-landlords":
      "Are 2 or more persons together the landlord? Then select company and add the persons later to the company.",
    "coach/newunit-step/first-step-company-hint":
      "A landlord in Casadesk is always a company. We therefor create a fictitious company and link the person to that company.",
    "coach/newunit-step/second-step": "Address",
    "coach/newunit-step/second-title": "The address",
    "coach/newunit-step/second-subtitle":
      "Select the address for :companyDisplayName",
    "coach/newunit-step/third-step": "Unit",
    "coach/newunit-step/third-title": "The unit",
    "coach/newunit-step/third-subtitle": "The basic details of the unit",
    "coach/newunit-step/charge-step": "Rent price",
    "coach/newunit-step/charge-title": "Rent price",
    "coach/newunit-step/charge-subtitle":
      "Set the default rent prices for this unit",
    "coach/newunit-step/fourth-step": "Agreement",
    "coach/newunit-step/fourth-title": "Agreement with the landlord",
    "coach/newunit-step/fourth-subtitle":
      "The agreed compensation fee from the landlord",
    "coach/newunit-step/fifth-step": "Summary",
    "coach/newunit-step/fifth-title": "Summary",
    "coach/newunit-step/sixth-step": "Finish",
    "coach/newunit-step/sixth-title": "Finish",
    "coach/newunit-step/fifth-subtitle":
      "The new unit was successfully created",
    "coach/newunit-step/third-address/label": "Property:",
    "coach/newunit-step/third-unittype/label": "Type:",
    "coach/newunit-step/third-unitnumber/label": "Unit:",
    "coach/newunit-step/third-agencyfee/label": "Agency fee:",
    "coach/newunit-step/third-amountbasicrent/label": "Amount: ",
    "coach-error-chargetemplates[0].amount": "Amount",
    "coach-error-propertyid": "Property",
    "coach-error-unitnumber": "Unit number",
    "coach-error-counterparty": "Counterparty not updated. Iban is different",
    "coach/newunit-step/second-info2":
      "After creating the unit you could add more default prices for services, utilities,.. etc. These are default prices, in individual contracts you can adjust these prices.",
    "coach/newunit-step/third-info1":
      "Provide the monthly agency fee for this unit.",
    "coach/newunit-step/fourth-info1":
      "Click Next and the new Unit is created based on the following details:",
    "coach/newunit-step/fifth-info1": "Unit details successfully registered",
    "coach/newunit-step/fifth-info2":
      "Review and edit more details in the details page of this new unit.",
    "coach/newunit-step/fifth-info3":
      "Click Continue and create the first contract for this unit, or click Cancel to close this coach.",
    "coach/newunit-step/agreement-success":
      "Agreement details successfully registered",
    "coach/newunit-step/second-label/amountbasicrent": "Basic rent",
    "coach/newunit-step/first-info1": "The landlord",
    "coach/newunit-step/first-info1-subtitle":
      "Register the name of the landlord",
    "coach/newunit-step/first-newowner/label": "New landlord",
    "coach/newunit-step/first-selectexistingowner/label": "Known landlord",
    "coach/newunit-step/second-newproperty/label": "New address",
    "coach/newunit-step/second-selectexistingproperty/label": "Known address",
    "coach/newunit-step/second-info1":
      "Select an existing property or create a new property.",
    "coach/newunit-step2/title": "The Address",
    "coach/newunit-step/unit-info1": "Provide the unit details.",
    "coach/newunit-step2/subtitle": "Select the address for :companyName",
    "coach/newbills-step/fifth-step-calc-label": "deposits",
    "coach/newbills-step/fifth-step-calc-label-to-pay": "to pay ",

    /* Coach dialogs PROPERTY (stepper) */
    "coach/newproperty-step/first-step": "Owner",
    "coach/newproperty-step/first-title": "The owner",
    "coach/newproperty-step/first-subtitle":
      "Select the owner of the new address",
    "coach/newproperty-step/second-step": "Address",
    "coach/newproperty-step/second-title": "The address",
    "coach/newproperty-step/third-title": "Summary",
    "coach/newproperty-step/forth-title": "Finish",
    "coach/newproperty-step/forth-subtitle":
      "The address was successfully saved.",
    "coach/newproperty-step/third-address/label": "Address:",
    "coach/newproperty-step/third-owner/label": "Owner:",
    "coach-error-companyid": "Owner",
    "coach-error-address.googleplaceid": "Address",
    "coach/newproperty-step/first-info1":
      "The new address for :ownerDisplayName",
    "coach/newproperty-step/third-subtitle":
      "Click Finish and the new address is created based on the following details",
    "coach/newproperty-step/third-info1":
      "The following address was successfully created:",
    "coach/newproperty-step/third-info2":
      "The property is successfully created. Review and update any information in the property details page.",

    /* Coach dialogs CONTRACT (stepper) */
    "coach/newcontract-step/first-step-title": "Unit",
    "coach/newcontract-step/second-step-title": "Tenant",
    "coach/newcontract-step/third-step-title": "Occupants",
    "coach/newcontract-step/fourth-step-title": "Contract",
    "coach/newcontract-step/fifth-step-title": "Summary",
    "coach/newcontract-step/sixth-step-title": "Finish",
    "coach/newcontract-step/third-unit/label": "Unit:",
    "coach/newcontract-step/third-amountbasicrent/label": "Amount:",
    "coach/newcontract-step/third-tenant/label": "Tenant:",
    "coach/newcontract-step/third-firstdate/label": "First date:",
    "coach/newcontract-step/first-title": "The unit",
    "coach/newcontract-step/first-subtitle": "Select an existing unit",
    "coach/newcontract-step/second-title": "The tenant",
    "coach/newcontract-step/second-subtitle":
      "New tenant, or an existing tenant?",
    "coach/newcontract-step/third-title": "The occupants",
    "coach/newcontract-step/third-subtitle":
      "This will be the tenant of the unit.",
    "coach/newcontract-step/fourth-title": "Contract dates",
    "coach/newcontract-step/fourth-subtitle":
      "Provide the contract dates and contract amounts",
    "coach/newcontract-step/fifth-title": "Summary",
    "coach-error-firstdate": "First date",
    "coach-error-unitid": "Unit",
    "coach-error-maintenantcontactid": "Tenant",
    "coach-error-contactforcontracts[0].contactid": "Tenant",
    "coach/newcontract-step/first-newtenant/label": "New tenant",
    "coach/newcontract-step/first-existingtenant/label": "Existing tenant",
    "coach/newcontract-step/first-existingtenant/hint1":
      "More information about the tenant can be added later",
    "coach/newcontract-step/tenant-infoadditionaloccupant":
      "Additional tenants, or occupants? Click Add person",
    "coach/newcontract-step/tenant-button/addperson-label": "Add person",
    "coach/newcontract-step/occupants-info1":
      "This will be the tenant of the unit.",
    "coach/newcontract-step/occupantscreated-info1":
      "Other co-tenants and occupants mentioned in the contract:",
    "coach/newcontract-step/paiddirectlytoowner-label":
      "The owner receives rent payments directly from the tenant.",

    /* Coach dialogs BILLS (stepper) */
    "coach/newbills-step/first-step-title": "Address",
    "coach/newbills-step/second-step-title": "Bill",
    "coach/newbills-step/third-step-title": "Unit",
    "coach/newbills-step/fourth-step-title": "Tenant",
    "coach/newbills-step/fifth-step-title": "Finish",
    "coach/newbills-step/six-step-title": "Finish",
    "coach/newbills-step/sixth-step-title": "Finish",
    "coach/newbills-step/third-unit/label": "Unit:",
    "coach/newbills-step/third-amountbasicrent/label": "Amount:",
    "coach/newbills-step/third-tenant/label": "Tenant:",
    "coach/newbills-step/third-firstdate/label": "First date:",
    "coach/newbills-step/first-title": "The unit",
    "coach/newbills-step/first-subtitle": "Select an existing unit",
    "coach/newbills-step/second-title": "The tenant",
    "coach/newbills-step/second-subtitle":
      "Details of the final bill to settle with the tenant(s)",
    "coach/newbills-step/third-title": "The occupants",
    "coach/newbills-step/third-subtitle":
      "This will be the tenant of the unit.",
    "coach/newbills-step/third-subtitle-one":
      "Details of the final bill to settle with the tenant(s)",
    "coach/newbills-step/fourth-title": "Contract dates",
    "coach/newbills-step/fourth-subtitle":
      "Provide the contract dates and contract amounts",
    "coach/newbills-step/fifth-title": "Summary",
    "coach/newbills-step/label": "This settlement is for the following address",
    "coach/newbills-step/first-existingtenant/label": "Existing tenant",
    "coach/newbills-step/first-existingtenant/hint1":
      "More information about the tenant can be added later",
    "coach/newbills-step/tenant-infoadditionaloccupant":
      "Additional tenants, or occupants? Click Add person",
    "coach/newbills-step/tenant-button/addperson-label": "Add person",
    "coach/newbills-step/occupants-info1":
      "This will be the tenant of the unit.",
    "coach/newbills-step/occupantscreated-info1":
      "Other co-tenants and occupants mentioned in the contract:",
    "coach/newbills-step/paiddirectlytoowner-label":
      "The owner receives rent payments directly from the tenant.",
    "coach/newbills-step-field/type-label": "Settlement type",
    "coach/newbills-step/second-step-first-field-label": "Bill is about:",
    "coach/newbills-step/second-step-second-field-label": "Bill amount:",
    "coach/newbills-step/second-step-second-field-label-deposited":
      "Already paid (deposited)",
    "coach/newbills-step/second-step-admin-field-label": "Percentage:",
    "coach/newbills-step/second-step-pdf-field-label":
      "Make the following documents available for the tenant(s)",
    "coach/newbills-step/button-upload-document": "Upload document",
    "coach/newbills-step/second-step-error-field-label":
      "Total amount should be higher than 0 and lower then 100.000",
    "coach/newbills-step/second-step-error-percent-field-label":
      "Should be >= 0",
    "coach/newbills-step/second-step-third-field-label": "Bill period:",
    "coach/newbills-step/second-step-from-data-label": "first date:",
    "coach/newbills-step/second-step-to-data-label": "last date:",
    "coach/newbills-step/third-step-first-field-label": "Bill is about:",
    "coach/newbills-step/third-step-second-field-label": "Bill amount:",
    "coach/newbills-step/third-step-fourth-field-label": "Total Amount:",
    "coach/newbills-step/third-step-third-field-label": "Bill period:",
    "coach/newbills-step/third-step-fifth-field-label":
      "Administration fee landlord:",
    "coach/newbills-step/third-step-only-one-unit":
      "The address has only one unit. Thus the total amount does not have to be distributed over several units.",
    "coach/newbills-step/fourth-step-second-title":
      "Distribute the total amount over the units",
    "coach/newbills-step/fourth-step-third-title":
      "Landlord’s administration fee",
    "coach/newbills-step/fourth-step-contract-period":
      "Based on the contract period the total amount is pro rata assigned to the tenant(s).",
    "coach/newbills-step/third-step-for-each-unit":
      "Determine the distribution by entering for each unit a number from 0 to 100",
    "coach/newbills-step/fifth-step-second-title": "To settle with tenant(s)",
    "coach/newbills-step/third-step-subtitle":
      "Distribution among the rental properties",
    "coach/third-step-third-field-label/amount-label": "Percentage",
    "coach/newbills-step/second-step-second-field-checkbox":
      "Payments directly processed by the landlord",
    "coach/newbills-step/second-step-second-field-content":
      "As payments are directly paid or received by the landlord the bill is labeled as fully paid",

    /* Coach dialogs AGENCY (stepper) */
    "coach/newagency-step/first-welcometitle": "Welcome!",
    "coach/newagency-step/first-info1":
      "The Casadesk environment for :agencyName is ready to be used.",
    "coach/newagency-step/first-info2":
      "We are now about to register basic information that will allow Casadesk to function well for :agencyName.",
    "coach/newagency-step/first-info3":
      "But already have a look now and start using Casadesk for :agencyName.",
    "coach/newagency-step/second-info1":
      "These details will be used in invoices and messages",
    "coach/newagency-step/second-info2":
      "Monthly rent charges are being created automatically, based on the rental contract details. Next the payment are being processed and the monthly owner statements become available immediately.",
    "coach/newagency-step/third-info1": "Bank account of :agencyName",
    "coach/newagency-step/third-info2":
      "This is the bank account at which - on behalf of the landlords - the rent is received",
    "coach/newagency-step/first-title": "Welcome",
    "coach/newagency-step/second-title": "Company details",
    "coach/newagency-step/third-title": "Banking details",
    "coach-loseinformation/info":
      "You are about to close this coach. The information entered will be lost.",
    "coach/newagency-step/fourth-title": "Logo",
    "coach/newagency-step/fifth-title": "Finish",
    "coach/newagency-step/fourth-info1":
      "Upload de agency logo (jpg, jpeg, png). The logo will be used in, for example, invoices and messages",
    "coach/newagency-step/fifth-errorinfo2":
      "Go back and correct the problem, or click 'Close' try again later.",
    "coach/newagency-step/fifth-info1":
      "The most important settings are now registered and the Casadesk is ready to be used for :agencyName.",
    "coach/newagency-step/fifth-info2":
      "We will now continue to register the first rental unit.",
    "coach-error-bankaccountid": "Bank account of agency",
    "coach-error-mainbankaccountid": "Bank account for receiving the rent",
    "coach/newagency-step/first-maintitletext": "Welcome :agencyName!",
    "coach/newagency-step/second-maintitletext": "The company information",
    "coach/newagency-step/third-maintitletext": "The managing bank account",
    "coach/newagency-step/fourth-maintitletext": "Upload the agency logo",
    "coach/newagency-step/fifth-maintitletext": "Settings saved",
    "coach/newpropertyfirstuser-step/fifth-hintforaddress":
      "Start by typing housenumber and street, and click the appropriate address",
    "coach/newpropertyfirstuser-step/fifth-hintforiban":
      "Provide the full Iban number ( example: NL91ABNA0417164300 )",
    "label-bank-account-name": "Bank account name",
    "list-label-bank-account-name": "In the name of",
    "coach-welcome-error-phone": "General phone number",
    "coach-welcome-error-email": "General agency email address",
    "agency-general-address": "Select the main agency address",
    "coach/newagency-step/fourth-hintlogo":
      "You can also skip this step and add the agency logo later",
    "coach/newagency-step/fifth-info3": "Next fields contain errors:",

    /* Coach  dialogs NEW PROPERTY FIRST USER (stepper) */
    "coach/newpropertyfirstuser-scenario/single-step/first-title": "Type",
    "coach/newpropertyfirstuser-scenario/single-step/second-title": "Landlord",
    "coach/newpropertyfirstuser-scenario/single-step/third-title": "Unit",
    "coach/newpropertyfirstuser-scenario/single-step/fourth-title": "Agreement",
    "coach/newpropertyfirstuser-scenario/single-step/fifth-title": "Tenant",
    "coach/newpropertyfirstuser-scenario/single-step/sixth-title": "Contract",
    "coach/newpropertyfirstuser-scenario/single-step/seventh-title":
      "Statement",
    "coach/newpropertyfirstuser-scenario/single-step/eighth-title": "Finish",
    "coach/newpropertyfirstuser-step/first-title": "Unit type",
    "coach/newpropertyfirstuser-step/first-subtitle":
      "To register all essential details about a unit we’ll start with the unit type",
    "coach/newpropertyfirstuser-radiobutton/single":
      "Single unit address (apartment, house,..)",
    "coach/newpropertyfirstuser-radiobutton/multiple":
      "Address with multiple units (rooms, bedsits,..)",
    "coach/newpropertyfirstuser-step/owner-title": "Name of the owner",
    "coach/newpropertyfirstuser-step/landlord-title": "The landlord",
    "coach/newpropertyfirstuser-step/owner-info":
      "More details about the owner can be added later",
    "coach/newpropertyfirstuser-step/fifth-info1":
      "Tenant details successfully registered",
    "coach/newpropertyfirstuser-step/fifth-last-hint":
      "More tenant details can later be added",
    "coach/newpropertyfirstuser-step/fifth-company-title": "Contact person",
    "coach/newpropertyfirstuser-step/sixth-info3":
      "Click 'Close' and update the contract details before setting the status to Signed.",
    "coach/newpropertyfirstuser-step/eighth-info3":
      "Click Close to finish this coach",
    "coach/newpropertyfirstuser-step/eighth-info4": "Register another unit",
    "coach/newpropertyfirstuser-step/unit-info1": "The unit",
    "coach/newpropertyfirstuser-step/unit-info2":
      "Provide the basic details of the unit",
    "coach/newpropertyfirstuser-step/agreement-info1":
      "Agreement with the landlord",
    "coach/newpropertyfirstuser-step/agreement-info2":
      "The agreed compensation fee from the landlord",
    "coach/newpropertyfirstuser-step/unit-scenario/multiple-info1":
      "Please provide the details for the various units in this property.",
    "coach/newpropertyfirstuser-step/tenant-info1": "Name of the tenant.",
    "coach/newpropertyfirstuser-step/contract-info1":
      "Provide the contract dates and contract amounts.",
    "coach/newpropertyfirstuser-step/contract-info": "The rental contract",
    "coach/newpropertyfirstuser-step/contract-info2":
      "The arrangements with the tenant",
    "coach/newpropertyfirstuser-step/statement-info":
      "The statement for the landlord",
    "coach/newpropertyfirstuser-step/statement-info2":
      "The upcoming landlord statement is immediately updated when a charge or payment is processed.",
    "coach/newpropertyfirstuser-scenario/owner-info1":
      "Landlord details successfully registered",
    "coach/newpropertyfirstuser-step/sixth-info1":
      "The details for the unit were successfully registered",
    "coach/newpropertyfirstuser-step/sixth-info2":
      "Register another unit for the property",
    "coach/newpropertyfirstuser-step/sixth-info-title": "Success",
    "coach/newpropertyfirstuser-step/sixth-info-subtitle":
      "The details for the unit were successfully registered",
    "coach/newpropertyfirstuser-scenario/complex-step/third-title": "Complex",
    "coach/newpropertyfirstuser-scenario/complex-info1":
      "Please provide the name or description of the complex.",
    "coach/newpropertyfirstuser-scenario/complex-info2":
      "The following Complex was successfully created:",
    "coach/newpropertyfirstuser-step/sixth-info4":
      "Click 'New unit' to create another unit for this complex.",
    "coach/newpropertyfirstuser-radiobutton/complex":
      "Complex with multiple addresses ( apartments, tower block,.. )",
    "coach/newpropertyfirstuser-step/forth-infocomplex":
      "Please provide the details for the various units in this complex.",
    "coach/newpropertyfirstuser-step/forth-addresscreated":
      "The address was successfully saved.",
    "coach/newpropertyfirstuser-step/forth-hintforunittype":
      "More unit details can later be added",
    "coach/newpropertyfirstuser-step/fifth-hintfortenant":
      "More information about the tenant can later be added.",
    "coach/newpropertyfirstuser-step/sixth-field/paiddirectlytoowner-label":
      "The landlord receives the rent payments directly from the tenant.",
    "coach/propertyowner-scenario/tenant-step/first-choosetype":
      "The tenant is a person, or an organization?",
    "coach/newpropertyfirstuser-step/tenant-info3": "Contact with the company",
    "coach/newpropertyfirstuser-step/cotract-infochargetemplates":
      "Click button 'Add' to add another contract amount.",
    "coach/newpropertyfirstuser-step/cotract-amounts":
      "Amounts rental contract",
    "coach/newpropertyfirstuser-step/cotract-infochargetemplates2":
      "Click Add to add an amount.",
    "coach/newpropertyfirstuser-step/forth-hintforunitnumber":
      "Are there multiple units at the same address, then identify the individual units by a number or description",
    "coach/propertyowner-step/tenant-info1": "The tenant",
    "coach/propertyowner-step/tenant-info2":
      "The basic information about the tenant",
    "coach/newpropertyfirstuser-step/eighth-hintforlaststep":
      "You can start this coach again any time",
    "coach/newpropertyfirstuser-step/title-contract-amounts": "Amounts",
    "coach/newpropertyfirstuser-step/contract-success-title":
      "Contract details successfully registered",
    "coach/newpropertyfirstuser-step/vat-contract": "VAT contract",
    "coach/newpropertyfirstuser-step/directly-paid": "Directly paid",

    //Coach dialog new tenant
    "coach/newtenant-step/second-title": "Finish",
    "coach/newtenant-step/tenant-info2":
      "This is the person who will sign the rental contract",

    //Coach dialog new counterparty
    "coach/newcounterparty-step/first-title": "New person or company",
    "coach/newcounterparty-step/first-info1":
      "The counterparty is a person, or an organization?",
    "coach/newcounterparty-step/second-info1":
      "The counterparty was successfully saved.",
    "coach/knowncounterparty/first-title": "Known person or company",

    //Coach Move unit
    "coach/moveunit-step/first-title": "Address",
    "coach/moveunit-step/select-address":
      "Find the address (powered by Google address search)",
    "coach/moveunit-step/select-address-hint":
      "Do not forget the house number (including any extensions)",
    "coach/moveunit-step/second-title": "Summary",
    "coach/moveunit-step/third-title": "Result",
    "coach/moveunit-step/first-info1":
      "Select another property of owner :ownerDisplayName or create a new property",
    "coach/moveunit-step/second-info1": "Unit :unitDisplayName is moved from",
    "coach/moveunit-step/second-info2": "to property",
    "coach/moveunit-step/third-info1": "The address was successfully updated",
    "coach/moveunit-step/third-errorinfo1":
      "An error occurred. The unit was not moved.",

    //Coach Update counterparty
    "coach/counterparty-step/third-info1":
      "The counterparty was successfully updated",
    "coach/counterparty-step/third-errorinfo1":
      "An error occurred. The counterparty was not changed.",

    /* Abstract pane (information about related to object) */
    "info/paidto": "Paid to",
    "info/receivedfrom": "Received from",

    // Payment Information component (use for payments and charge pages: for example ChargeUpdate)

    "payment-unused-information-received":
      "Received from :counterparty on :date.",
    "payment-unused-information-paid": "Paid by :counterparty on :date.",
    "payment-partly-used-information-received":
      "Received from :counterparty on :date.",
    "payment-partly-used-information-paid": "Paid by :counterparty on :date.",
    "payment-fully-used-information-received":
      "Received from :counterparty on :date.",
    "payment-fully-used-information-paid": "Paid by :counterparty on :date.",
    "payment-unused-information-received-no-counterparty": "Received on :date.",
    "payment-unused-information-paid-no-counterparty": "Paid on :date.",
    "payment-partly-used-information-received-no-counterparty":
      "Received on :date.",
    "payment-partly-used-information-paid-no-counterparty": "Paid on :date.",
    "payment-fully-used-information-received-no-counterparty":
      "Received on :date.",
    "payment-fully-used-information-paid-no-counterparty": "Paid on :date.",
    "payment-unused-information-2": "You can use it to pay a charge.",
    "payment-partly-used-information-2":
      "Of which the following amount is left to pay an additional charge:",
    "payment-fully-used-information-2":
      "This payment was fully used to pay one or more charges.",

    // Charge Information component (use for payments and charge pages: for example PaymentUpdate)

    "charge-unpaid-information-receivable":
      "A charge to be received from :counterparty due on :dueDate for :type, :period.",
    "charge-unpaid-information-payable":
      "A charge to be paid to :counterparty due on :dueDate for :type, :period.",
    "charge-fully-paid-information-receivable":
      "A charge to be received from :counterparty due on :dueDate for :type, :period.",
    "charge-fully-paid-information-payable":
      "A charge to be paid to :counterparty due on :dueDate for :type, :period.",
    "charge-partly-paid-information-receivable":
      "A charge to be received from :counterparty due on :dueDate for :type, :period.",
    "charge-partly-paid-information-payable":
      "A charge to be paid to :counterparty due on :dueDate for :type, :period.",
    "invoice-unpaid-information-receivable":
      "An invoice to be received from :counterparty due on :dueDate for :type, :period.",
    "invoice-unpaid-information-payable":
      "An invoice to be paid to :counterparty due on :dueDate for :type, :period.",
    "invoice-fully-paid-information-receivable":
      "An invoice to be received from :counterparty due on :dueDate for :type, :period.",
    "invoice-fully-paid-information-payable":
      "An invoice to be paid to :counterparty due on :dueDate for :type, :period.",
    "invoice-partly-paid-information-receivable":
      "An invoice to be received from :counterparty due on :dueDate for :type, :period.",
    "invoice-partly-paid-information-payable":
      "An invoice to be paid to :counterparty due on :dueDate for :type, :period.",
    "charge-fully-paid-information-2": "This charge is fully paid.",
    "invoice-fully-paid-information-2": "This invoice is fully paid.",
    "charge-partly-paid-information-2":
      "Of this charge an amount of :paidAmount was already paid.",
    "invoice-partly-paid-information-2":
      "Of this invoice an amount of :paidAmount was already paid.",
    "section/charge-info/relatedtoobject": "This charge is related to:",
    "section/invoice-info/relatedtoobject": "This invoice is related to:",

    // Payment section component (use for different pages: ChargeUpdate, BankTransaction, PaymentCreate, PeymentSettle, PaymentUpdate, PaymentLink)

    /*Charge statuses (use like information text for charge)*/
    "status-paid": "Paid",
    "status-unpaid": "Unpaid",
    "status-partially-paid": "Partial Paid",
    "status-to-receive": "TO RECEIVE",
    "status-to-pay": "TO PAY",
    "status-still-to-receive": "LEFT TO RECEIVE",
    "status-still-to-pay": "LEFT TO PAY",
    "status-received": "RECEIVED",
    "status-amount/paid": "PAID",
    "status-withdrawal": "WITHDRAWAL",
    "status-deposit": "DEPOSIT",

    /*Payment statuses (use like information text for payment)*/
    "payment-status-to-receive": "to process - RECEIVED",
    "payment-status-to-pay": "to process - PAID",
    "payment-status-still-to-receive": "to process - RECEIVED",
    "payment-status-still-to-pay": "to process - PAID",
    "payment-status-received": "RECEIVED",
    "payment-status-amount/paid": "PAID",

    /*
    | Snackbar messages
    */

    "snackbar-message-unit-created-successfully": "New unit created",
    "snackbar-message-unit-updated-successfully": "Unit updated",
    "snackbar-message-user-created-successfully": "New user created",
    "snackbar-message-user-updated-successfully": "User updated",
    "snackbar-message-person-created-successfully": "New person created.",
    "snackbar-message-person-updated-successfully": "Person updated.",
    "snackbar-message-tenant-created-successfully": "New tenant created.",
    "snackbar-message-caretaker-created-successfully": "New caretaker created.",
    "snackbar-message-executor-created-successfully": "New contact created.",
    "snackbar-message-manager-created-successfully": "New manager created.",
    "snackbar-message-owner-created-successfully": "New owner created.",
    "snackbar-message-company-created-successfully": "New company created.",
    "snackbar-message-company-updated-successfully": "Company updated.",
    "snackbar-message-unit-removed-successfully": "Unit removed",
    "snackbar-message-person-removed-successfully": "Person removed",
    "snackbar-message-user-removed-successfully": "User removed",
    "snackbar-message-company-removed-successfully": "Company removed",
    "snackbar-message-property-updated-successfully": "Property updated",
    "snackbar-message-property-created-successfully": "New property created",
    "snackbar-message-property-removed-successfully": "Property removed",
    "snackbar-message-activity-template-created-successfully":
      "New activity template created",
    "snackbar-message-activity-template-updated-successfully":
      "Activity template updated",
    "snackbar-message-activity-template-removed-successfully":
      "Activity template removed",
    "snackbar-message-agency-fee-created-successfully":
      "New agency fee created",
    "snackbar-message-default-agency-fee-created-successfully":
      "Default agreement settings saved",
    "snackbar-message-default-agency-fee-updated-successfully":
      "Default agreement settings saved",
    "snackbar-message-agency-fee-updated-successfully": "Agency fee updated",
    "snackbar-message-agency-fee-removed-successfully": "Agency fee removed",
    "snackbar-message-agency-settings-updated-successfully":
      "Agency settings updated",
    "snackbar-message-bill-settlement-processed-successfully":
    "Bill settlement processed",
    "snackbar-message-user-settings-updated-successfully":
      "User settings updated",
    "snackbar-message-bank-account-created-successfully":
      "New bank account created",
    "snackbar-message-bank-account-updated-successfully":
      "Bank account updated",
    "snackbar-message-bank-account-removed-successfully":
      "Bank account removed",
    "snackbar-message-charge-created-successfully": "New charge created",
    "snackbar-message-charge-updated-successfully": "Charge updated",
    "snackbar-message-charge-removed-successfully": "Charge removed",
    "snackbar-message-charge-settled-successfully": "Charge settled",
    "snackbar-message-charge-unsettled-successfully": "Charge unsettled",
    "snackbar-message-charge-unlinked-successfully": "Charge unlinked",
    "snackbar-message-charge-credited-successfully":
      "The charge has been - partially - settled with the newly created credit invoice",
    "snackbar-message-charge-undo-credit-successfully": "Credit removed",
    "snackbar-message-charge-type-created-successfully": "Charge type saved",
    "snackbar-message-charge-type-updated-successfully": "Charge type saved",
    "snackbar-message-charge-type-removed-successfully": "Charge type removed",
    "snackbar-message-charge-template-created-successfully":
      "New charge template created",
    "snackbar-message-charge-template-updated-successfully":
      "Charge template updated",
    "snackbar-message-charge-template-removed-successfully":
      "Charge template removed",
    "snackbar-message-contract-created-successfully": "New contract created",
    "snackbar-message-contract-updated-successfully": "Contract updated",
    "snackbar-message-contract-removed-successfully": "Contract removed",
    "snackbar-message-contract-renewed-successfully": "Contract renewed",
    "snackbar-message-contract-end-date-updated-successfully":
      "Contract end date updated",
    "snackbar-message-contract-expiration-date-updated-successfully":
      "Contract expiration date updated",
    "snackbar-message-email-sent-successfully": "EMail sent",
    "snackbar-message-event-created-successfully": "New :eventname created",
    "snackbar-message-event-updated-successfully": ":eventname updated",
    "snackbar-message-event-removed-successfully": ":eventname removed",
    "snackbar-message-event-snoozed-successfully": "Event snoozed",
    "snackbar-message-financial-start-date-updated-successfully":
      "Financial start date updated",
    "snackbar-message-payment-created-successfully": "New payment created",
    "snackbar-message-payment-updated-successfully": "Payment updated",
    "snackbar-message-payment-removed-successfully": "Payment removed",
    "snackbar-message-payment-settled-successfully": "Payment settled",
    "snackbar-message-payment-unsettled-successfully": "Payment unsettled",
    "snackbar-message-payment-linked-successfully": "Payment linked",
    "snackbar-message-payment-unlinked-successfully": "Payment unlinked",
    "snackbar-message-charge-payment-created-successfully":
      "New charge and new payment created",
    "snackbar-message-transaction-file-uploaded-successfully":
      "Transaction file uploaded",
    "snackbar-message-transaction-file-removed-successfully":
      "Transaction file removed",
    "snackbar-expiring-contract-notification-deactivated-contract-ended":
      "The expiring contract notification was deactivated, as the contract was ended",
    "snackbar-expiring-contract-notification-deactivated-contract-updated":
      "The expiring contract notification was deactivated, as the contract was updated",
    "snackbar-expiring-contract-notification-deactivated-contract-continued":
      "The expiring contract notification was deactivated, as the contract was continued",
    "snackbar-notification-snoozed": "Notification snoozed until ",
    "snackbar-action-successful": "Action successful",
    "snackbar-person-added-to-company-successfully":
      "Person added to this company.",
    "snackbar-person-unlinked-from-company-successfully":
      "Person removed from this company.",
    "snackbar-widhdrawal-amount-from-company-successfully":
      "The withdrawal was successfully made.",
    "snackbar-deposit-to-savings-done-successfully": "The deposit was made",
    "snackbar-message-charge-memo-updated-successfully": "Memo is updated",
    "snackbar-message-charge-memo-removed-successfully": "Memo is removed",
    "snackbar-chargetempalte-cannot-be-removed":
      "Charge of a Contract can not be updated",
    "snackbar-message-unit-service-status-updated-successfully":
      "Unit service status updated",
    "snackbar-message-settle-with-savings-successfully":
      "Settlement wih savings is done",
    "snackbar-message-undosettle-with-savings-successfully":
      "Settlement with savings undone",
    "snackbar-message-charge-snooze-updated-successfully": "Charge snoozed",
    "snackbar-message-charge-unsnooze-updated-successfully": "Charge unsnoozed",
    "snackbar-message-payment-snooze-updated-successfully": "Payment snoozed",
    "snackbar-message-payment-unsnooze-updated-successfully":
      "Payment unsnoozed",
    "snackbar-message-statement-snooze-updated-successfully":
      "Statement snoozed",
    "snackbar-message-statement-unsnooze-updated-successfully":
      "Statement unsnoozed",
    "snackbar-message-charges-for-next-mounth-create-successfully":
      "Charges successfully created",

    // UNIVERSAL
    // Dropdown component button label
    // The dropdown components allow users to (a) search for and select an existing object or (b) create a new object
    // The buttons, for which a label is defined below, are used to start the creation of a new object
    //
    "dropdown/chargetype-button/newchargetype": "New Type",
    "dropdown/person-button/newperson": "New person",
    "dropdown/company-button/newcompany": "New company",
    "dropdown/bankaccount-button/newbankaccount": "New bank account",
    "dropdown/company-button/propertyassociation": "New Owners Association",

    // Dialogs
    //
    "dialog/warning-title": "Warning",
    "dialog/attention-title": "Attention",
    "dialog/attention-info/chooseexistingpayment":
      "Please choose an existing payment and click 'Create' button to finish transaction", //User clicks Save but did not select a payment while the option Existing payments in the section payment is open in the ChargeCreate, ChargeUpdate or ChargePay page
    "dialog/attention-info/chooseexistingcharge":
      "Please choose an existing charge and click 'Create' button to finish transaction", //   User clicks Save but did not select a charge while the option Existing charge in the section charge is open in the PaymentCreate, PaymentUpdate or PaymentLink page
    "dialog/preprocess-info/deletecharge":
      "You're about to remove the charge. Are you sure?", //  User chooses to remove a charge
    "dialog/preprocess-info/ibanalreadyused":
      "This bank account is already used for :displayName1. Delete this bank account at :displayName2 and add to :displayName3?", // User clicks Save in a create or update page but the bank account number provided is already used by another person or company
    "preprocess/cannotpaycharge-info/differentclasses":
      "To link a payable charge with a received payment, or a receivable charge with a paid payment, is not possible.", //  User selected a payment with a different class from the charge (chargeClass vs paymentClass) and clicked Save in the ChargeCreate, ChargeUpdate, PaymentCreate, PaymentUpdate or BankTranksaction page.
    "preprocess/selectbanktransactionfile-info":
      "Select a file of type MT940. You download such a file from your online bank environment and it contains bank transactions.",
    "preprocess/cantcreateactivitytemplate-info":
      "This feature is only available to users with the Administrator role.",
    "preprocess/cantupdateentity-info":
      "The entity was removed and can no longer be updated",
    "dialog/preprocess-info/withdrawal":
      "The savings balance of :companyName is: :savingsAmount. Determine the amount and click Continue.",
    "dialog/preprocess-info/deposit":
      "You are about to create a deposit into the savings of this owner. The amount will be included in the next owner settlement. Provide the details and click Continue.",
    "dialog/postprocess-info/withdrawalforpayablecharge":
      "The withdrawal was successfully made and included in the owner statement in order to settle this charge with the owner.",
    "dialog/preprocess-settlewithsavings/title": "Settle with savings",
    "dialog/preprocess-settlewithsavings/select-owner": "Select owner",
    "dialog/preprocess-settlewithsavings/info-select-acc":
      "Select the savings account to settle :savingsAmount with",
    "dialog/preprocess-undosettlewithsavings/title":
      "Undo settlement with savings",
    "dialog/preprocess-chargeundosettlewithsavings/info":
      "Undo the settlement of this charge with the savings account.",
    "dialog/preprocess-paymentundosettlewithsavings/info":
      "Undo the settlement of this payment with the savings account.",
    "dialog/preprocess-unithasactivecontract/info":
      "An active contract without end date still exists. Click Continue to create a new contract for a new tenant. Or Cancel and renew the existing contract.",
    "dialog/preprocess-negativesavingsaccount/info":
      "Insufficient funds in the savings account. The current balance is :savingsAmount. ",

    //Withdrawal dialogs
    "dialog/preprocess-withdrawal/title": "Withdrawal from savings",
    "dialog/preprocess-deposit/title": "Make a deposit",
    "dialog/preprocess-info/savingsamount":
      "The amount of :withdrawalamount will be drawn from savings.",
    "dialog/preprocess-info/savingsamountnotenough":
      "The savings amount is not enough. The available amount of :savingsamount will be drawn from savings",
    "dialog/preprocess-info/nosavings": "There are no savings at this time.",

    //Deposit process
    "menuitem-deposit-to-owner-savings": "Deposit to savings of the owner",
    "dialog/preprocess-title/deposittoowner": "Deposit to savings of the owner",
    "dialog/deposittoowner-info":
      "The amount is to be added to the savings of the owner.",
    "menuitem-deposit-to-agency-savings": "Deposit to savings of :agency",
    "dialog/preprocess-title/deposittoagency": "Deposit to savings of :agency",
    "dialog/deposittoagency-info":
      "The amount is to be added to the savings of :agency",

    // CHARGE SECTION
    // Charge section component
    // This component is used to present the details for charge, create new charge or select existing charge in the following pages:
    // Payment Create,
    // Payment Update,
    // Payment Link,
    // Charge Create,
    // Charge Update,
    // Charge Settle,
    // BankTransaction
    // Invoice Create
    // Invoice Update
    "section/charge-title": "Charge", // Use for charge details section, also for createNew/selectExisting charge section.
    "section/invoice-title": "Invoice", // Use for invoice details section, also for createNew/selectExisting charge section.
    "section/charge-status/lefttopay": "left to pay",
    "section/charge-status/paid": "Paid",
    "section/charge-status/unpaid": "Unpaid",
    "section/charge-status/partiallypaid": "Partial Paid",
    "section/charge-field/class-label": "We are to",
    "section/charge-field/classreceivable-label": "Receive",
    "section/charge-field/classreceivableexplanation-label":
      "income for owner, or :agencyName",
    "section/charge-field/classpayable-label": "Pay",
    "section/charge-field/classpayableexplanation-label":
      "costs for owner, or :agencyName",
    "section/charge-field/аmount-label": "Amount",
    "section/charge-field/from-label": "From",
    "section/charge-field/to-label": "To",
    "section/charge-field/for-label": "For",
    "section/charge-field/invoicedate-label": "Invoice date",
    "section/charge-field/invoicenumber-label": "Invoice number",
    "section/charge-field/invoiceperiod-label": "Period",
    "section/charge-field/vat-label": "VAT",
    "section/charge-field/currency-label": "Currency",
    "section/charge-field/type-label": "Type",
    "section/charge-field/person-label": "Person",
    "section/charge-field/company-label": "Company",
    "section/charge-field/forperiod-label":
      "Present the charge in the statement for",
    "section/charge-field/description-label": "Description",
    "section/charge-radiobutton/newcharge": "Create charge", // Use for createNew/selectExisting charge section.
    "section/charge-radiobutton/existingcharge": "Find charge", // Use for createNew/selectExisting charge section.
    "section/charge-radiobutton/nocharge": "Charge unknown", // Use for createNew/selectExisting charge section.
    "section/charge-tab/nocharge-hint/nochargeexplanation":
      "The charge for this payment is yet unknown",
    "section/charge-tab/nocharge-hint/dummyexplanation":
      "Not going to attach this payment to any charge? :link",
    "section/charge-tab/nocharge-link/considerused":
      "Consider this payment processed",
    "section/charge-checkbox/paidcharges": "Include paid charges", // Use for select existing charge section.
    "section/charge-tab/existing-info/chargesnotfound": "No charges found.", // Use for select existing charge section, when list of charges is empty
    "section/charge-tab/existing-switch/listswitcher-label":
      "Automatically find charges",
    "section/charge-info/islocked": "This charge is locked", // Use for charge details section
    "section/charge-info/isremoved": "This charge is removed.", // Use for charge details section
    "section/charge-info/chargetosettle": "Use this charge to settle", // Information text for user on settle charge page, that this charge is used to settle, use for charge details section.
    "section/charge-info/invoicetosettle": "Use this invoice to settle", // Information text for user on settle charge page, that this invoice is used to settle, use for charge details section.
    "section/charge-info/cannottselectchargepaymentfullyused":
      "This charge can not be paid with this payment. This payment is already fully used.",
    "section/charge-info/cannottselectchargemaxchargenumberselected":
      "Only :number charges can be linked to a payment in one go",
    "section/charge-info/cannotpaychargeswithdifferentclasses":
      "Cannot create a payment for selected charges. Payable and receivable charges are mixed. Select only payable or receivable charges and try again.",
    "section/charge-label/invoicereceivedfrom": "Invoice received from",
    "section/invoice-label/amount": "Total amount",
    "section/invoice-field/vat-label": "VAT amount",
    "section/invoice-field/vatpercentage-label": "VAT percentage",
    "section/charge-for-hint":
      "For what or for who are we receiving or paying the amount?",

    //Settle With Savings Check Scenario Translation
    it_is_not_possible_to_make_savings_action:
      "The amount cannot be settled with savings",
    deposit_to_owner: "Settle :savingsAmount with the savings of owner",
    withdrawal_from_owner: "Settle :savingsAmount with the savings of owner",
    deposit_to_agency: "The amount is to be added to the :agency savings.",
    withdrawal_from_agency:
      "The amount is to be subtracted from the :agency savings.",
    choose_saving_account_for_withdraw:
      "Please select the savings account from which to withdraw",
    choose_saving_account_for_deposit:
      "Please select the savings account to deposit to.",
    "label-choise-saving-account-owner": "Owner",
    "label-choise-saving-account-agency": "Agency",

    // PAYMENT SECTION
    // Payment section component
    // This component is used to present the details for payment, create new payment or select existing payment in the following pages:
    // Charge Update,
    // Payment Create,
    // Payment Update,
    // Peyment Settle,
    // Payment Link,
    // Charge Link,
    // BankTransaction
    //
    "section/payment-title": "Payment", // Use for payment details section, also for createNew/selectExisting payment section.
    "section/payment-status/unused": "Unused", // Use for payment details section or for select existing payment section(in table row with payment).
    "section/payment-field/person-label": "Person",
    "section/payment-field/company-label": "Company",
    "section/payment-field/аmount-label": "Аmount",
    "section/payment-field/currency-label": "Currency",
    "section/payment-field/date-label": "Date",
    "section/payment-field/bankaccount-label": "Bank Account",
    "section/payment-field/counterpartyiban-label": "Bank account counterparty",
    "section/payment-sub/banktransaction-title/banktransaction":
      "Bank Transaction",
    "section/payment-sub/banktransaction-field/bankaccount-label":
      "Bank Account", //use for BankTransaction page.
    "section/payment-sub/banktransaction-field/counterparty-label": "Name", //use for BankTransaction page.
    "section/payment-sub/banktransaction-field/description-label":
      "Description", //use for BankTransaction page.
    "section/payment-sub/banktransaction-field/transaction-details-label":
      "Transactions details", //use for BankTransaction page.
    "section/payment-radiobutton/existingpayment": "Existing payment", // Use for createNew/selectExisting payment section.
    "section/payment-radiobutton/newpayment": "New payment", // Use for createNew/selectExisting payment section.
    "section/payment-radiobutton/nopayment": "Payment yet unkown", // Use for createNew/selectExisting payment section.
    "section/payment-tab/existing-switch/listswitcher-label":
      "Automatically find payments",
    "section/payment-info/islocked":
      "This payment is locked because it is linked to financial statement",
    "section/payment-info/isremoved": "This payment was removed",
    "section/payment-info/fromdeposit":
      "You can not make any changes when payment has 'From Deposit' type", // Old translation, functionality was removed
    "section/payment-info/paymenttosettle": "Use this payment to settle", // When is this translation used??? Information text for user , that this payment is used to settle.
    "section/payment-hint/companyperson":
      "Select the person or company that made the payment",
    "section/payment-info/selectorcreatecounterparty":
      "This counterparty was not found. Please click 'Select' and select the correct counterparty.",
    "section/payment-button/create": "Create",
    "section/payment-button/select": "Select",
    "section/payment-field/forperiod-label": "Statement period",
    "section/chapaymentrge-field/class-label": "We",
    "section/payment-field/classreceived-label": "Received",
    "section/payment-field/classpaid-label": "Paid",
    "section/payment-info/cannottselectpaymentchargefullypaid":
      "The payment cannot be linked with this charge. This charge is already fully paid.",
    "section/payment-info/cannottselectpaymentmaxpaymentnumberselected":
      "Only :number payments can be linked to a charge in one go.",

    // CHARGES

    // Charge create page
    // Page to create a new charge object
    //
    "page/chargecreate-title": "New charge",
    "page/invoicecreate-title": "New invoice",
    "page/chargecreate-field/invoiceswitch-label": "Invoice",
    "page/payables": "Payables",
    "page/receivables": "Receivables",

    // Charge update page
    // Page to update the details for an existing charge
    //
    "page/chargeupdate-title": "Charge",
    "page/invoiceupdate-title": "Invoice",
    "page/chargeupdate-section/payment-button/anotherpayment":
      "Add another payment",
    "page/chargeupdate-section/payment-title": "Payments",
    "page/chargeupdate-section/payment-button/addpayment": "Add payment",
    "page/chargeupdate-dialog/warning-title/chargeisfullypaid":
      "Charge is fully paid",
    "page/chargeupdate-dialog/warning-title/invoiceisfullypaid":
      "Invoice is fully paid",
    "page/chargeupdate-dialog/warning-info/chargeisfullypaid":
      "You cannot create another payment for this charge. This charge is already fully paid. Remove a payment from this charge or go to a charge not already fully paid and try again.",
    "page/chargeupdate-dialog/warning-info/invoiceisfullypaid":
      "You cannot create another payment for this invoice. This invoice is already fully paid. Remove a payment from this invoice or go to a invoice not already fully paid and try again.",
    "page/chargeupdate-dialog/preprocess-info/unlinkpayment":
      "You're about to unlink the payment. Are you sure?", //User chooses to unlink a payment
    "page/chargeupdate-dialog/preprocess-info/removepayment":
      "You're about to remove the payment. Are you sure", //User chooses to remove a payment
    "page/chargeupdate-section/charge-info/specialcreatedsettlecharge":
      "Read only. This charge was created for the settlement of two payments and can therefor not be changed.", // Additional user information that cannot be modified charge details , use for special charge with type settlement, when user settle two paymnets.
    "page/chargeupdate-section/charge-info/cantupdatesettlecharge":
      "Read only. This charge was settled with another charge and can therefor not be changed.", // Additional user information that cannot be modified charge details , use for charges which were settled.
    "page/chargeupdate-preprocess/considerpay-title":
      "Consider this charge paid",
    "page/chargeupdate-preprocess/considerpay-info":
      "What is the reason to consider this charge paid?",
    "page/chargeupdate-preprocess/considerpay-reason/label": "Reason",
    "page/chargeupdate-preprocess/considerpay-dummydescription":
      "Payment details unknown.",
    "page/chargeupdate-section/charge-info/specialcreatedsavingscharge":
      "The charge details cannot be updated because the charge was registered for the savings.",
    "page/chargeupdate-preprocess/paythischarge-title":
      "Process payment for this charge",
    "page/chargeupdate-preprocess/unrefund-title": "Undo refund",
    "page/chargeupdate-preprocess/unrefund-info":
      "Click Undo to remove the refund charge",
    "page/chargeupdate-preprocess/unrefund-button": "Undo",
    "page/chargeupdate-preprocess/undo-credit-title": "Remove credit",
    "page/chargeupdate-preprocess/undo-credit-info":
      "Click Remove to remove the credit charge and undo the credit",
    "page/chargeupdate-preprocess/undo-credit-button": "Remove",
    "page/chargeupdate-preprocess/undo-withdrawal-title": "Undo withdrawal",
    "page/chargeupdate-preprocess/undo-withdrawal-info":
      "Click Continue to undo the withdrawal from savings account",
    "page/chargeupdate-preprocess/undo-withdrawal-button": "Continue",
    "page/chargeupdate-preprocess/undo-deposit-title": "Undo deposit",
    "page/chargeupdate-preprocess/undo-deposit-info":
      "Click Continue to undo the deposit to savings account",
    "page/chargeupdate-label/paidby": "paid by",
    "page/chargeupdate-label/settledwith": "settled with",
    "page/chargeupdate-hint/chargehasnotmatchingpayments":
      "Search and select the matching payment, and click Save. Or process a payment for this charge.",
    "page/chargeupdate-hint/chargehasmatchingpayments":
      "Select the matching payment and click Continue. Or click the switch and find the matching payment yourself. Or create a new payment.",

    // Charge settlement page
    // Page to settle a charge with a another charge which is to be selected by the user
    //
    "page/chargesettle-title": "Settle charge",
    "page/chargesettle-dialog/attention-info/selectcharge":
      "Please select charge from list",
    "page/chargesettle-dialog/warning-info/notpossibilitychangeamount":
      "You can not change the amount for a charge",

    // Charge settlement dialogs
    // Dialogs used for preprocess and postprocess of the charge settlement process
    //
    "dialog/preprocess-title/settlecharge": "Settle charge",
    "dialog/preprocess-info/сontinuebuttondescription":
      "Click 'Continue' to settle charge :chargeToSettle with charge :chargeSelected",
    "dialog/postprocess-title/paymentcreate": "Payment created",
    "dialog/postprocess-info/paymentwascreated":
      "The charges have been settled",

    // Pay charge page
    // Page to allow a user to link a charge with a payment to be selected by the user
    //
    "page/paycharge-title": "Pay charge",
    "page/payinvoice-title": "Pay invoice",
    "page/paycharge-button/pay": "Pay",

    // Extra charge dialog
    // Dialog used when we link payment with charge and amount of payment more than amount of charge (amountPayment > amountCharge)
    // This dialog is in the following pages:
    //   ChargeUpdate
    //   ChargeCreate
    //   PaymentUpdate
    //   ChargeLink
    //
    "dialog/extracharge-title": "Add charge",
    "dialog/extracharge-button/createextracharge": "Add charge",
    "dialog/extracharge-button/settlethedifference": "Settle payment",
    "dialog/extracharge-info/buttonskip":
      "Click 'Skip' to finish processing this payment later.",
    "dialog/extracharge-info-1":
      "Only :chargeAmount of the payment :paymentAmount was used. Click 'Add charge' to pay another charge. Or click 'Settle payment, to settle with another payment",
    "dialog/extracharge-info-2": `Click button "Create charge" to create an extra charge for :additionalChargeAmount. Or click "Skip" to do it later.`,
    "dialog/extracharge-info/chargeisfullypaid": "Charge is already fully paid",
    "dialog/settlewithsavings-info":
      "The amount of :chargeamount will be drawn from savings and included in the owner’s statement to settle this charge.",

    // Extra payment dialog
    // Dialog used when we link charge with payment and amount of charge more than amount of payment (amountCharge > amountPayment)
    // This dialog is used in the following pages:
    //   ChargeUpdate
    //   PaymentCreate
    //   PaymentUpdate
    //   PaymentLink
    "dialog/extrapayment-title": "Add payment",
    "dialog/extrapayment-info/createextrapayment":
      "Only :paymentAmount of :chargeAmount was paid. Click 'Add payment' to pay the missing amount. Or click 'Settle charge', to settle the remainder with another charge.",
    "dialog/extrapayment-info/buttoncreateextrapayment":
      "Click 'Create extra payment' to create an extra payment for the charge.",
    "dialog/extrapayment-info/buttonskip":
      "Click 'Skip' to finish processing this charge later.",
    "dialog/extrapayment-button/createextrapayment": "Add payment",
    "dialog/extrapayment-button/settlethedifference": "Settle charge",

    // PAYMENTS

    // payment create page
    // Page to allow a user to create a new payment
    //
    "page/paymentcreate-title": "New payment",

    // Payment update page
    // Page to allow a user to update the details for a payment
    //
    "page/paymentupdate-title": "Payment",
    "page/paymentupdate-section/charge-title": "Charges",
    "page/paymentupdate-section/charge-info/chargesnotfound": "No charges yet",
    "page/paymentupdate-dialog/warning-title/fullyused":
      "Payment is already fully used",
    "page/paymentupdate-dialog/warning-info/fullyused":
      "This payment is already fully used. You can not link it with charges",
    "page/paymentupdate-dialog/preprocess-info/chargewillbeunlinked":
      "The charge will be unlinked from the payment. After unlinking the charge becomes - partially - unpaid and the payment becomes available again to pay another charge. Are you sure?",
    "page/paymentupdate-link/updatestatementperiod": "Update",
    "page/paymentupdate-dialog/updatestatementperiod-title":
      "Select the owner statement period",
    "page/paymentupdate-dialog/updatestatementperiod-hint":
      "Select the owner statement period in which to place the payment",
    "page/chargeupdate-dialog/updatestatementperiod-hint":
      "Select the owner statement period in which to place the charge",
    "page/paymentupdate-section/payment-info/specialcreatedsettlepayment":
      "This payment was created to settle two charges", // Additional user information that cannot be modified payment details , use for special payment with type settlement, when user settle two charges.
    "page/paymentupdate-section/payment-info/cantupdatesettlepayment":
      "This payment was settled with another payment", // Additional user information that cannot be modified payment details , use for payments which were settled.
    "page/paymentupdate-preprocess/considerused-title":
      "Consider this payment processed",
    "page/paymentupdate-preprocess/considerused-info":
      "What is the reason to consider this payment fully used?",
    "page/paymentupdate-preprocess/considerused-reason/label": "Reason",
    "page/paymentupdate-preprocess/considerused-dummydescription":
      "Skipped transaction",
    "page/paymentupdate-preprocess/considerfullyused-info":
      "This payment will be considered fully used. For that purpose a charge for the remaining amount is created and linked to this payment.",
    "page/paymentupdate-preprocess/agencycosts-info":
      "This payment is processed as costs for :agencyName. For this purpose a purchase charge is created and linked to the payment.",
    "page/paymentupdate-postprocess/agencycosts-info":
      "A purchase charge is created and linked to the payment.",
    "page/paymentupdate-preprocess/agencycosts-title":
      "Process as costs for :agencyName",
    "page/paymentupdate-preprocess/agencycosts-hint":
      "The name found in the payment is :paymentName",
    "page/paymentupdate-preprocess/agencyfeecharge-info":
      "This payment will be linked to unpaid agency fee charges, oldest ones first. Continue?",
    "page/paymentupdate-postprocess/agencyfeecharge-linked-info":
      "With this payment :count charges were paid.",
    "page/paymentupdate-postprocess/agencyfeecharge-max-linked-info":
      "A maximum of 5 agency fees were paid. Try again to pay more agency fees.",
    "page/paymentupdate-preprocess/incomeforagency-info":
      "The received amount is going to be added to :agencyname's savings. These savings are used to pay any costs, or can be withdrawn and send to :agencyname's bank account at any time. Continue?",
    "page/paymentupdate-section/payment-info/specialcreatedsavingspayment":
      "This payment was created to settle a charge with the savings account", // Additional user information that cannot be modified payment details , use for special payment with type savings, when user registered payments for the savings account.
    "page/paymentupdate-preprocess/considerprocess-description":
      "Charge unknown",
    "page/paymentupdate-preprocess/refund-title": "Refund",
    "page/paymentupdate-preprocess/refund-info":
      "Click Refund to create a refund charge",
    "page/paymentupdate-preprocess/refund-button": "Refund",
    "page/paymentupdate-label/paidfor": "paid for",
    "page/paymentupdate-label/settledwith": "settled with",
    "page/paymentchargeupdate-label/relatedto": "related to",
    "page/paymentupdate-hint/transactionautomaticallylinked":
      "Casadesk automatically linked the charge(s) below to this payment. Correct? Then click Verified. Not correct? Then unlink the charge(s) and link the correct charge(s) yourself.",
    "page/paymentupdate-hint/paymenthasnotmatchingcharges":
      "Search and select the matching charge, and click Save. Or create a new charge based on this payment.",
    "page/paymentupdate-hint/paymenthasmatchingcharges":
      "Select the charge(s) for this payment and click Save. Or click the switch and find the charge(s) yourself. Or create the charge for this payment.",
    "page/paymentupdate/question1":
      "The charge below was automatically linked with this payment. Is it the right charge for this payment?",
    "page/paymentupdate/tab/select-charge": "Select charge",
    "page/paymentupdate/tab/find-charge": "Find charge",
    "page/paymentupdate/tab/new-charge": "New charge",
    "page/paymentupdate/tab/select-charge/panel-title":
      "Select the charge(s) for this payment and click Save",
    "page/paymentupdate/tab/find-charge/panel-title":
      "Find and select the charge(s) for this payment and click Save",

    // Payment settlement page
    // Page to allow a user to settle the payment with a payment which the user needs to select
    //
    "page/paymentsettle-title": "Settle Payment",
    "page/paymentsettle-dialog/warning-info/notpossibilitychangeamount":
      "You can not change the amount for a payment",
    "page/paymentsettle-dialog/warning-info/cannotsettlewithequaltypes":
      "Can not settle payment and charges with equal types",
    "page/paymentsettle-dialog/warning-info/selectpayment":
      "Please select payment from existing payments or create new",

    // Payment settlement dialogs
    // Dialogs used for preprocess and postprocess of the payment settlement process
    //
    "dialog/preprocess-title/paymentsettle": "Settle Payment", // Use for dialog on page payment settle and for payment list.
    "dialog/preprocess-info/settlepayment":
      "Click 'Continue' to settle payment :paymentToSettle with payment :paymentSelected.",
    "dialog/postprocess-title/chargecreated": "Charge created",
    "dialog/postprocess-info/chargecreated":
      "A charge was created to settle payment :paymentToSettle with payment :paymentSelected",

    // Payment link/use page
    // Page to allow a user to link a payment (and thus pay) a charge
    //
    "page/paymentlink-title/additionalcharge": "Additional charge for payment", // Title when only a remaining amount is available as the payment was already used before
    "page/paymentlink-title/usepayment": "Use payment", // Title when the full amount of the payment is still available
    "page/paymentlink-section/charge-title/additionalcharge":
      "Select additional charge",

    // Bank Account dialog
    // Dialog used when we want choose bank account for payment or add new bank account to payment.
    //
    "dialog/bankaccount-title": "Bank Account",
    "dialog/bankaccount-field/number-label": "Bank account",
    "dialog/bankaccount-field/name-label": "Bank account is in the name of",
    "dialog/bankaccount-field/label-label": "Name",
    "dialog/bankaccount-checkbox/default": "Default",

    // Task create/update dialogs
    // Dialogs used for preprocess and postprocess of task create/update processes
    //
    "preprocess/taskcreate-hint":
      "You are about to create a new task. An email with the task details will be send automatically to the person assigned to the task.",
    "postprocess/taskcreate-hint":
      "The task was created but the email with the details could not be sent because the email address of the person is unknown",
    "preprocess/taskupdate-hint":
      "You are about to update the task. An email with the task details will be send automatically to the person assigned to the task.",
    "postprocess/taskupdate-hint":
      "The task was updated but the email with the details could not be sent because the email address of the person is unknown",

    // Task update page
    "page/taskupdate-hint/taskforproperty": "Object Property: ",
    "page/taskupdate-hint/taskforunit": "Object Unit: ",
    "page/taskupdate-hint/object": "Object: ",
    "page/taskupdate-hint/taskforcharge": "Object Charge: ",
    "page/taskupdate-link/sendinvoice": "Send by email",
    "page/taskupdate-hint/taskfor": ":entity",

    // Conversation update page
    "page/conversationupdate-hint/relatedto": ":entity: ",

    // Note update page
    "page/noteupdate-hint/notefor": "Note for :entity: ",

    //Timelime component
    "tab/tasks-by/label": "By",
    "tab/tasks-for/label": "for",
    "tab/tasks-duedate/label": "due date",

    // Unit list
    "page/unitlist-tooltip/taskicon-overdueunfinished":
      "Tasks: :unfinished unfinished(:overdue past due date)",
    "page/unitlist-tooltip/taskicon-unfinished":
      "Tasks: :unfinished unfinished",
    "page/unitlist-unit-info/templateupdatedate": "rent updated :date",

    // Launchpanel
    "launchpanel-link/register-an-incoming-invoice":
      "Process an incoming invoice",
    "launchpanel-link/create-a-new-task": "Create a new task",
    "launchpanel-title": "DO NOW",
    "launchpanel-link/send-statements": "Send statements to owners",
    "launchpanel-link/withdrawal-agency-savings": "Withdraw from savings",
    "launchpanel-link/createnewunit": "Create unit",
    "launchpanel-link/createnewproperty": "Create property",
    "launchpanel-link/createnewcontract": "Create contract",
    "launchpanel-charge-title": "SELECT AN ACTION FOR THIS CHARGE",
    "launchpanel-payment-title": "SELECT AN ACTION FOR THIS PAYMENT",
    "launchpanel-contract-title": "SELECT AN ACTION FOR THIS CONTRACT",
    "launchpanel-unit-title": "SELECT AN ACTION FOR THIS UNIT",
    "launchpanel-property-title": "SELECT AN ACTION FOR THIS ADDRESS",
    "launchpanel-person-title": "SELECT AN ACTION FOR THIS PERSON",
    "launchpanel-person-task": "SELECT AN ACTION FOR THIS TASK",
    "launchpanel-company-title": "SELECT AN ACTION FOR THIS COMPANY",
    "launchpanel-conversation-title": "ACTIONS FOR THIS CONVERSATION",
    "launchpanel-link/newrealestate": "New real estate",
    "launch-panel-send-tenant-portal-link": "Send portal link to tenant",
    "launch-panel-create-incident": "New task",
    "launchpanel-agreement-title": "SELECT AN ACTION FOR THIS AGREEMENT",
    "launchpanel-hint/deletecompany": "Permanently delete this company",
    "launchpanel-link/addcontactforcompany": "Add a contact person",
    "launchpanel-hint/addcontactforcompany":
      "Add a contact person for this company",
    "launchpanel-link/addpropertyforcompany": "Add a unit",
    "launchpanel-hint/addpropertyforcompany":
      "Add a unit for which this company is the landlord",
    "launchpanel/unit-option/createchargetemplate":
      "Create a new charge template",
    "launchpanel/unit-option/createchargetemplate-hint":
      "Automatically create monthly charges, for example for the contributions to the owner association",
    "launchpanel/property-option/createunit": "Add a unit",
    "launchpanel/property-option/createunit-hint":
      "Create a unit and link it with this address",
    "launchpanel/property-option/createchargetemplate":
      "Create a new charge template",
    "launchpanel/property-option/createchargetemplate-hint":
      "Automatically create monthly charges, for example for the contributions to the owner association",
    "launchpanel/property-option/createcharge": "Create an extra charge",
    "launchpanel/property-option/createcharge-hint": "An extra cost to be paid by the owner for this address, or an extra amount to be received by the owner (a tax return for example)",
    "launchpanel/download-csv-file": "Download charges as XLSX file (comma seperated values) to be used in - for example - a spreadsheet application",

    // Invoice update
    "page/invoiceupdate-link/sendinvoice": "Send by email",
    "page/invoiceupdate-link/sendinvoice-hint":
      "Send a copy of this charge by email to anyone you want",
    "page/invoiceupdate-link/sendcontract-hint":
      "Send the details of this contract by email",
    "page/invoiceupdate-dialog/sendinvoice-title": "Send this invoice by email",
    "page/invoiceupdate-dialog/sendinvoice-field/to-label": "To",
    "page/invoiceupdate-dialog/sendinvoice-field/message-label": "Message",

    // Property update and create page
    "page/propertyupdate-section/property-tab/details-field/contactinformationofassociation-label":
      "Property Owner Association contact details",

    // Property create page
    "page/propertycreate-field/contactinformationofassociation-label":
      "Property Owner Association contact details",
    "page/propertycreate-field/associationownerid-label":
      "Property Owner Association contact",

    /* Contract renew page */
    "page/renewcontract-dialog/calculateprice-field/oldamount-label":
      "Old price",
    "page/renewcontract-dialog/calculateprice-field/newamount-label":
      "New price",
    "page/renewcontract-dialog/calculateprice-field/percentage-label":
      "Percentage",
    "page/renewcontract-dialog/calculateprice-title": "Update contract price",
    "page/renewcontract-section/prices-icon/updatecontractprice-tip":
      "Update contract price",
    "coach/renew-contract/first-title": "Contract",
    "coach/renew-contract/second-title": "Tenant",
    "coach/renew-contract/third-title": "Rent",
    "coach/renew-contract/fourth-title": "Start date",
    "coach/renew-contract-step/step1-title": "The contract",
    "coach/renew-contract-step/step1-subtitle": "The contract to be renewed",
    "coach/renew-contract-step/step2-title": "The tenant",
    "coach/renew-contract-step/step2-subtitle":
      "Renew the tenant details, or click Next",
    "coach/renew-contract-step/step3-title": "The rent",
    "coach/renew-contract-step/step3-subtitle":
      "Renew rent prices for :unitShortDisplayName",
    "coach/renew-contract-step/step4-title": "Dates",
    "coach/renew-contract-step/step4-subtitle":
      "Set the dates for the renewed contract for :unitShortDisplayName",
    "coach/renew-contract-step/step5-hint": "Review and click Finish",
    "coach/renew-contract-step/step6-hint":
      "The new contract conditions were saved.",
    "coach/renew-contract-step/new-person": "New person",
    "coach/renew-contract-step/known-person": "Known person",

    //Stepper for new user
    "stepper/invitenewuser-step/first-title": "Welcome!",
    "stepper/invitenewuser-step/first-info":
      "Welcome to the Casadesk. The smart choice to manage your properties, finances, communications and more.",
    "stepper/invitenewuser-step/second-title": "Main menu",
    "stepper/invitenewuser-step/second-info":
      "Find the main menu in each page to the left. Select an item and find more details about that item.",
    "stepper/invitenewuser-step/third-title": "Search",
    "stepper/invitenewuser-step/third-info":
      "Find the general search box in the header of each page. Start typing a name or address and quickly find the object you’re looking for.",

    // Send Email
    "page/sendemail-title/sendemail": "New email message",
    "page/sendemail-hint/objectdetails":
      "The email sent will also contain more details about: :object.",
    "page/sendemail-dialog/attention-info": "Cancel the new email message?",
    "page/sendemail-message1/statement":
      "As an attachment to this message you'll find a settlement invoice. An amount to be received will be transferred into your bank account as soon as possible. For an amount that you need to pay we kindly request you to send it to us within the next few days.",
    "page/sendemail-message2/statement":
      "Should any costs have occurred during recent period, you'll find a copy of the relevant invoices as an attachment to this message.",
    "page/sendemail-message/invoice":
      "Please find below more details about the charge.",
    "page/sendemail-message/contract":
      "Please find below more details about the contract.",
    "page/sendemail-message/payment": "Please find below the payment details.",
    "page/sendemail-message/task":
      "Please find more details about the task below. The contact details of the tenant are:",
    "page/sendemail-message/chargeunpaid":
      "The due date for an invoice has passed. We appreciate your prompt settlement.",
    "page/sendemail-message/chargepartlypaid":
      "An invoice was not yet - fully - paid. We appreciate your prompt settlement.",
    "page/sendemail-message/hello": "Hello",
    "page/sendemail-message/dear": "Dear",
    "page/sendemail-message1/collectiveinvoice":
      "Please find attached the details for the first payment for the rental of :unitDisplayName.",
    "page/sendemail-message2/collectiveinvoice":
      "We expect to receive the payment on or before :chargeDueDate",
    "page/sendemail-message3/collectiveinvoice": "Kind regards,",
    "page/sendemail-message1/lastcollectiveinvoice":
      "Please find as attachment the final statement for the rent of :unitDisplayName.",
    "page/sendemail-message/tenant-login-portal-link":
      "Click the button below to access the tenant portal of :agencyName",
    "page/sendemail-message/requeststatementsreview":
      "The following link will take you to the list with owner statements which are ready to review. \n\nClick the PDF link to review the owner statement. \n\nWhen finished, set the statement to ready to send.\n\nhttps://:domain/app/dashboard/statements",
    "page/sendemail-link/updatedefaulttext":
      "Update the default text for this email",
    "page/sendemail-label/sendcopytoemails":
      "Send a copy of the attachment(s) to:",
    "page/sendemail-message/sendcopytomessage": "See attachment(s).",
    "page/sendemail-label/sendcopyto": "Send a copy of the attachment(s) to",
    "page/sendemail-message/message-beginning":
      "In conformance with contract conditions and related regulations the rent will change starting :newContractStartDate for :unitDisplayName.",
    "page/sendemail-message/rent-until":
      "The rent price until :oldContractEndDate:",
    "page/sendemail-message/rent-after":
      "The rent price starting :newContractStartDate:",
    "page/sendemail-message/message-ending": "See also attached document.",
    "page/sendemail-message/renewed-contract":
      "Soon we’ll apply a rent adjustment. By changing the rent the agency fee could also change. Please find the details below.\n\nThis message is for your information, no action is needed from you. If you have questions, do not hesitate to contact us, or send us a reply to this message. ",
    "page/sendemail-message3/renewed-contract": "With kind regards,",
    "page/sendemail-message/agreement-until":
      "The agency fee until :oldContractEndDate:",
    "page/sendemail-message/agreement-after":
      "The agency fee from :newContractStartDate:",

    // Dashboard
    "page/dashboard-tab/notifications": "Notifications",
    "page/dashboard-tab/receivables": "To receive",
    "page/dashboard-tab/payables": "To pay",
    "page/dashboard-tab/activities": "Activities",
    "page/dashboard-tab/notes": "Notes",
    "title-no-notifications-to-list": "No notifications found",
    "title-no-activities-to-list": "No activities found",
    "title-no-contracts-to-list": "No contracts found",
    "title-no-tasks-to-list": "No tasks found",
    "title-no-notes-to-list": "No notes found",
    "page/dashboard-tab/activities-dialog/noactivitytemplates-1":
      "Cannot create a new activity. To create a new activity an activity template is necessary, and at this time no activity templates are available.",
    "page/dashboard-tab/activities-dialog/noactivitytemplates-2":
      "Please go to Settings and create an activity template (only available for administrators).",
    "page/dashboard-tab/activities-section/tableofactivities-label/closedtasks":
      "Tasks closed",
    "page/dashboard-tab/unpaid-section/charge-info/chargesnotfound":
      "No charges yet",
    "page/dashboard-tab/payments": "Payments",
    "page/dashboard-tab/statements-button/requeststatementsreview":
      "Request for review owner statements",
    "page/dashboard-tab/messages": "Messages",
    "page/dashboard-tab/start-section/statistic-button/newrentalunit":
      "New unit rental",
    "page/dashboard-tab/start-section/statistic-label/registred": "REGISTRED",
    "page/dashboard-tab/start-section/statistic-label/clickbutton":
      "Click and register a",
    "page/dashboard-tab/start-section/statistic-info/includingpropertyandowner":
      "Including property and owner details",
    "page/dashboard-tab/start-section/statistic-info2/unitrental":
      "New owner + units",
    "page/dashboard-tab/start-section/statistic-info1/unitrental":
      "Click to register a new owner and units",
    "page/dashboard-tab/start-section/statistic-info1/unit": "A unit is a:",
    "page/dashboard-tab/start-section/statistic-info2/unit":
      "self contained living accommodation",
    "page/dashboard-tab/start-section/statistic-info3/unit":
      "room with shared facilities",
    "page/dashboard-tab/start-section/statistic-button/newunit": "New unit",
    "page/dashboard-tab/start-section/statistic-info1/property":
      "An address is typically one with:",
    "page/dashboard-tab/start-section/statistic-info2/property":
      "a self contained unit",
    "page/dashboard-tab/start-section/statistic-info3/property":
      "multiple units (rooms) to be rented separately",
    "page/dashboard-tab/start-section/statistic-button/newproperty":
      "New Address",
    "page/dashboard-tab/start-section/statistic-button/newlandlord":
      "New owner",
    "page/dashboard-tab/start-section/statistic-info1/landlord":
      "The contact for a address is typically referred to as owner and could be the owner of the address directly, or a caretaker.",

    "page/dashboard-tab/start-section/statistic-button/newrentalcontract":
      "New rental contract",
    "page/dashboard-tab/start-section/statistic-info/includingtenantandoccupant":
      "Including tenant and occupant details",
    "page/dashboard-tab/start-section/statistic-info1/contract":
      "A rental contract is an agreement between the tenant and the owner. It allows the tenant or occupant access to and use of the unit.",
    "page/dashboard-tab/start-section/statistic-button/newcontract":
      "New contract",
    "page/dashboard-tab/start-section/statistic-title/contract": "Contract",
    "page/dashboard-tab/start-section/statistic-info1/tenant":
      "A tenant is party in the rental contract and can be a:",
    "page/dashboard-tab/start-section/statistic-info2/tenant": "person",
    "page/dashboard-tab/start-section/statistic-info3/tenant":
      "company or organization",
    "page/dashboard-tab/start-section/statistic-button/newtenant": "New tenant",

    "page/dashboard-tab/start-section/statistic-button/increaserent":
      "Adjust rent",
    "page/dashboard-tab/start-section/statistic-title/increaserent":
      "Adjust the rent",
    "page/dashboard-tab/start-section/statistic-info1/increaserent":
      "Increase, or otherwise adjust, the rent for an existing contract",
    "coach/increaserent-step/first-title": "Contract",
    "coach/increaserent-step/second-title": "Rent",
    "coach/increaserent-step2/title": "The new rent prices",
    "coach/increaserent-step2/subtitle":
      "The new rent prices for :unitDisplayName",
    "coach/increaserent-step3/title": "Set the first day",
    "coach/increaserent-step3/subtitle":
      "Set the first day for the new prices for :unitDisplayName",
    "coach/increaserent-step3/date-hint":
      "Date at which to review the rent prices again",
    "coach/increaserent-step/third-title": "Date",
    "coach/increaserent-step/first-info1":
      "Select the unit for which you want to update the rent",
    "coach/increaserent-step/second-info1":
      "Update the price(s) for the rental contract",
    "coach/increaserent-step/third-info1":
      "Determine the first date for the new prices and click Finish",
    "coach/increaserent-step/step1-hint":
      "Select the contract for which one or more prices need to be adjusted",
    "coach/increaserent-step/step2-hint": "Update rent prices",
    "coach/increaserent-step/step3-hint":
      "The new prices will be applied from the start date on",
    "coach/increaserent-step/step4-hint": "Review and click Finish",
    "coach/increaserent-step/step5-hint":
      "The new contract conditions were saved.",
    "coach/increaserent-step/old-prices": "Old prices",
    "coach/increaserent-step/new-prices": "New prices",
    "coach/increaserent-step/start-date": "Start date",
    "coach/increaserent-step/new-price": "New price",
    "page/dashboard-tab/start-section/statistic-info1/creditcharge":
      "Credit note",
    "page/dashboard-tab/start-section/statistic-info1/provideinvoice":
      "Incoming invoice",
    "page/dashboard-tab/start-section/statistic-title/statements":
      "Owner statements",
    "page/dashboard-tab/start-section/statistic-info/statements":
      "Owner statements that are ready to review and send",
    "coach/creditcharge-info1":
      "Find the charge for which you want to create a credit charge",
    "increaserent-label": "Adjust rent",
    "coach/creditcharge-error": "No charges found",
    "link-to-all-charges": "To all charges",
    "link-to-all-payments": "To all payments",
    "link-to-all-statements": "To all owner statements",

    // Pay Unit Charges
    "page/payunitcharges-section/payment-hint":
      "Click 'Finish' to create a payment of :amount and pay selected charges.",

    // Activity details
    "page/activitydetails-dilalog/checkclosedstatus-info":
      "You are about to close an activity. However, not all tasks in this activity are yet closed. Are you sure you want to close this activity?",
    "page/activitydetails-hint/opentasksnumber":
      "Check the tasks for this activity ( open tasks: :numberOfOpenTasks ) and Close this activity if all tasks are done.",
    "page/activitydetails-dilalog/checkclosedstatus-button/close": "Close",

    // Finance -> Charges
    "finance-charges-filter/date-label/chargesbefore": "Charges before date",

    // Finance -> Invoices
    "finance-invoice-filter/date-label/fromdate": "From date",

    // Finance -> Payments
    "finance-payments-filter/date-label/paymentsbefore": "Payments before date",

    "charge-summary-title/receivable": "CHARGE to receive from",
    "charge-summary-title/payable": "CHARGE to pay to",
    "chargetemplate-summary-title/receivable":
      "Charge template - to be received",
    "chargetemplate-summary-title/payable": "Charge template - to be paid",
    "contractitem-summary-title/receivable": "Contract amount - to be received",
    "contractitem-summary-title/payable": "Contract amount - to be paid",
    "defaultchargetemplate-summary-title/receivable":
      "Default contract amount - to be received",
    "defaultchargetemplate-summary-title/payable":
      "Default contract amount - to be paid",
    "charge/payment-summary-title/savings": "savings",
    "charge-summary-details/period": "Period:",
    "charge-summary-details/ownerstatement": "Statement:",
    "charge-summary-details/invoicenumber": "Invoice number",
    "charge-summary-details/credits": "Credit related charge: ",
    "charge-summary-details/related": "Related charge: ",
    "charge-summary-details/not-part-of-owner-statement":
      "This charge is not part of an owner statement",
    "charge-summary-class/receive": "receive",
    "charge-summary-class/pay": "pay",
    "charge-summary-class/settled": "settled",
    "charge-summary-state/paid": "paid",
    "charge-summary-state/received": "received",
    "charge-summary-state/unpaid": "unpaid",
    "charge-summary-state/removed": "removed",
    "charge-summary-state/remainingtoreceive": "remaining to receive:",
    "charge-summary-state/remainingtopay": "remaining to pay:",
    "charge-summary-state/status": "Status:",
    "charge-summary-readonly/wassettled":
      "This charge was settled with another charge",
    "charge-summary-readonly/settlement":
      "This charge was created to settle two payments",
    "charge-summary-readonly/payout":
      "This charge was created for a financial statement",
    "charge-summary-readonly/withsavings":
      "This charge was settled with the savings account",
    "charge-summary-readonly/removed": "This charge was removed",
    "charge-summary-readonly/refund":
      "This charge was created as part of a refund",
    "charge-summary-readonly/ispaiddirectlytoowner":
      "This charge was paid directly to the owner",
    "charge-summary-readonly/isinvoice": "This charge is part of an invoice",
    "charge-summary-readonly/islocked":
      "This charge is part of a now closed statement",
    "charge-summary-details/savings": "Related charge: ",
    "charge-section/payment-action/findpayment": "Find payment",
    "charge-section/payment-action/settlecherge": "Settle charge",
    "payment-summary-title/receivable": "PAYMENT received from",
    "payment-summary-title/payable": "PAYMENT paid to",
    "payment-summary-class/received": "Received from",
    "payment-summary-class/paid": "paid",
    "payment-summary-details/amount": "Amount",
    "payment-summary-details/type": "Type",
    "payment-summary-details/paidto": "To",
    "payment-summary-details/paidfrom": "From",
    "payment-summary-details/unknown": "Unknown",
    "payment-summary-details/description": "Description",
    "payment-summary-details/transactiondetails": "Transaction",
    "payment-summary-readonly/refund": "This payment is part of a refund",
    "payment-summary-readonly/transaction":
      "This payment was created from a MT940 bank transaction",
    "payment-summary-readonly/ponto": "This payment was created from a Ponto",
    "payment-summary-state/used": "processed",
    "payment-summary-state/unused": "unused",
    "payment-summary-state/part-unused": "unused",
    "payment-summary-state/removed": "removed",
    "payment-summary-state/remainingtouse": "remaining to use:",
    "payment-summary-state/status": "Status:",

    // Readonly reasons

    "agreement-readonly/removed": "This agreement is removed",
    "agreement-readonly/signed":
      "This agreement is signed; to update, set the end date and create a new agreement",
    "contract-readonly/removed": "This contract was removed",
    "contract-readonly/signed":
      "This contract is signed. Select renew to update details of this contract, a new occupant for example. Or delete this contract if it contains errors, and create a new contract.",
    "property-readonly/removed": "This address was removed",
    "unit-readonly/removed": "This unit was removed",
    "person-readonly/removed": "This contract was removed",
    "company-readonly/removed": "This company was removed",

    // Conversations

    "label-conversation": "Conversation",
    "label-new-conversation": "New conversation",
    "label-conversation-with": "Conversation with :person",
    "title-messages": "Messages",
    "label-unread": "Unread",
    "label-email-notification": "Email notifications to",
    "label-sms-notification": "Sms notification",
    "status-email-notification-failed": "Email not delivered!",
    "status-sms-notification-failed": "SMS not delivered!",
    "title-no-messages-to-list": "No open conversations found",
    "preprocess/createincidentfromconversation-hint":
      "A new task will be  created and linked to this conversation",
    "label-subject": "Subject",

    // Unit spreadsheet
    "spreadsheet/unit-property": "Property",
    "spreadsheet/unit-type": "Type",
    "spreadsheet/unit-agreementservice": "Agreement.Service",
    "spreadsheet/unit-defaultdeposit": "Default deposit",
    "spreadsheet/unit-defaultbasicrent": "Default basic rent",
    "spreadsheet/unit-agreementagencyfee": "Agreement.Agency fee",
    "spreadsheet/unit-contracttenant": "Contract.Tenant",
    "spreadsheet/unit-contractoccupants": "Contract.Occupants",
    "spreadsheet/unit-contractstatus": "Contract.Status",
    "spreadsheet/unit-contractfirstdate": "Contract.First date",
    "spreadsheet/unit-contractexpirationdate1": "Contract.Expiration date 1",
    "spreadsheet/unit-contractexpirationdate2": "Contract.Expiration date 2",
    "spreadsheet/unit-contractenddate": "Contract.End date",
    "spreadsheet/unit-contractnotificationdate": "Contract.Notification date",
    "spreadsheet/unit-contractdeposit": "Contract.Deposit",
    "spreadsheet/unit-contractbasicrent": "Contract.Basic rent",

    // New charge coach
    "coach/newcharge-step1/title": "New charge",
    "coach/newcharge-step1/title-payment": "New charge for :amount",
    "coach/newcharge-step1/subtitle":
      "An amount to be paid or received by a landlord or :agencyName",
    "coach/newcharge-step1/option-tobereceived":
      "Register an amount to be received",
    "coach/newcharge-step1/option-tobepaid": "Register an amount to be paid",
    "coach/newcharge-step1/option-registerincominginvoice":
      "Process an invoice to be paid",
    "coach/newcharge-step1/hint-registerincominginvoice":
      "You’ve received an invoice to be paid by an owner or :agencyName",
    "coach/newcharge-step2/title-type/tobereceived": "Receiver",
    "coach/newcharge-step2/subtitle-type/tobereceived":
      "Select on behalf of whom the amount is to be received",
    "coach/newcharge-step2/choicehint-type/tobereceived":
      "Amount to be received by:",
    "coach/newcharge-step2/title-type/tobepaid": "Payer",
    "coach/newcharge-step2/subtitle-type/tobepaid":
      "Select on behalf of whom the amount is to be paid",
    "coach/newcharge-step2/choicehint-type/tobepaid": "Amount to be paid by:",
    "coach/newcharge-step2/title-type/registerincominginvoice": "Payer",
    "coach/newcharge-step2/subtitle-type/registerincominginvoice":
      "Select on behalf of whom the amount is to be paid",
    "coach/newcharge-step2/choicehint-type/registerincominginvoice":
      "Invoice to be paid by:",
    "coach/newcharge-step3/step-title-tobereceived": "To be received",
    "coach/newcharge-step3/title-type/tobereceived": "To receive",
    "coach/newcharge-step3/subtitle-type/tobereceived":
      "Details about the amount to receive",
    "coach/newcharge-step3/step-title-tobepaid": "To pay",
    "coach/newcharge-step3/title-type/tobepaid": "To pay",
    "coach/newcharge-step3/title-type/tobepaid-payment":
      "New charge: to be paid",
    "coach/newcharge-step3/subtitle-type/tobepaid":
      "Details about the amount to pay",
    "coach/newcharge-step3/title-type/registerincominginvoice": "To pay",
    "coach/newcharge-step3/subtitle-type/registerincominginvoice":
      "Provide more details about the invoice",
    "coach/newcharge-step3/payment/received-title": "Received amount :amount",
    "coach/newcharge-step3/payment/received-title-counterparty":
      "The amount :amount was received from :counterparty",
    "coach/newcharge-step3/payment/paid-title": "Paid amount :amount",
    "coach/newcharge-step3/payment/paid-title-counterparty":
      "The amount :amount was paid to :counterparty",
    "coach/newcharge-step4/title": "Add attachment",
    "coach/newcharge-step4/subtitle": "Upload related files",
    "coach/newcharge-step5/toreceivefrom": "To receive from",
    "coach/newcharge-step5/topayto": "To pay to",
    "link/anameonly": "A name only",
    "link/selectcounterparty": "Select counterparty",
    "charge-creation-successful": "The new charge was successfully created",
    "charge-creation-failed": "Charge creation failed",
    amount_related_to: "Related to contract or unit",
    service_provided_in_period: "Service or product provided in period",
    include_charge_in_statement_for_period:
      "Include charge in statement for period",
    "coach/newcharge-step2/error/please-select-an-owner":
      "Please select an owner",
    "coach/paymentcharge-step1/charge-to-be-received": "Charge to be received",
    "coach/paymentcharge-step1/charge-to-be-paid": "Charge to be paid",
    "coach/paymentcharge-step1/credit-charge": "Credit charge",
    credit_charge_for_payment: "Credit charge for payment",
    show_more: "More...",
    show_less: "Less...",
    received_for: "Received for",
    paid_for: "Paid for",
    this_field_automatically_filled: "This field was automatically set",
    "coach/newcharge/selectcharge": "Select a charge",
    "coach/newcharge/selectchargelabel":
      "The charge for which the credit is provided",
    "coach/summary/object-label": "Object",
    "coach/step2/landlord-label": "Landlord",
    "coach/counterpartystep/receivable/title": "To receive from",
    "coach/counterpartystep/receivable/subtitle": "Select from whom to receive",
    "coach/counterpartystep/payable/title": "To pay to",
    "coach/counterpartystep/payable/subtitle": "Select to whom to pay to",
    "coach/newagreement/step1/title": "New agreement",
    "coach/newagreement/step1/subtitle":
      "Date agreement and service to be provided",
    "coach/newagreement/step2/title": "Fee",
    "coach/newagreement/step2/subtitle":
      "Details for the automatic creation of compensation charges",
    "coach/newagreement/date-agreement": "Date agreement",
    "agreement-creation-successful":
      "The new agreement was successfully created",
    "agreement-update-successful": "The agreement was successfully updated",
    bank_account_minimum_amount_error:
      "There is at least 1 bank account necessary",
    "payment-details-hint":
      "Is this payment a payout to :agencyName? Then settle this payment with the savings of :agencyName.",

    // General Coach translations
    "coach/general-forelast-create-subtitle-dutch-de":
      "Click Finish to create the new :entity",
    "coach/general-forelast-create-subtitle-dutch-het":
      "Click Finish to create the new :entity",
    "coach/general-summary-create-subtitle-dutch-de":
      "The new :entity was successfully created",
    "coach/general-summary-create-subtitle-dutch-het":
      "The new :entity was successfully created",
    "coach/general-forelast-update-subtitle-dutch-de":
      "Click Finish to update the :entity",
    "coach/general-forelast-update-subtitle-dutch-het":
      "Click Finish to update the :entity",
    "coach/general-summary-update-subtitle-dutch-de":
      "The :entity was successfully updated",
    "coach/general-summary-update-subtitle-dutch-het":
      "The :entity was successfully updated",

    // Ponto
    "revoke-access-from-ponto-button": "Disconnect bank account",
    "syncronize-with-ponto-button": "Sync with bank account",
    "charge-to-be-created": "charge",
    please_disconnect_from_ponto:
      "Please disconnect the active default bank account from Ponto first, then try again.",
    ponto_count_of_created_payments: ":count new payments :datetime",
    ponto_no_default_bank_account:
      "Set a default bank account in Settings to use Ponto.",
    ponto_no_default_bank_account_title: "Set default bank account",
    ponto_no_default_bank_account_body:
      "Go to Settings | Bank accounts, and set Default for one bank account.",
    // Ponto: panel status
    ponto_status_authorizing: "Authorization in progress...",
    ponto_status_connected: "Connected, not yet synced",
    ponto_status_sync_pending: "Sync in progress...",
    ponto_status_sync_failed: "Sync failed",
    ponto_status_sync_failed_at: "Sync failed :datetime",
    ponto_status_sync_failed_at_with_reason: "Sync failed :datetime — :reason",
    // Ponto: sync failure reasons
    ponto_sync_failure_reason_synchronization_failed: "sync error at Ponto",
    ponto_sync_failure_reason_authorization_expired: "authorization expired",
    ponto_sync_failure_reason_bank_connection_required: "authorization expired",
    ponto_sync_failure_reason_unknown: "unknown error",
    ponto_sync_failure_reason_fallback: "unknown error",
    // Ponto: snackbars
    ponto_redirect_success: "Bank account connected",
    ponto_no_sync_needed_snackbar: "Last sync is still up to date",
    // Ponto: auth dialogs — shared
    "connect-to-ponto-button": "Connect bank account",
    ponto_auth_button: "Authorize",
    ponto_auth_close_button: "Close",
    ponto_auth_restart_button: "Restart",
    // Ponto: auth dialog titles
    ponto_auth_no_integration_title: "Connect bank account to Ponto",
    ponto_auth_reconnect_title: "Reconnect to Ponto",
    ponto_auth_expired_title: "Ponto authorization expired",
    ponto_auth_bank_required_title: "Reconnect bank account",
    ponto_auth_in_progress_title: "Authorization in progress",
    // Ponto: auth dialog bodies
    ponto_auth_no_integration_body:
      "Click Authorize to connect bank account :accountId to Ponto.",
    ponto_auth_reconnect_body:
      "The Ponto connection has been lost. Click Authorize to grant access again to bank account :accountId.",
    ponto_auth_expired_body:
      "The Ponto authorization has expired. Click Authorize to grant access again to bank account :accountId.",
    ponto_auth_bank_required_body:
      "Casadesk has access to Ponto but no longer to bank account :accountId. Click Authorize to reconnect the bank account.",
    ponto_auth_in_progress_body:
      "Authorization for the bank account has already been started by another user. Click Close to wait for the ongoing authorization, or click Restart to start over.",
    ponto_reauth_connect_error:
      "Unable to connect to your bank. Please try again or contact support.",
    // Ponto: error dialog titles
    ponto_connection_failed_title: "Authorization failed",
    bank_connection_failed_title: "Authorization: bank account not found",
    ponto_oauth_error_title: "Authorization: unexpected error",
    bank_account_not_found_title: "Synchronization: bank account not found",
    financial_operations_were_blocked_title: "Synchronization: financial processing in progress",
    be_ajv_not_validated_title: "Invalid request",
    no_ponto_integration_title: "No active Ponto connection",
    ponto_unexpected_error_title: "Unexpected error",
    // Ponto: error dialog bodies
    ponto_connection_failed_body:
      "Authorization failed. Click Close and try again.",
    bank_connection_failed_body:
      "Authorization with Ponto succeeded, but permission for :accountId was not found. Click Sync and grant access to :accountId.",
    ponto_oauth_error_body:
      "An unexpected error occurred with Ponto. Click Authorize to try again.",
    bank_account_not_found_body:
      "Bank account :accountId was not found. Please contact support.",
    financial_operations_were_blocked_body:
      "Synchronization is not possible because financial data is being updated. Please try again later.",
    be_ajv_not_validated_body:
      "The request could not be processed. Please contact support.",
    no_ponto_integration_body:
      "No active Ponto connection was found. Refresh the page and try again.",
    ponto_unexpected_error_body:
      "An unexpected error occurred. Please try again.",
    "dialog-new-notification-title": "New notification",
    "dialog-new-notification-text": "Notification text",
    "notification-done": "Done",
    "default-error-message":
      "An unexpected error occurred. The Casadesk team is informed.",
    "button/show-keys": "Show keys",
    "button/show-translations": "Show translations",

// coach new bill settlement
  "coach/new-bill-settlement/action-buttons/cancel": "Cancel",
  "coach/new-bill-settlement/action-buttons/back": "Back",
  "coach/new-bill-settlement/action-buttons/next": "Next",
  "coach/new-bill-settlement/action-buttons/finish": "Finish",
  
    // address
    "coach/new-bill-settlement/steps/address/title": "Address",
    "coach/new-bill-settlement/steps/address/property-lookup-label": "This settlement is for the following address:",
    "coach/new-bill-settlement/steps/address/property-lookup-input-floating-label": "Search for an address",

    // bill
    "coach/new-bill-settlement/steps/bill/title":"Bill",
    "coach/new-bill-settlement/steps/bill/section-one/title":"Details of the final bill to settle with the tenant(s)",

    "coach/new-bill-settlement/steps/unit/section-one/company/label": "Billing company",
    "coach/new-bill-settlement/steps/bill/section-one/charge-type-for-landlord/label": "Bill type:",
    "coach/new-bill-settlement/steps/bill/section-one/charge-type-for-tenant/label": "Charge type for tenant:",
    "coach/new-bill-settlement/steps/bill/section-one/total-amount/label": "Bill amount:",
    "coach/new-bill-settlement/steps/bill/section-one/description/label": "Description:",
    "coach/new-bill-settlement/steps/bill/section-one/description/default": "Final bill for period",
    "coach/new-bill-settlement/steps/bill/section-one/paid-amount/label": "Already paid (deposited):",
    "coach/new-bill-settlement/steps/bill/landlord-section/title": "Landlord’s administration fee",
    "coach/new-bill-settlement/steps/bill/landlord-section/percentage-fee/label": "Percentage",
    "coach/new-bill-settlement/steps/bill/documents/title": "Make the following documents available for the tenant(s)",
    "coach/new-bill-settlement/steps/bill/documents/upload": "Upload documents",

    // unit
    "coach/new-bill-settlement/steps/unit/title":"Unit",
    "coach/new-bill-settlement/steps/unit/section-one/title":"The final bill",
    "coach/new-bill-settlement/steps/unit/section-one/table/utility-bill/label":"Bill is about",
    "coach/new-bill-settlement/steps/unit/section-one/table/bill-period/label": "Bill period",
    "coach/new-bill-settlement/steps/unit/section-one/table/total-bill-amount/label": "Bill amount",
    "coach/new-bill-settlement/steps/unit/section-one/table/administration-fee/label": "Administration fee landlord",
    "coach/new-bill-settlement/steps/unit/section-one/table/total-settled-amount/label": "Total to settle",
    "coach/new-bill-settlement/steps/unit/section-one/table/monthly/label": "Monthly payment",
    "coach/new-bill-settlement/steps/unit/section-one/table/bill-period/difference/years": "Years",
    "coach/new-bill-settlement/steps/unit/section-one/table/bill-period/difference/months":"Months",
    "coach/new-bill-settlement/steps/unit/section-one/table/bill-period/difference/days":"Days",
    "coach/new-bill-settlement/steps/unit/section-two/title": "Distribution among the rental properties",
    "coach/new-bill-settlement/steps/unit/section-two/unit-number": "Unit",
    "coach/new-bill-settlement/steps/unit/section-two/one-unit-only-message": "The address has only one unit. Thus the total amount to settle does not have to be distributed over several units.",
    "coach/new-bill-settlement/steps/unit/section-two/distribution-key/label": "Distribution Key",
    "coach/new-bill-settlement/steps/unit/section-two/hint": "Determine the distribution by entering a number 0-100 for each unit",

    // tenant
    "coach/new-bill-settlement/steps/tenant/title":"Tenant",
    "coach/new-bill-settlement/steps/tenant/section-two/title": "Distribution over the tenants",
    "coach/new-bill-settlement/steps/tenant/section-two/no-contracts-found":"No Contract Found",
    "coach/new-bill-settlement/steps/tenant/section-two/distributed-amount-by-unit":"Distributed:",
    "coach/new-bill-settlement/steps/tenant/section-two/expected-amount-by-unit":"To pay:",
    "coach/new-bill-settlement/steps/tenant/section-two/paid-amount-by-unit":"Deposits:",
    "coach/new-bill-settlement/steps/tenant/section-two/remaining-amount-by-unit":"Difference:",
    "coach/new-bill-settlement/steps/tenant/section-two/accordion/details/contract/label":"Contract Id:",
    "coach/new-bill-settlement/steps/tenant/tenants/header/unit": "Unit",
    "coach/new-bill-settlement/steps/tenant/tenants/header/tenant": "Tenant",
    "coach/new-bill-settlement/steps/tenant/tenants/header/contract": "Contract",
    "coach/new-bill-settlement/steps/tenant/tenants/header/to-pay": "To pay",
    "coach/new-bill-settlement/steps/tenant/section-two/hint": "Based on the contract period(s) the total amount to settle is pro rata assigned to the tenant(s)",

    // finish
    "coach/new-bill-settlement/steps/finish/title":"Finish",
    "coach/new-bill-settlement/steps/finish/tenants/title": "Remains to settle with the tenants",
    "coach/new-bill-settlement/steps/finish/tenants/header/unit": "Unit",
    "coach/new-bill-settlement/steps/finish/tenants/header/tenant": "Tenant",
    "coach/new-bill-settlement/steps/finish/tenants/header/to-pay": "To pay",
    "coach/new-bill-settlement/steps/finish/tenants/header/deposited": "Deposited",
    "coach/new-bill-settlement/steps/finish/tenants/header/remains-to-settle": "Remains",

    // errors
    "coach/new-bill-settlement/steps/address/errors/property-missing": "Property is required",
    "coach/new-bill-settlement/steps/bill/section-one/company/error/company-missing": "Company is required",
    "coach/new-bill-settlement/steps/bill/section-one/utility-bill-type/error/charge-type-for-landlord-missing": "Select a bill type",
    "coach/new-bill-settlement/steps/bill/section-one/utility-bill-type/error/charge-type-for-tenant-missing": "Select a charge type",
    "coach/new-bill-settlement/steps/bill/section-one/end-date/error/end-date-missing" : "End date is required",
    "coach/new-bill-settlement/steps/bill/section-one/end-date/error/end-date-in-future": "End date cannot be in the future",
    "coach/new-bill-settlement/steps/bill/section-one/end-date/error/end-date-before-start": "End date cannot be before start date",
    "coach/new-bill-settlement/steps/bill/section-one/first-date/error/first-date-missing": "First date is required",
    "coach/new-bill-settlement/steps/bill/section-one/first-date/error/first-date-in-future": "First date cannot be in the future",
    "coach/new-bill-settlement/steps/bill/section-one/first-date/error/first-date-too-early": "First date should be in this century",
    "coach/new-bill-settlement/steps/bill/section-one/bill-period/error/bill-period-too-long": "Bill period is too long",
    "coach/new-bill-settlement/steps/bill/section-one/total-amount/error/total-amount-missing": "Total amount is required",
    "coach/new-bill-settlement/steps/bill/section-one/total-amount/error/total-amount-negative": "Total amount cannot be negative",
    "coach/new-bill-settlement/steps/bill/section-one/total-amount/error/total-amount-too-high": "Total amount is too high",
    "coach/new-bill-settlement/steps/bill/section-one/paid-amount/error/paid-amount-missing": "Paid amount is required",
    "coach/new-bill-settlement/steps/bill/section-one/paid-amount/error/paid-amount-negative": "Paid amount cannot be negative",
    "coach/new-bill-settlement/steps/bill/landlord-section/percentage-fee/error/percentage-fee-missing": "Percentage fee is required",
    "coach/new-bill-settlement/steps/bill/landlord-section/percentage-fee/error/not-in-range": "Percentage fee should be between 0 and 100",
    "coach/new-bill-settlement/steps/unit/section-two/distribution-key/error/not-set": "At least one distribution key should be set",
    "coach/new-bill-settlement/steps/unit/section-two/distribution-key/error/not-in-range": "Every distribution key should be between 0 and 100",  

    // process
    "process/create-charges-for-contracts":"Start production charges for contracts",
    "process/mail-charges-without-owner-statement":"Send email with charges missing an owner statement",

    //! fixes
    //"settled_bill_receivable": "[MISSING TRANSLATION] settled_bill_receivable",
    //"settled_bill_payable": "[MISSING TRANSLATION] settled_bill_payable",
    
    // XLSX Sheets
    "sheets-date": "Date",
    "sheets-type": "Type",
    "sheets-object": "Object",
    "sheets-counterpart": "Counterparty",
    "sheets-description": "Description",
    "sheets-amount-receivable": "Receivable",
    "sheets-amount-payable": "Payable"
  };

  public get(key) {
    key = key ? key : "default-error-message";
    return this.language[key];
  };
};

export { English };
